webpackJsonp([1],Array(19).concat([
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  COUNTRIES: [{
    'name': 'Kenya',
    'code': 'KE'
  }, {
    'name': 'Tanzania',
    'code': 'TZ'
  }, {
    'name': 'Uganda',
    'code': 'UG'
  }, {
    'name': 'Zambia',
    'code': 'ZM'
  }, {
    'name': 'Zimbabwe',
    'code': 'ZW'
  }, {
    'name': 'Ghana',
    'code': 'GH'
  }, {
    'name': 'Nigeria',
    'code': 'NG'
  }, {
    'name': 'Mozambique',
    'code': 'MZ'
  }, {
    'name': 'Egypt',
    'code': 'EG'
  }, {
    'name': 'Angola',
    'code': 'AO'
  }, {
    'name': 'Botswana',
    'code': 'BW'
  }, {
    'name': 'Burkina Faso',
    'code': 'BF'
  }, {
    'name': 'Burundi',
    'code': 'BI'
  }, {
    'name': 'South Africa',
    'code': 'ZA'
  }, {
    'name': 'Senegal',
    'code': 'SN'
  }, {
    'name': 'Morocco',
    'code': 'MA'
  }, {
    'name': 'Ethiopia',
    'code': 'ET'
  }, {
    'name': "Cote d'Ivoire",
    'code': 'CI'
  }, {
    'name': 'Tunisia',
    'code': 'TN'
  }, {
    'name': 'Sudan',
    'code': 'SD'
  }, {
    'name': 'Guinea Conakry',
    'code': 'GN'
  }, {
    'name': 'Algeria',
    'code': 'DZ'
  }, {
    'name': 'Malawi',
    'code': 'MW'
  }, {
    'name': 'South Sudan',
    'code': 'SS'
  }],
  CURRENCIES: {
    'KE': {
      'name': 'KES',
      'code': 'KES'
    },
    'TZ': {
      'name': 'TZS',
      'code': 'TZS'
    },
    'UG': {
      'name': 'UGX',
      'code': 'UGX'
    },
    'ZW': {
      'name': 'USD',
      'code': 'USD'
    },
    'ZM': {
      'name': 'ZMW',
      'code': 'ZMW'
    },
    'GH': {
      'name': 'GHS',
      'code': 'GHS'
    },
    'NG': {
      'name': 'NGN',
      'code': 'NGN'
    },
    'MZ': {
      'name': 'MZN',
      'code': 'MZN'
    },
    'EG': {
      'name': 'EGP',
      'code': 'EGP'
    },
    'AO': {
      'name': 'AOA',
      'code': 'AOA'
    },
    'BW': {
      'name': 'BWP',
      'code': 'BWP'
    },
    'BF': {
      'name': 'XOF',
      'code': 'XOF'
    },
    'BI': {
      'name': 'BIF',
      'code': 'BIF'
    },
    'ZA': {
      'name': 'ZAR',
      'code': 'ZAR'
    },
    'SN': {
      'name': 'XOF',
      'code': 'XOF'
    },
    'MA': {
      'name': 'MAD',
      'code': 'MAD'
    },
    'ET': {
      'name': 'ETB',
      'code': 'ETB'
    },
    'CI': {
      'name': 'XOF',
      'code': 'XOF'
    },
    'TN': {
      'name': 'TND',
      'code': 'TND'
    },
    'GN': {
      'name': 'GNF',
      'code': 'GNF'
    },
    'SD': {
      'name': 'SDG',
      'code': 'SDG'
    },
    'DZ': {
      'name': 'DZD',
      'code': 'DZD'
    },
    'ML': {
      'name': 'XOF',
      'code': 'XOF'
    },
    'MW': {
      'name': 'MWK',
      'code': 'MWK'
    },
    'Global': {
      'name': 'USD',
      'code': 'USD'
    }
  },
  ENGINE_PROXY_URL: 'https://developer.tingg.africa/checkout/v2/portal-proxy/api/engine/',
  PAYMENT_WEBHOOK_URL: 'https://developer.tingg.africa/checkout/v2/portal-proxy/api/webhook/callback',
  EXPRESS_CALLBACK_URL: 'https://developer.tingg.africa/checkout/v2/portal-proxy/api/express/callback',
  ERROR_MESSAGES: {
    7: 'Whoops! Something wring happened. <br> Please try again',
    53: 'Seems like you already have an account <br> with the same email address'
  },
  LOGO_URLS: {
    KE: 'https://beep2.cellulant.africa:9001/hub/admin/images/logos/med96',
    TZ: 'https://beep2.cellulant.africa:9001/hub/admin/images/logos/med96',
    UG: 'https://beep2.cellulant.africa:9001/hub/admin/images/logos/med96'
  },
  SESSION_EXPIRY_TIME: 1 / 24
});

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Shell_vue__ = __webpack_require__(272);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ead5697_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Shell_vue__ = __webpack_require__(461);
function injectStyle (ssrContext) {
  __webpack_require__(457)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ead5697"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Shell_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ead5697_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Shell_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_API__ = __webpack_require__(33);





var Auth = function () {
  function Auth() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Auth);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Auth, [{
    key: 'attemptSignIn',
    value: function attemptSignIn(_ref) {
      var email = _ref.email,
          password = _ref.password;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__utilities_API__["a" /* default */].post({ url: 'login', data: { 'emailAddress': email, 'password': password } }).then(function (response) {
          if (response.SUCCESS) {
            resolve(response);
          } else {
            reject(response);
          }
        }).catch(function (response) {
          reject(response);
        });
      });
    }
  }, {
    key: 'attemptToSetPassword',
    value: function attemptToSetPassword(_ref2) {
      var password = _ref2.password,
          token = _ref2.token;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__utilities_API__["a" /* default */].post({ url: 'setPassword', data: { password: password, 'verificationToken': token } }).then(function (response) {
          if (response.SUCCESS) {
            resolve(response);
          } else {
            reject(response);
          }
        }).catch(function (response) {
          reject(response);
        });
      });
    }
  }, {
    key: 'attemptToVerifyAccount',
    value: function attemptToVerifyAccount(_ref3) {
      var token = _ref3.token;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__utilities_API__["a" /* default */].post({ url: 'verifyAccount', data: { verificationToken: token } }).then(function (response) {
          if (response.SUCCESS) {
            resolve(response);
          } else {
            reject(response);
          }
        }).catch(function (response) {
          reject(response);
        });
      });
    }
  }, {
    key: 'requestPasswordReset',
    value: function requestPasswordReset(_ref4) {
      var email = _ref4.email;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__utilities_API__["a" /* default */].post({ url: 'requestPasswordReset', data: { 'emailAddress': email } }).then(function (response) {
          if (response.SUCCESS) {
            return resolve(response);
          } else {
            return reject(response);
          }
        }).catch(function (response) {
          return reject(response);
        });
      });
    }
  }, {
    key: 'resetPassword',
    value: function resetPassword(_ref5) {
      var token = _ref5.token,
          password = _ref5.password;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__utilities_API__["a" /* default */].post({ url: 'setPassword', data: { 'verificationToken': token, password: password } }).then(function (response) {
          if (response.SUCCESS) {
            return resolve(response);
          } else {
            return reject(response);
          }
        }).catch(function (response) {
          return reject(response);
        });
      });
    }
  }, {
    key: 'verifyAccount',
    value: function verifyAccount(_ref6) {
      var token = _ref6.token;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__utilities_API__["a" /* default */].post({ url: 'verifyAccount', data: { token: token } }).then(function (response) {
          if (response.SUCCESS) {
            resolve(response);
          } else {
            reject(response);
          }
        }).catch(function (response) {
          reject(response);
        });
      });
    }
  }]);

  return Auth;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Auth());

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_config__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_utilities_Session__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(110);




// import { logout } from '../middlewares/auth'







var API = function () {
  function API() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, API);

    // Set the default headers for the post call.
    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.common['Authorization'] = API.getAuthToken();
    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.post['Content-Type'] = 'application/json';
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(API, [{
    key: 'refresh',
    value: function refresh() {
      // Set the default headers for the post call.
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.common['Authorization'] = API.getAuthToken();
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.post['Content-Type'] = 'application/json';
      return this;
    }
  }, {
    key: 'post',
    value: function post(_ref) {
      var url = _ref.url,
          data = _ref.data;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_6__api_config__["a" /* default */].ENGINE_PROXY_URL + url, data).then(function (response) {
          if (response.data.SUCCESS) {
            resolve(response.data);
          }
          reject(response.data);
        }).catch(function (error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            if (error.response.status === 401) {
              __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].dispatch('auth/logout');
              __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].push('/login');
            }
          } else if (error.request) {
            /* The request was made but no response was received */
          } else {
              /* Something happened in setting up the request that triggered an Error */
            }
          reject(error.response.data);
        });
      });
    }
  }], [{
    key: 'getAuthToken',
    value: function getAuthToken() {
      if (__WEBPACK_IMPORTED_MODULE_8__api_utilities_Session__["a" /* default */].has('token')) {
        return 'Bearer ' + __WEBPACK_IMPORTED_MODULE_8__api_utilities_Session__["a" /* default */].get('token');
      }
      return '';
    }
  }, {
    key: 'store',
    value: function store() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('auth', ['logout']));
    }
  }]);

  return API;
}();

/* harmony default export */ __webpack_exports__["a"] = (new API());

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(273);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4627535c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(460);
function injectStyle (ssrContext) {
  __webpack_require__(459)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4627535c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Group_vue__ = __webpack_require__(271);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06670ff4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Group_vue__ = __webpack_require__(456);
function injectStyle (ssrContext) {
  __webpack_require__(455)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06670ff4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie__);





var logUtility = !!("development" !== 'production');

var Session = function () {
  /**
   * Constructor a session instance
   *
   * @param attributes
   */
  function Session(_ref) {
    var expires = _ref.expires;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Session);

    this._attributes = {};
    this._attributes[expires] = expires === null || expires === undefined ? 1 / 24 : expires;
    this._cookies = __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a;
  }

  /**
   * Check if session has a specific key.
   *
   * @return boolean
   */


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Session, [{
    key: 'has',
    value: function has(name) {
      logUtility && console.log('Checking if ' + name + ' is present => ' + (this.get(name) !== undefined && this.get(name) !== null));
      return this.get(name) !== undefined && this.get(name) !== null;
    }

    /**
     * Retrieve a cookie value
     *
     * @param name
     * @returns {*}
     */

  }, {
    key: 'get',
    value: function get(name) {
      logUtility && console.log('Retrieving the value for => ' + name + ' => ' + this._cookies.get(name));
      return this._cookies.get(name);
    }

    /**
     * Remove a cookie
     *
     * @param name
     */

  }, {
    key: 'remove',
    value: function remove(name) {
      logUtility && console.log('Removing the value ' + name);
      this._cookies.remove(name, this._attributes);
    }

    /**
     * Set a cookie
     *
     * @param name
     * @param value
     */

  }, {
    key: 'set',
    value: function set(name, value) {
      logUtility && console.log('Setting ' + name + ' => ' + value);
      this._cookies.set(name, value, this._attributes);
    }
  }]);

  return Session;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Session({ expires: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].SESSION_EXPIRY_TIME }));

/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_API__ = __webpack_require__(33);



// import _ from 'lodash'


var Service = function () {
  function Service() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Service);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Service, null, [{
    key: 'create',
    value: function create(_ref) {
      var payload = _ref.payload;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__utilities_API__["a" /* default */].refresh().post({ url: 'createServicePaymentOption', data: payload }).then(function (response) {
          if (response.SUCCESS) {
            resolve(response);
          } else {
            reject(response);
          }
        }).catch(function (response) {
          reject(response);
        });
      });
    }
  }, {
    key: 'update',
    value: function update(_ref2) {
      var payload = _ref2.payload;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__utilities_API__["a" /* default */].refresh().post({ url: 'createServicePaymentOption', data: payload }).then(function (response) {
          if (response.SUCCESS) {
            resolve(response);
          } else {
            reject(response);
          }
        }).catch(function (response) {
          reject(response);
        });
      });
    }
  }, {
    key: 'updateService',
    value: function updateService(_ref3) {
      var service = _ref3.service;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__utilities_API__["a" /* default */].refresh().post({ url: 'updateService', data: service }).then(function (response) {
          if (response.SUCCESS) {
            resolve(response);
          } else {
            reject(response);
          }
        }).catch(function (response) {
          reject(response);
        });
      });
    }
  }]);

  return Service;
}();

/* harmony default export */ __webpack_exports__["a"] = (Service);

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTable_vue__ = __webpack_require__(285);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb782544_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataTable_vue__ = __webpack_require__(496);
function injectStyle (ssrContext) {
  __webpack_require__(490)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb782544_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_API__ = __webpack_require__(33);






var STATUSES = {
  0: 'DEACTIVATED',
  1: 'ACTIVE',
  2: 'INVITED'
};

var User = function () {
  function User() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, User);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(User, [{
    key: '_retrieveRole',
    value: function _retrieveRole(roleId, roles) {
      var finalRole = {};
      __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.forIn(roles, function (role) {
        if (roleId === role.userRoleID) {
          finalRole = role;
        }
      });
      return finalRole;
    }
  }, {
    key: '_retrieveRoleUsingCode',
    value: function _retrieveRoleUsingCode(roleCode, roles) {
      var finalRole = {};
      __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.forIn(roles, function (role) {
        if (role.roleCode === roleCode) {
          finalRole = role;
        }
      });
      return finalRole;
    }
  }, {
    key: '_retrieveStatus',
    value: function _retrieveStatus(status) {
      return STATUSES[status];
    }
  }, {
    key: 'activateUser',
    value: function activateUser(_ref) {
      var user = _ref.user;

      user.userActive = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.invert(STATUSES)['ACTIVE'];
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5__utilities_API__["a" /* default */].refresh().post({ url: 'updateUser', data: user }).then(function (response) {
          if (response.SUCCESS) {
            resolve(response);
          } else {
            reject(response);
          }
        }).catch(function (response) {
          reject(response);
        });
      });
    }
  }, {
    key: 'create',
    value: function create(data) {
      // Submit request
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5__utilities_API__["a" /* default */].post({ url: 'saveSignUpRequest', data: data }).then(function (response) {
          if (response.SUCCESS) {
            resolve(response);
          }
          reject(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }
  }, {
    key: 'deactivateUser',
    value: function deactivateUser(_ref2) {
      var user = _ref2.user;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5__utilities_API__["a" /* default */].refresh().post({ url: 'updateUser', data: user }).then(function (response) {
          if (response.SUCCESS) {
            resolve(response);
          } else {
            reject(response);
          }
        }).catch(function (response) {
          reject(response);
        });
      });
    }
  }, {
    key: 'fetchClientUsers',
    value: function fetchClientUsers(_ref3) {
      var _this = this;

      var clientCode = _ref3.clientCode;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5__utilities_API__["a" /* default */].refresh().post({ url: 'fetchClientUsers', data: { clientCode: clientCode } }).then(function (response) {
          if (response.SUCCESS) {
            // Clean up the user data
            var data = { roles: {}, users: [] };
            response.DATA.users.forEach(function (user) {
              data.users.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
                name: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.capitalize(user.firstName) + ' ' + __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.capitalize(user.lastName)
              }, __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.pick(user, ['emailAddress', 'userActive', 'userID']), {
                fullName: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.capitalize(user.firstName) + ' ' + __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.capitalize(user.lastName),
                role: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.capitalize(_this._retrieveRole(user.userRoleID, response.DATA.userRoles).roleName),
                status: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.capitalize(_this._retrieveStatus(user.userActive)),
                date: user.dateCreated
              }));
            });
            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.forIn(response.DATA.userRoles, function (role, key) {
              role.roleName = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.capitalize(role.roleName);
              data.roles[role.userRoleID] = role;
            });
            resolve(data);
          }
          reject(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }
  }, {
    key: 'inviteUser',
    value: function inviteUser(_ref4) {
      var user = _ref4.user;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5__utilities_API__["a" /* default */].refresh().post({ url: 'createUser', data: user }).then(function (response) {
          if (response.SUCCESS) {
            resolve(response);
          }
          reject(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }
  }, {
    key: 'updateUserProfile',
    value: function updateUserProfile(_ref5) {
      var user = _ref5.user;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5__utilities_API__["a" /* default */].refresh().post({ url: 'updateUser', data: user }).then(function (response) {
          if (response.SUCCESS) {
            resolve(response);
          } else {
            reject(response);
          }
        }).catch(function (response) {
          reject(response);
        });
      });
    }
  }, {
    key: 'updateClient',
    value: function updateClient(_ref6) {
      var client = _ref6.client;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5__utilities_API__["a" /* default */].refresh().post({ url: 'updateClient', data: client }).then(function (response) {
          if (response.SUCCESS) {
            resolve(response);
          } else {
            reject(response);
          }
        }).catch(function (response) {
          reject(response);
        });
      });
    }
  }]);

  return User;
}();

/* harmony default export */ __webpack_exports__["a"] = (new User());

/***/ }),
/* 106 */,
/* 107 */,
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({ name: 'app' });

/***/ }),
/* 109 */,
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_auth__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_user__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_services__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_dist_logger__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_dist_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_registration__ = __webpack_require__(398);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "development" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    auth: __WEBPACK_IMPORTED_MODULE_2__modules_auth__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_3__modules_user__["a" /* default */],
    services: __WEBPACK_IMPORTED_MODULE_4__modules_services__["b" /* default */],
    registration: __WEBPACK_IMPORTED_MODULE_6__modules_registration__["a" /* default */]
  },
  strict: debug,
  plugins: debug ? [__WEBPACK_IMPORTED_MODULE_5_vuex_dist_logger___default()()] : []
}));

/***/ }),
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ADD_SERVICE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_CURRENT_SERVICE; });
/* unused harmony export PERSIST_SERVICES */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);




var _mutations;



var ADD_SERVICE = 'ADD_SERVICE';
var SET_CURRENT_SERVICE = 'SET_CURRENT_SERVICE';
var PERSIST_SERVICES = 'PERSIST_SERVICES';

// Initial state
var state = {
  services: JSON.parse(localStorage.getItem('services')) === null ? {} : JSON.parse(localStorage.getItem('services'))

  // Getters
};var getters = {
  allServices: function allServices(state) {
    var services = [];
    __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forIn(state.services.serviceDetails, function (value, key) {
      services.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
        serviceCode: key
      }, value));
    });
    return services;
  },
  currentService: function currentService(state, getters) {
    var currentServiceCode = localStorage.getItem('current_service');

    console.log('Did the user already preselect a service?', !!currentServiceCode);

    if (currentServiceCode === null || state.services.serviceDetails[currentServiceCode] === undefined) {
      if (getters.allServices.length > 0) {
        var currentService = getters.allServices[0];
        localStorage.setItem('current_service', currentService.serviceCode);
        return currentService;
      }

      return {};
    }

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
      serviceCode: currentServiceCode
    }, state.services.serviceDetails[currentServiceCode]);
  }

  // Mutations
};var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, ADD_SERVICE, function (state, service) {
  state.services.serviceDetails = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state.services.serviceDetails, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, service.serviceCode, {
    serviceName: service.serviceName,
    serviceID: service.serviceID,
    active: '1'
  }));

  localStorage.setItem('services', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.services));
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, SET_CURRENT_SERVICE, function (state, service) {
  localStorage.setItem('current_service', service.serviceCode);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, PERSIST_SERVICES, function (state, services) {
  state.services = services;
}), _mutations);

// Actions
var actions = {
  addService: function addService(_ref, service) {
    var commit = _ref.commit;

    commit(ADD_SERVICE, service);
    commit(SET_CURRENT_SERVICE, service);
  },
  saveServices: function saveServices(_ref2, services) {
    var commit = _ref2.commit;

    localStorage.setItem('services', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(services));
    commit(PERSIST_SERVICES, services);
  },
  updateService: function updateService(_ref3, service) {
    var dispatch = _ref3.dispatch;

    dispatch('addService', service);
  }
};

/* harmony default export */ __webpack_exports__["b"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Activate__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_CreateService__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Documentation__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Home__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Login__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_NotFoundComponent__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Payments__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_PaymentOptions__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Profile__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_utilities_Session__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_SetPassword__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_RecoverPassword__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_ResetPassword__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_RegisterUser__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_RegisterBusiness__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_RegisterComplete__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_Visits__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_Users__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash__);






















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  // mode: 'history',
  routes: [{
    path: '/',
    redirect: '/login'
  }, {
    path: '/activate/:token',
    name: 'Activate',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Activate__["a" /* default */],
    meta: {
      requiresGuest: true
    }
  }, {
    path: '/set/password/:token',
    name: 'SetPassword',
    component: __WEBPACK_IMPORTED_MODULE_12__views_SetPassword__["a" /* default */],
    meta: {
      requiresGuest: true
    }
  }, {
    path: '/documentation',
    name: 'Documentation',
    component: __WEBPACK_IMPORTED_MODULE_4__views_Documentation__["a" /* default */],
    meta: {
      requiresAuth: true,
      requiresService: true
    }
  }, {
    path: '/home',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_5__views_Home__["a" /* default */],
    meta: {
      requiresAuth: true,
      requiresService: true
    }
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_6__views_Login__["a" /* default */],
    meta: {
      requiresGuest: true
    }
  }, {
    path: '/payments',
    name: 'Payments',
    component: __WEBPACK_IMPORTED_MODULE_8__views_Payments__["a" /* default */],
    meta: {
      requiresAuth: true,
      requiresService: true
    }
  }, {
    path: '/payment/options',
    name: 'PaymentOptions',
    component: __WEBPACK_IMPORTED_MODULE_9__views_PaymentOptions__["a" /* default */],
    meta: {
      requiresAuth: true,
      requiresService: true
    }
  }, {
    path: '/profile',
    name: 'Profile',
    component: __WEBPACK_IMPORTED_MODULE_10__views_Profile__["a" /* default */],
    meta: {
      requiresAuth: true,
      requiresService: true
    }
  }, {
    path: '/register/user',
    name: 'RegisterUser',
    component: __WEBPACK_IMPORTED_MODULE_15__views_RegisterUser__["a" /* default */],
    meta: {
      requiresGuest: true
    }
  }, {
    path: '/register/business',
    name: 'RegisterBusiness',
    component: __WEBPACK_IMPORTED_MODULE_16__views_RegisterBusiness__["a" /* default */],
    meta: {
      requiresGuest: true
    }
  }, {
    path: '/register/complete',
    name: 'RegisterComplete',
    component: __WEBPACK_IMPORTED_MODULE_17__views_RegisterComplete__["a" /* default */],
    meta: {
      requiresGuest: true
    }
  }, {
    path: '/recover/password',
    name: 'RecoverPassword',
    component: __WEBPACK_IMPORTED_MODULE_13__views_RecoverPassword__["a" /* default */],
    meta: {
      requiresGuest: true
    }
  }, {
    path: '/reset/password/:token',
    name: 'ResetPassword',
    component: __WEBPACK_IMPORTED_MODULE_14__views_ResetPassword__["a" /* default */],
    meta: {
      requiresGuest: true
    }
  }, {
    path: '/visits',
    name: 'Visits',
    component: __WEBPACK_IMPORTED_MODULE_18__views_Visits__["a" /* default */],
    meta: {
      requiresAuth: true,
      requiresService: true
    }
  }, {
    path: '/create/service',
    name: 'CreateService',
    component: __WEBPACK_IMPORTED_MODULE_3__views_CreateService__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/users',
    name: 'Users',
    component: __WEBPACK_IMPORTED_MODULE_19__views_Users__["a" /* default */],
    meta: {
      requiresAuth: true,
      requiresService: true
    }
  }, {
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_7__views_NotFoundComponent__["a" /* default */]
  }]
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    if (!__WEBPACK_IMPORTED_MODULE_11__api_utilities_Session__["a" /* default */].has('token')) {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      // Fetch the user information to feed to our user event trackers.
      var user = JSON.parse(localStorage.getItem('user'));
      // Identify a user on fresh chat
      // To set unique user id in your system when it is available
      window.fcWidget.setExternalId(user.emailAddress);
      // Set the user's basic information
      window.fcWidget.user.setFirstName(user.firstName + ' ' + user.lastName);
      window.fcWidget.user.setEmail(user.emailAddress);
      // To set user additional properties
      window.fcWidget.user.setProperties({
        clientCode: user.clientCode,
        clientName: user.clientName
      });

      // Identify a user on full story
      window.FS.identify(user.emailAddress, {
        displayName: user.firstName + ' ' + user.lastName,
        email: user.emailAddress,
        client: user.clientCode
      });

      if (to.matched.some(function (record) {
        return record.meta.requiresService;
      })) {
        var services = JSON.parse(localStorage.getItem('services')) === null ? {} : JSON.parse(localStorage.getItem('services'));
        if (services.serviceDetails === undefined || __WEBPACK_IMPORTED_MODULE_20_lodash___default.a.keys(services.serviceDetails).length < 1) {
          next({
            path: '/create/service',
            query: {
              redirect: to.fullPath
            }
          });
        } else {
          next();
        }
      } else {
        next();
      }
    }
  } else if (to.matched.some(function (record) {
    return record.meta.requiresGuest;
  })) {
    if (__WEBPACK_IMPORTED_MODULE_11__api_utilities_Session__["a" /* default */].has('token')) {
      next({
        path: '/home',
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_services_auth_js__ = __webpack_require__(32);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***
 * Activate view
 *
 * Possible statuses: ['pending', 'failed', 'successful']
 */




var logInfo = !!("development" !== 'production');

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      status: 'pending'
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('auth', ['login']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('services', ['saveServices']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('user', ['saveUserInformation', 'saveUserKeys']), {
    verifyAccount: function verifyAccount() {
      var _this = this;

      // Set the page to a pending state waiting for the response from the checkout engine
      this.status = 'pending';

      __WEBPACK_IMPORTED_MODULE_3__api_services_auth_js__["a" /* default */].attemptToVerifyAccount({ token: this.$route.params.token }).then(function (response) {
        logInfo && console.log('User was successfully verified', response);
        // Set the status to a success status
        _this.status = 'success';
        // Persist the user's token
        _this.login(response.DATA.authorizationToken);

        // Persist the user's information, services and keys
        _this.saveServices(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(response.DATA, ['serviceDetails']));
        _this.saveUserKeys(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(response.DATA, ['clientAccessKeys', 'oauthKeyDetails']));
        _this.saveUserInformation(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.omit(response.DATA, ['authorizationToken', 'clientAccessKeys', 'oauthKeyDetails', 'serviceDetails']));
      }).catch(function (response) {
        logInfo && console.log('User was not verified', response);
        // Set the status to a failed status
        _this.status = 'failed';
      });
    }
  }),
  mounted: function mounted() {
    this.verifyAccount();
  },

  name: 'Activate'
});

/***/ }),
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Button__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_config__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Group__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Shell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Step__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_services_service__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_PaymentOptionManager__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_services_paymentOption__ = __webpack_require__(277);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var logInfo = "development" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'ml-button': __WEBPACK_IMPORTED_MODULE_3__components_Button__["a" /* default */],
    'app-shell': __WEBPACK_IMPORTED_MODULE_6__components_Shell__["a" /* default */],
    'ml-group': __WEBPACK_IMPORTED_MODULE_5__components_Group__["a" /* default */],
    'ml-step': __WEBPACK_IMPORTED_MODULE_7__components_Step__["a" /* default */],
    'payment-option-manager': __WEBPACK_IMPORTED_MODULE_9__components_PaymentOptionManager__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('user', ['clientInfo']), {
    hasOtherServices: function hasOtherServices() {
      var services = JSON.parse(localStorage.getItem('services')) === null ? {} : JSON.parse(localStorage.getItem('services'));
      return !(services.serviceDetails === undefined || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.keys(services.serviceDetails).length < 1);
    },
    logoUrls: function logoUrls() {
      return __WEBPACK_IMPORTED_MODULE_4__api_config__["a" /* default */].LOGO_URLS;
    }
  }),

  data: function data() {
    return {
      service_name: '',
      options: [],
      selected_options: []
    };
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('auth', ['logout']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('services', ['addService']), {
    addPaymentOption: function addPaymentOption(option) {
      logInfo && console.log('Add the payment option =>', __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(option, ['countryPayerClientID', 'clientDisplayName', 'selectedPaymentModeID', 'countryName']));
      this.$set(option, 'optionEnabled', true);
      this.selected_options.push(option);
    },
    createService: function createService() {
      var _this = this;

      this.$btn.disable('button[type="submit"]');
      this.$validator.validateAll().then(function (result) {
        logInfo && console.log('Did the service parameters pass validation ?', result);
        if (result) {
          __WEBPACK_IMPORTED_MODULE_8__api_services_service__["a" /* default */].create({
            payload: {
              'serviceName': _this.service_name,
              'clientCode': _this.clientInfo.client_code,
              'options': _this.selected_options
            }
          }).then(function (response) {
            logInfo && console.log('Creation of a service was a success. Response =>', response);
            _this.addService(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(response.DATA, ['serviceName', 'serviceCode', 'serviceID']));
            _this.$btn.enable('button[type="submit"]');
            _this.$router.push('/home');
          }).catch(function (reason) {
            logInfo && console.log('Creation of a service failed. Reason =>', reason);
            _this.$btn.enable('button[type="submit"]');
          });
        }
      }).catch(function (reason) {
        logInfo && console.log('Validation of the parameters failed. Reason => ', reason);
      });
    },
    logoutUser: function logoutUser() {
      this.logout();
      this.$router.push('/login');
    },
    removePaymentOption: function removePaymentOption(option) {
      logInfo && console.log('Remove the payment option =>', __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(option, ['countryPayerClientID', 'clientDisplayName', 'selectedPaymentModeID', 'countryName']));
      this.$set(option, 'optionEnabled', false);
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.remove(this.selected_options, function (opt) {
        return opt.clientCode === option.clientCode;
      });
    },
    quitCreatingService: function quitCreatingService() {
      if (this.hasOtherServices) {
        this.$router.go(-1);
      } else {
        this.logoutUser();
      }
    },
    updatePaymentOption: function updatePaymentOption(option) {
      logInfo && console.log('Update the payment option =>', __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(option, ['countryPayerClientID', 'clientDisplayName', 'selectedPaymentModeID', 'countryName']));
      this.removePaymentOption(option);
      this.addPaymentOption(option);
    }
  }),

  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_10__api_services_paymentOption__["a" /* default */].all().then(function (paymentOptions) {
      logInfo && console.log('Successfully fetched the payment options: ', paymentOptions);
      _this2.options = paymentOptions;
    }).catch(function (reason) {
      logInfo && console.log('Failed to fetch the payment options: => ', reason);
    });
  },


  name: 'CreateService'
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    buttonClass: function buttonClass() {
      var classObj = {};
      classObj['ml-btn ml-btn--md ml-btn--' + this.mode] = true;
      return classObj;
    }
  },
  name: 'MlButton',
  props: {
    loading: {
      default: false
    },
    type: {
      default: 'button'
    },
    mode: {
      default: 'primary'
    }
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Group',
  props: {
    subtitle: {
      type: String,
      default: ''
    },
    title: {
      required: true
    }
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_dist_vue__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_dist_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_dist_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_timers__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_services_auth_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_modules_services__ = __webpack_require__(118);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var logInfo = !!("development" !== "production");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Shell",

  props: {
    breadcrumbs: {
      type: String
    },
    loading: {
      default: false,
      type: Boolean
    }
  },

  components: {
    modal: __WEBPACK_IMPORTED_MODULE_3__components_Modal__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])("services", ["currentService", "allServices"]), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])("user", ["userInfo"])),

  data: function data() {
    return {
      actions: [{
        name: "Reset",
        event: "reset-password"
      }],
      servicesNavState: false
    };
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])("auth", ["logout"]), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])("services", [__WEBPACK_IMPORTED_MODULE_6__store_modules_services__["a" /* SET_CURRENT_SERVICE */]]), {
    buildBreadcrumbs: function buildBreadcrumbs() {
      var res = __WEBPACK_IMPORTED_MODULE_1_vue_dist_vue___default.a.compile("<span style=\"font-size: 14px; display: flex; align-items: center;\">" + this.breadcrumbs.replace(new RegExp(",", "gi"), "&nbsp;&nbsp;/&nbsp;&nbsp;") + "</span>");

      new __WEBPACK_IMPORTED_MODULE_1_vue_dist_vue___default.a({
        render: res.render,
        staticRenderFns: res.staticRenderFns
      }).$mount("#breadcrumbs");
    },
    createService: function createService() {
      this.$router.push("/create/service");
    },
    triggerModal: function triggerModal() {
      this.$modal.show("reset-password");
    },
    requestPasswordReset: function requestPasswordReset() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_4__api_services_auth_js__["a" /* default */].requestPasswordReset({ email: this.userInfo.emailAddress }).then(function (response) {
        logInfo && console.log("The request to reset the password was successful", response);

        _this.$snackbar.open({
          message: "A reset password email has been successfully sent",
          type: "is-success",
          position: "is-bottom",
          queue: false
        });

        _this.$modal.hide("reset-password");

        Object(__WEBPACK_IMPORTED_MODULE_2_timers__["setTimeout"])(_this.logoutUser(), 3000);
      }).catch(function (response) {
        logInfo && console.log("The reset password request failed", response);
        _this.showError = true;
        _this.$btn.enable(".mula-btn");
      });
    },
    cancelPasswordReset: function cancelPasswordReset() {
      this.$modal.hide("reset-password");
    },
    toggleServicesNav: function toggleServicesNav() {
      this.servicesNavState = !this.servicesNavState;
    },
    logoutUser: function logoutUser() {
      this.logout();
      this.$router.push("/login");
    },
    pickService: function pickService(service) {
      this[__WEBPACK_IMPORTED_MODULE_6__store_modules_services__["a" /* SET_CURRENT_SERVICE */]](service);
      window.location.reload(true);
    },


    openTinggDocumentation: function openTinggDocumentation() {
      window.open("https://tingg.gitbook.io/checkout/", "_blank");
    }
  }),

  mounted: function mounted() {
    this.buildBreadcrumbs();
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Modal',
  props: {
    actionIcon: {
      type: String,
      default: 'save'
    },
    action: {
      type: String
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    height: {
      type: String,
      default: 'auto'
    },
    name: {
      type: String,
      required: true
    },
    noIcon: {
      type: Boolean,
      default: true
    },
    title: {
      type: String
    },
    width: {
      type: String,
      default: '350px'
    }
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Step',
  props: {
    customClass: {
      required: false
    },
    step: {
      required: false
    },
    subTitle: {
      required: false
    },
    title: {
      required: false
    }
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentOptionManager_vue__ = __webpack_require__(276);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc594b9e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentOptionManager_vue__ = __webpack_require__(466);
function injectStyle (ssrContext) {
  __webpack_require__(465)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentOptionManager_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc594b9e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentOptionManager_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_buefy__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_buefy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_buefy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Modal__ = __webpack_require__(43);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var logInfo = !!("development" !== 'production');

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_Modal__["a" /* default */],
    'b-checkbox': __WEBPACK_IMPORTED_MODULE_1_buefy___default.a.Checkbox
  },
  computed: {
    active: function active() {
      return this.selected;
    },

    editable: {
      get: function get() {
        return this.internalState.editing;
      },
      set: function set(value) {
        this.internalState.editing = value;
      }
    },
    paymentMode: {
      get: function get() {
        if (this.internalState.payerModeID !== undefined && this.internalState.payerModeID !== 0 && this.internalState.payerModeID !== null) {
          logInfo && console.log('A predefined mode exists for this option =>', this.paymentOption.payerModeID);
          return this.paymentOption.paymentModes[__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(this.paymentOption.paymentModes, ['payerModeID', __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toString(this.internalState.payerModeID)])];
        }

        return this.paymentOption.paymentModes[0];
      },
      set: function set(value) {
        this.internalState.payerModeID = value;
        this.$emit('option-updated', __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.merge(this.paymentOption, { payerModeID: this.paymentMode.payerModeID }));
      }
    },
    syncing: function syncing() {
      return this.status === 2;
    }
  },
  data: function data() {
    return {
      mode: 'view',
      internalState: {
        active: false,
        editing: false,
        payerModeID: undefined
      },
      selectedPayerMode: undefined
    };
  },

  methods: {
    cancelEdit: function cancelEdit() {
      this.$modal.hide('payment-option#' + this.paymentOption.countryPayerClientID);
    },
    raiseEvent: function raiseEvent() {
      if (this.paymentOption.optionEnabled) {
        return this.$emit('option-deactivated', __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.merge(this.paymentOption, { payerModeID: this.paymentMode.payerModeID }));
      }

      return this.$emit('option-activated', __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.merge(this.paymentOption, { payerModeID: this.paymentMode.payerModeID }));
    },
    saveEdit: function saveEdit() {
      this.paymentMode = this.selectedPayerMode;
      this.$modal.hide('payment-option#' + this.paymentOption.countryPayerClientID);
    },
    toggleEditability: function toggleEditability() {
      this.$modal.show('payment-option#' + this.paymentOption.countryPayerClientID);
    }
  },
  name: 'PaymentOptionManager',
  mounted: function mounted() {
    this.internalState.active = this.selected;
    this.internalState.payerModeID = this.paymentOption.payerModeID;
    this.selectedPayerMode = this.internalState.payerModeID;
  },

  props: {
    imageSource: {
      required: true,
      type: String
    },
    paymentOption: {
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    status: {
      default: 2
    },
    title: {
      required: true,
      type: String
    }
  }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_API__ = __webpack_require__(33);






var activeCodes = {
  1: 'Active',
  2: 'Created',
  3: 'Inactive',
  4: 'Rejected',
  5: 'Unknown',
  6: 'Deleted'
};

var PaymentOptions = function () {
  function PaymentOptions() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PaymentOptions);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PaymentOptions, null, [{
    key: 'activeStatus',
    value: function activeStatus(code) {
      return activeCodes[code];
    }
  }, {
    key: 'all',
    value: function all() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_4__utilities_API__["a" /* default */].refresh().post({ url: 'fetchAllPaymentOptions' }).then(function (response) {
          if (response.SUCCESS) {
            var result = [];
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forIn(response.DATA.countries, function (value, key) {
              var payerClients = [];

              __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forIn(response.DATA.payerClients[key], function (value, key) {
                payerClients = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.union(payerClients, value);
              });

              result.push({
                title: value.countryName,
                options: payerClients
              });
            });

            resolve(result);
          } else {
            reject(response);
          }
        }).catch(function (response) {
          reject(response);
        });
      });
    }
  }, {
    key: 'forService',
    value: function forService(_ref) {
      var serviceCode = _ref.serviceCode;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_4__utilities_API__["a" /* default */].refresh().post({ url: 'fetchServicePaymentOptions', data: { serviceCode: serviceCode } }).then(function (response) {
          if (response.SUCCESS) {
            var result = [];
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forIn(response.DATA.countries, function (value, key) {
              var payerClients = [];

              __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forIn(response.DATA.payerClients[key], function (payerClientsObj, key) {
                __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forIn(payerClientsObj, function (value, key) {
                  payerClients = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.union(payerClients, value);
                });
              });

              result.push({
                title: value.countryName,
                options: payerClients
              });
            });

            resolve(result);
          } else {
            reject(response);
          }
        }).catch(function (response) {
          reject(response);
        });
      });
    }
  }, {
    key: 'updatePaymentOption',
    value: function updatePaymentOption(payload, active) {
      console.log('UpdatePaymentOption() => payload passed: ', payload);
      // Check the active or inactive value
    }
  }]);

  return PaymentOptions;
}();

/* harmony default export */ __webpack_exports__["a"] = (PaymentOptions);

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Shell__ = __webpack_require__(23);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'app-shell': __WEBPACK_IMPORTED_MODULE_0__components_Shell__["a" /* default */]
  },
  name: 'Documentation'
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Group__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Shell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DeveloperKey__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_CollapsibleCard__ = __webpack_require__(477);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',

  components: {
    'ml-group': __WEBPACK_IMPORTED_MODULE_2__components_Group__["a" /* default */],
    'app-shell': __WEBPACK_IMPORTED_MODULE_3__components_Shell__["a" /* default */],
    'developer-key': __WEBPACK_IMPORTED_MODULE_4__components_DeveloperKey__["a" /* default */],
    'collapsible-card': __WEBPACK_IMPORTED_MODULE_5__components_CollapsibleCard__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('services', ['currentService']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('user', ['expressKeys', 'customApiKeys', 'clientInfo'])),

  methods: {
    goTo: function goTo(path) {
      if (!this.loading) {
        this.$router.push(path);
      }
    }
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_clipboard__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    copyButtonClass: function copyButtonClass() {
      return ['input-group-append js-copy-button', 'js-' + this.id + '_' + __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.snakeCase(this.title)];
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      var clipboard = new __WEBPACK_IMPORTED_MODULE_1_clipboard___default.a('.js-' + _this.id + '_' + __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.snakeCase(_this.title));
      clipboard.on('success', function (evt) {
        _this.$snackbar.open({
          message: _this.title + ' copied to clipboard',
          type: 'is-success',
          position: 'is-bottom',
          queue: false
        });
      });
    });
  },

  name: 'DeveloperKey',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String
    },
    id: {
      type: String,
      default: 'provide_id'
    },
    value: {
      required: true
    },
    width: {
      default: 45,
      type: Number
    }
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      collapsed: false
    };
  },


  props: {
    title: {
      type: String
    }
  },

  methods: {
    toggleCollapsible: function toggleCollapsible() {
      this.collapsed = !this.collapsed;
    }
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_services_auth_js__ = __webpack_require__(32);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var logInfo = !!("development" !== 'production');

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      password: '',
      showError: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('auth', ['login']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('services', ['saveServices']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('user', ['saveUserInformation', 'saveUserKeys']), {
    signIn: function signIn() {
      var _this = this;

      // Reset the page as we try authenticate the user.
      this.showError = false;
      // Check that all the user is expected to
      // fill in is provided
      this.$validator.validateAll().then(function (result) {
        logInfo && console.log('Did the login request pass validation?', result);

        if (result) {
          _this.$btn.disable('.mula-btn');

          // Attempt to login the user.
          __WEBPACK_IMPORTED_MODULE_3__api_services_auth_js__["a" /* default */].attemptSignIn({ email: _this.email, password: _this.password }).then(function (response) {
            logInfo && console.log('User was successfully authenticated', response);
            // Persist the user's token
            _this.login(response.DATA.authorizationToken);

            // Persist the user's information, services and keys
            _this.saveServices(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(response.DATA, ['serviceDetails']));
            _this.saveUserKeys(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(response.DATA, ['clientAccessKeys', 'oauthKeyDetails']));
            _this.saveUserInformation(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.omit(response.DATA, ['authorizationToken', 'clientAccessKeys', 'oauthKeyDetails', 'serviceDetails']));
            _this.$btn.enable('.mula-btn');
            _this.$router.push('/home');
          }).catch(function (response) {
            logInfo && console.log('User was not authenticated', response);
            // Stop the button loader
            // l.stop()
            // Show the error message
            _this.showError = true;
            _this.$btn.enable('.mula-btn');
          });
        }
      }).catch(function (reason) {
        logInfo && console.log('The user credentials have failed validation', reason);
      });
    }
  }),
  name: 'Login'
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var enableLogging = !!("development" !== 'production');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NotFoundComponent',
  mounted: function mounted() {
    enableLogging && console.log('Route does not match any of the routes => ', this.$router);
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Shell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_awesome_phonenumber__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_awesome_phonenumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_awesome_phonenumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_DataTable__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_services_payments__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_DataTable__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_ComparisonData__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ComparisonBoard__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_PaymentSimulator__ = __webpack_require__(348);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var logInfo = !!("development" !== 'production');

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'modal': __WEBPACK_IMPORTED_MODULE_4__components_Modal__["a" /* default */],
    'app-shell': __WEBPACK_IMPORTED_MODULE_3__components_Shell__["a" /* default */],
    'data-table': __WEBPACK_IMPORTED_MODULE_7__components_DataTable__["a" /* default */],
    'comparison-board': __WEBPACK_IMPORTED_MODULE_11__components_ComparisonBoard__["a" /* default */]
  },
  computed: {
    filters: function filters() {
      return [{
        label: 'Account number',
        type: 'string',
        key: 'accountNumber'
      }, {
        label: 'Amount',
        type: 'number',
        key: 'amountPaid'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        label: 'Visit ID',
        type: 'string',
        key: 'checkoutRequestID'
      }, this._passedFilters('checkoutRequestID')), {
        label: 'Country',
        type: 'list',
        key: 'countryCode',
        list: this._prepareCountries(this.meta.countries)
      }, {
        label: 'Currency',
        type: 'list',
        key: 'currencyCode',
        list: this._prepareCurrencies(this.meta.currencies)
      }, {
        label: 'Date',
        type: 'date',
        key: 'date'
      }, {
        label: 'Mobile number',
        type: 'string',
        key: 'MSISDN'
      }, {
        label: 'Payer client',
        type: 'list',
        key: 'payerClientCode',
        list: this._preparePayerClients(this.meta.payerClients)
      }, {
        label: 'Status',
        type: 'list',
        key: 'hubOverallStatus',
        list: this._prepareStatuses(this.meta.statusCodes)
      }];
    }
  },
  data: function data() {
    return {
      actions: [{
        name: 'View',
        event: 'view'
      }, {
        name: 'Visit',
        event: 'show-visit'
      }],
      buttons: [{
        name: 'Simulate',
        icon: 'plus',
        event: 'simulate-payment'
      }],
      columns: {
        MSISDN: {
          filter: 'phoneNumber',
          label: 'Mobile Number'
        },
        accountNumber: {
          label: 'Account Number'
        },
        amountPaid: {
          float: 'left',
          filter: 'money',
          label: 'Amount',
          highlight: true
        },
        checkoutRequestID: {
          label: 'Visit ID'
        },
        currencyCode: {
          float: 'right',
          highlight: true,
          label: ''
        },
        customerName: {
          label: 'Customer Name',
          collapsed: true
        },
        ownerClientCode: {
          hide: true
        },
        ownerClientDisplayName: {
          hide: true
        },
        ownerClientName: {
          hide: true
        },
        payerClientCode: {
          hide: true
        },
        payerClientDisplayName: {
          label: 'Payment Mode',
          collapsed: true
        },
        payerClientName: {
          hide: true
        },
        paymentReceivedDate: {
          float: 'right',
          collapsed: true,
          type: 'date'
        },
        payerTransactionID: {
          label: 'Payer Transaction ID',
          collapsed: true
        },
        paymentDate: {
          float: 'right',
          label: 'Date',
          type: 'date'
        },
        receiverNarration: {
          collapsed: true,
          label: 'Description'
        },
        merchantReceipt: {
          collapsed: true,
          label: 'Receipt number'
        },
        datePaymentAcknowledged: {
          collapsed: true,
          float: 'right',
          label: 'Payment acknowledged on',
          type: 'date'
        }
      }
    };
  },

  methods: {
    _formatPayments: function _formatPayments(payments) {
      var structuredPayments = [];
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forIn(payments, function (payment) {
        structuredPayments.push({
          checkoutRequestID: payment.checkoutRequestID,
          currencyCode: payment.currencyCode,
          amountPaid: payment.amountPaid,
          MSISDN: payment.MSISDN,
          accountNumber: payment.accountNumber,
          status: payment.statusCodeDesc,
          paymentDate: payment.dateCreated,
          receiverNarration: payment.receiverNarration,
          customerName: payment.customerName,
          merchantReceipt: payment.merchantReceipt,
          payerTransactionID: payment.payerTransactionID,
          paymentReceivedDate: payment.datePaymentReceived,
          payerClientDisplayName: payment.payerClientDisplayName,
          datePaymentAcknowledged: payment.datePaymentAcknowledged,
          payerClientCode: payment.payerClientCode,
          ownerClientCode: payment.ownerClientCode,
          ownerClientDisplayName: payment.ownerClientDisplayName,
          ownerClientName: payment.ownerClientName,
          payerClientName: payment.payerClientName
        });
      });
      return structuredPayments;
    },
    _passedFilters: function _passedFilters() {
      logInfo && console.log('What was the filter passed ?', this.$route.query.filter);
      if (this.$route.query.filter !== undefined) {
        return {
          mode: 'like',
          selected: true,
          value: this.$route.query.filter
        };
      }
      return {};
    },
    attachCustomValidators: function attachCustomValidators() {
      __WEBPACK_IMPORTED_MODULE_5_vee_validate__["a" /* Validator */].extend('phone_number', {
        getMessage: function getMessage(field) {
          return 'The phone number provided is not a valid phone number.';
        },
        validate: function validate(value) {
          return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
            var isPhoneNumberValid = __WEBPACK_IMPORTED_MODULE_6_awesome_phonenumber___default()('+' + value).isValid();
            resolve({
              valid: isPhoneNumberValid
            });
          });
        }
      });
    },
    showVisit: function showVisit(payment) {
      logInfo && console.log('Select the visit for the payment: ', payment);
      this.$router.push('/visits?filter=' + payment.checkoutRequestID);
    },
    rebuildComparisonChart: function rebuildComparisonChart(filters) {
      var _this = this;

      logInfo && console.log('Rebuilding the comparison chart....', filters);
      __WEBPACK_IMPORTED_MODULE_8__api_services_payments__["a" /* default */].whereService({ serviceCode: this.currentService.serviceCode }).fetchComparisonData({ filters: filters }).then(function (response) {
        logInfo && console.log('Comparison chart data received => ', response);
        _this.comparisonData = response;
      }).catch(function (reason) {
        logInfo && console.log('Failed to rebuild the comparison chart => ', reason);
      });
    },
    rebuildTable: function rebuildTable(filters) {
      var _this2 = this;

      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var rebuildFilters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      logInfo && console.log('Filters passed to rebuild the table are: ', filters);
      var formattedFilters = this._extractFormattedFilters(filters);
      logInfo && console.log('Filters from the data table', formattedFilters);
      __WEBPACK_IMPORTED_MODULE_8__api_services_payments__["a" /* default */].whereService({ serviceCode: this.currentService.serviceCode }).fetchAll({ page: page === null ? this.page : page, filters: formattedFilters }).then(function (response) {
        logInfo && console.log('Payments fetched from the engine => ', response);
        _this2.rows = _this2._formatPayments(response.DATA.payments);
        _this2.page = response.DATA.page;
        _this2.pageLimit = response.DATA.pageLimit;
        if (rebuildFilters) {
          _this2.meta = response.DATA.metaData;
        }
      }).catch(function (reason) {
        logInfo && console.log('Payments failed from the engine => ', reason);
      });
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_ComparisonData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_DataTable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_PaymentSimulator__["a" /* default */]],
  mounted: function mounted() {
    this.attachCustomValidators();
    this.rebuildTable(this.filters, 0, true);
  },

  name: 'Payments'
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_context_menu__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_context_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_context_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Popover__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_awesome_phonenumber__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_awesome_phonenumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_awesome_phonenumber__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable comma-spacing */







var FilterConstants = {
  string: 'like',
  number: 'between',
  date: 'dateBetween'
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'pop-over': __WEBPACK_IMPORTED_MODULE_4__components_Popover__["a" /* default */],
    'context-menu': __WEBPACK_IMPORTED_MODULE_3_vue_context_menu___default.a
  },
  computed: {
    columns: function columns() {
      var _this = this;

      var columns = [];
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.keys(this.rows[0]).forEach(function (key) {
        columns.push({
          collapsed: _this.columnConfiguration[key] === undefined ? false : _this.columnConfiguration[key].collapsed === undefined ? false : _this.columnConfiguration[key].collapsed,
          float: _this.columnConfiguration[key] === undefined ? false : _this.columnConfiguration[key].float === undefined ? false : _this.columnConfiguration[key].float,
          filter: _this.columnConfiguration[key] === undefined ? false : _this.columnConfiguration[key].filter === undefined ? false : _this.columnConfiguration[key].filter,
          label: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.capitalize(_this.columnConfiguration[key] === undefined ? __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.lowerCase(key) : _this.columnConfiguration[key].label === undefined ? __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.lowerCase(key) : _this.columnConfiguration[key].label),
          key: key,
          hide: _this.columnConfiguration[key] === undefined ? false : _this.columnConfiguration[key].hide === undefined ? false : _this.columnConfiguration[key].hide,
          highlight: _this.columnConfiguration[key] === undefined ? false : _this.columnConfiguration[key].highlight === undefined ? false : _this.columnConfiguration[key].highlight,
          type: _this.columnConfiguration[key] === undefined ? false : _this.columnConfiguration[key].type === undefined ? false : _this.columnConfiguration[key].type
        });
      });
      return columns;
    },
    hasActions: function hasActions() {
      return !!this.actions.length && this.rows.length > 0;
    },
    hasCollapsable: function hasCollapsable() {
      var hasCollapsable = false;
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forIn(this.columns, function (column) {
        if (column.collapsed) {
          hasCollapsable = true;
        }
      });
      return hasCollapsable;
    },
    numberOfFilters: function numberOfFilters() {
      var numberOfFilters = 0;

      this.tableFilters.forEach(function (filter) {
        if (filter.selected == null) {
          numberOfFilters++;
        }
      });

      return numberOfFilters;
    },
    numberOfPossiblePages: function numberOfPossiblePages() {
      if (this.page === 0 && this.rows.length < this.pageLimit) {
        return 0;
      }

      return this.page + 1;
    },
    previousRecords: function previousRecords() {
      if (this.page === 0) {
        return 1;
      }
      return this.page * this.pageLimit;
    }
  },
  data: function data() {
    return {
      filterEvent: {},
      infoEvent: {},
      outputFilters: {
        money: function money(value) {
          return __WEBPACK_IMPORTED_MODULE_2_numeral___default()(value).format('0,0.00');
        },
        phoneNumber: function phoneNumber(value) {
          return __WEBPACK_IMPORTED_MODULE_5_awesome_phonenumber___default()('+' + value).getNumber('international');
          // return `${value}`
        },
        capitalize: function capitalize(value) {
          return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.capitalize(value);
        }
      },
      showFilter: false,
      showInfo: false,
      tableFilters: []
    };
  },

  methods: {
    _buildTableFilters: function _buildTableFilters() {
      var _this2 = this;

      this.tableFilters = [];

      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forIn(this.filters, function (filter) {
        _this2.tableFilters.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, filter, {
          mode: filter.mode === undefined ? FilterConstants[filter.type] : filter.mode,
          value: filter.value === undefined ? null : filter.value,
          max: filter.max === undefined ? null : filter.max,
          min: filter.min === undefined ? null : filter.min,
          selected: filter.selected === undefined ? null : filter.selected
        }));
      });
    },
    clearFilters: function clearFilters(event) {
      this._buildTableFilters();
      this.performFilter(event);
    },
    determineMenuItemVisibility: function determineMenuItemVisibility(row, condition) {
      if (condition !== undefined) {
        if (condition.condition === 'isNot') {
          return row[condition.field] !== condition.value;
        }
        return row[condition.field] === condition.value;
      }
      return true;
    },
    dynamicallyFilter: function dynamicallyFilter(value, filter) {

      if (this.outputFilters[filter] !== undefined && !!filter) {
        return this.outputFilters[filter](value);
      }
      return value;
    },
    nextPage: function nextPage() {
      this.$emit('next-page', { filters: this.tableFilters });
      this.$btn.disable('.ml-btn--next');
      this.$btn.disable('.ml-btn--prev');
    },
    performFilter: function performFilter(event) {
      this.$emit('filter', this.tableFilters);
      this.toggleFilter(event);
    },
    prevPage: function prevPage() {
      this.$emit('prev-page', { filters: this.tableFilters });
      this.$btn.disable('.ml-btn--next');
      this.$btn.disable('.ml-btn--prev');
    },
    toggleFilter: function toggleFilter(event) {
      this.showFilter = !this.showFilter;
      this.filterEvent = event;
    },
    toggleRow: function toggleRow(row) {
      if (this.hasCollapsable) {
        this.$emit('view', row);
      }
    }
  },
  name: 'data-table',
  props: {
    actions: {
      default: function _default() {
        return [];
      }
    },
    buttons: {
      required: false
    },
    columnConfiguration: {
      required: false
    },
    filters: {
      default: function _default() {
        return [];
      }
    },
    selectedRow: {
      default: null
    },
    page: {
      default: 0
    },
    pageLimit: {
      default: 10
    },
    rows: {
      required: true
    }
  },
  watch: {
    filters: function filters() {
      this._buildTableFilters();
    },
    rows: function rows() {
      // Check with there're previous records
      this.page <= 0 ? this.$btn.disable('.ml-btn--prev') : this.$btn.enable('.ml-btn--prev');
      // Check whether there is a possibility of more records
      this.rows.length < this.pageLimit ? this.$btn.disable('.ml-btn--next') : this.$btn.enable('.ml-btn--next');
    }
  }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      position: ''
    };
  },

  watch: {
    show: function show(newValue, old) {
      // Build up the new position
      switch (this.orientation) {
        case 'Top':
          this.position = '\n            top: ' + (this.event.target.offsetTop - (this.space + this.event.target.offsetHeight)) + 'px;\n            left: ' + this.event.target.offsetLeft + 'px;\n          ';
          break;
        case 'Bottom':
          this.position = '\n            top: ' + (this.event.target.offsetHeight + this.event.target.offsetTop + this.space) + 'px;\n            left: ' + this.event.target.offsetLeft + 'px;\n          ';
          break;
        case 'Left':
          this.position = '\n            top: ' + this.event.target.offsetTop + 'px;\n            left: ' + (this.event.target.offsetLeft - this.event.target.offsetWidth) + 'px;\n          ';
          break;
        case 'Right':
          this.position = '\n            top: ' + this.event.target.offsetTop + 'px;\n            left: ' + (this.event.target.offsetWidth + this.event.target.offsetLeft + this.space) + 'px;\n          ';
          break;
      }
    }
  },
  name: 'Popover',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    space: {
      type: Number,
      default: 5
    },
    event: {
      required: true
    },
    orientation: {
      type: String,
      default: 'Bottom'
    }
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_API__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__transformers_ComparisonDataTransformer__ = __webpack_require__(288);






var logApi = !!("development" !== 'production');

var Payments = function () {
  function Payments() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Payments);

    this.serviceCode = '';
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Payments, [{
    key: 'fetchAll',
    value: function fetchAll(_ref) {
      var from = _ref.from,
          page = _ref.page,
          filters = _ref.filters;

      return __WEBPACK_IMPORTED_MODULE_3__utilities_API__["a" /* default */].refresh().post({ url: 'fetchPayments',
        data: {
          'dateFrom': from,
          'serviceCode': this.serviceCode,
          'page': page,
          filters: filters
        }
      });
    }
  }, {
    key: 'fetchComparisonData',
    value: function fetchComparisonData(_ref2) {
      var _this = this;

      var filters = _ref2.filters;

      logApi && console.log('Fetching comparison data of the service => ' + this.serviceCode);
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__utilities_API__["a" /* default */].refresh().post({ url: 'fetchPaymentTotals',
          data: {
            'serviceCode': _this.serviceCode,
            'date': {
              'type': 'dateBetween',
              'min': filters.from,
              'max': filters.to
            }
          }
        }).then(function (response) {
          console.log('Fetch visits comparison data => ', response);
          resolve(__WEBPACK_IMPORTED_MODULE_4__transformers_ComparisonDataTransformer__["a" /* default */].transform(response.DATA, 'Trx.'));
        }).catch(function (reason) {
          console.log('Fetching visits comparison data failed => ', reason);
          reject(reason);
        });
      });
    }
  }, {
    key: 'simulatePayment',
    value: function simulatePayment(_ref3) {
      var payment = _ref3.payment;

      return __WEBPACK_IMPORTED_MODULE_3__utilities_API__["a" /* default */].refresh().post({ url: 'simulatePayment', data: payment });
    }
  }, {
    key: 'whereService',
    value: function whereService(_ref4) {
      var serviceCode = _ref4.serviceCode;

      this.serviceCode = serviceCode;
      return this;
    }
  }]);

  return Payments;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Payments());

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);


/**
 * ---------------------------------------------------------------------------------------
 * Comparison data's expected format
 * ---------------------------------------------------------------------------------------
 *
 * [
 *    {
 *      title: '',
 *      total: '',
 *      performance: '',
 *      units: '',
 *      data: [
 *        {
 *          name: 'current',
 *          data: {
 *            `${date}`: '',
 *            ....
 *          }
 *        },
 *        {
 *          name: 'previous',
 *          data: {
 *            `${date}`: '',
 *            ....
 *          }
 *        }
 *      ]
 *    },
 *    ....
 * ]
 */



// Inverted comparison points.
var INVERTED_COMPARISON = ['rejected payments', 'expired requests', 'rejected requests'];

var ComparisonDataTransformer = function () {
  function ComparisonDataTransformer() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ComparisonDataTransformer);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ComparisonDataTransformer, null, [{
    key: 'transform',
    value: function transform(data, unit) {
      var comparisonData = { 'data': [] };
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forIn(data, function (value, key) {
        comparisonData.data.push({
          title: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.capitalize(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.lowerCase(key)),
          total: value.currentTotal,
          performance: Math.round((value.currentTotal - value.previousTotal) / (value.previousTotal === 0 ? 1 : value.previousTotal) * 100),
          data: ComparisonDataTransformer.formatTheChartLabels(value.data),
          unit: unit,
          invert: INVERTED_COMPARISON.includes(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.lowerCase(key))
        });
      });
      return comparisonData;
    }
  }, {
    key: 'formatTheChartLabels',
    value: function formatTheChartLabels(data) {
      var dataPoints = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toPairs(data[1].data);
      // Subtract the milliseconds from the first date to the last date
      var milliSecondDiff = new Date(dataPoints[dataPoints.length - 1][0]).getTime() - new Date(dataPoints[0][0]).getTime();
      var derivedWeeks = Math.ceil(__WEBPACK_IMPORTED_MODULE_3_moment___default.a.duration(milliSecondDiff, 'milliseconds').asWeeks());
      var weeks = derivedWeeks < 1 ? 1 : derivedWeeks;
      // Format the legend labels
      data[0].name = 'Current';
      data[1].name = weeks + ' week' + (weeks > 1 ? 's' : '') + ' ago';
      return data;
    }
  }]);

  return ComparisonDataTransformer;
}();

/* harmony default export */ __webpack_exports__["a"] = (ComparisonDataTransformer);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(9);




var TODAYS_SECONDS = 24 * 60 * 60 - 1;
/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('services', ['currentService']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('user', ['userInfo'])),
  data: function data() {
    return {
      meta: {},
      rows: [],
      selectedRow: '',
      page: 0,
      pageLimit: 10
    };
  },

  methods: {
    _extractFormattedFilters: function _extractFormattedFilters(filters) {
      var formattedFilters = {};
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forIn(filters, function (filter) {
        if (filter.selected) {
          formattedFilters[filter.key] = {
            max: filter.type === 'date' ? new Date(filter.max).getTime() / 1000 + TODAYS_SECONDS : filter.max,
            min: filter.type === 'date' ? new Date(filter.min).getTime() / 1000 + TODAYS_SECONDS : filter.min,
            type: filter.mode === undefined ? 'exact' : filter.mode,
            value: filter.type === 'date' ? new Date(filter.value).getTime() / 1000 + TODAYS_SECONDS : filter.value
          };
        }
      });
      return formattedFilters;
    },
    _prepareCountries: function _prepareCountries(countries) {
      var formattedCountries = [];
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forIn(countries, function (value, key) {
        formattedCountries.push({
          key: key,
          label: value.countryName
        });
      });
      return formattedCountries;
    },
    _prepareCurrencies: function _prepareCurrencies(currency) {
      var formattedCurrencies = [];
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forIn(currency, function (value, key) {
        formattedCurrencies.push({
          key: key,
          label: value.currencyName
        });
      });
      return formattedCurrencies;
    },
    _prepareStatuses: function _prepareStatuses(statuses) {
      var formattedStatuses = [];
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forIn(statuses, function (value, key) {
        formattedStatuses.push({
          key: key,
          label: value.statusName
        });
      });
      return formattedStatuses;
    },
    _preparePayerClients: function _preparePayerClients(payerClients) {
      var payerClientsObj = {};
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forIn(payerClients, function (clientSection, countryCode) {
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forIn(clientSection, function (client) {
          client.countryCode = countryCode;
        });
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.merge(payerClientsObj, clientSection);
      });
      var formattedPayerClients = [];
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forIn(payerClientsObj, function (value, key) {
        formattedPayerClients.push({
          countryCode: value.countryCode,
          key: key,
          label: value.payerClientName
        });
      });
      return formattedPayerClients;
    },
    nextPage: function nextPage(event) {
      // TODO: Implement a check for the next page
      if (this.rows.length > 1) {
        ++this.page;
      }
      this.rebuildTable(event.filters, this.page);
    },
    selectRow: function selectRow(row) {
      if (this.selectedRow !== row) {
        this.selectedRow = row;
      } else {
        this.selectedRow = {};
      }
    },
    prevPage: function prevPage(event) {
      if (this.page - 1 >= 0) {
        this.page = this.page - 1;
      }
      this.rebuildTable(event.filters, this.page);
    }
  }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      comparisonData: []
    };
  }
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComparisonBoard_vue__ = __webpack_require__(292);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_280de3b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComparisonBoard_vue__ = __webpack_require__(603);
function injectStyle (ssrContext) {
  __webpack_require__(497)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComparisonBoard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_280de3b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComparisonBoard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Chart__ = __webpack_require__(498);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ComparisonBoard',

  data: function data() {
    return {
      hide: false,
      range: {
        from: new Date((Math.round(new Date().getTime() / 1000) - 7 * 24 * 60 * 60) * 1000),
        to: new Date(Math.round(new Date().getTime() / 1000) * 1000)
      },
      selectedTab: 0,
      selectedCategory: false,
      prompts: {
        'week': 'vs last 7 Days',
        '2week': 'vs last 2 Weeks',
        'month': 'vs last Month'
      }
    };
  },


  computed: {
    categories: function categories() {
      return this.data.data;
    }
  },

  components: {
    Chart: __WEBPACK_IMPORTED_MODULE_0__components_Chart__["a" /* default */]
  },

  methods: {
    rebuildChart: function rebuildChart() {
      // Set the time range
      this.$emit('filter-chart', {
        from: this.range.from.getTime() / 1000,
        to: this.range.to.getTime() / 1000 + (24 * 60 * 60 - 1)
      });
    },
    selectTab: function selectTab(index) {
      this.selectedTab = index;
      // Allocate the selected category
      this.selectedCategory = this.categories[index];
    }
  },
  mounted: function mounted() {
    this.rebuildChart();
  },


  props: {
    data: {
      required: true
    }
  },
  watch: {
    data: function data() {
      this.selectedCategory = this.categories[this.selectedTab];
    }
  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_randomstring__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_randomstring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_randomstring__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: ''
    };
  },

  methods: {
    initializeChartID: function initializeChartID() {
      this.id = __WEBPACK_IMPORTED_MODULE_0_randomstring___default.a.generate({ length: 7, charset: 'alphabetic' });
    }
  },
  mounted: function mounted() {
    this.initializeChartID();
  },

  name: 'Chart',
  props: {
    title: {
      type: String
    },
    data: {
      required: true
    },
    height: {
      type: String,
      default: '500'
    },
    legendPosition: {
      type: String,
      default: 'none'
    }
  }
});

/***/ }),
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_config__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_services_payments__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_awesome_phonenumber__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_awesome_phonenumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_awesome_phonenumber__);







var logInfo = !!("development" !== 'production');

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      simulatedPayment: {
        chargeAmount: '',
        MSISDN: '',
        paymentOption: '',
        accountNumber: '',
        savePhoneNumber: false
      }
    };
  },

  methods: {
    attachCustomValidators: function attachCustomValidators() {
      __WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* Validator */].extend('phone_number', {
        getMessage: function getMessage(field) {
          return 'The phone number provided is not a valid phone number.';
        },
        validate: function validate(value) {
          return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
            var isPhoneNumberValid = __WEBPACK_IMPORTED_MODULE_5_awesome_phonenumber___default()('+' + value).isValid();
            resolve({
              valid: isPhoneNumberValid
            });
          });
        }
      });
    },
    cancelSimulator: function cancelSimulator() {
      this.$modal.hide('simulate-payment');
      // Reset the user form
      this.simulatedPayment = {
        amount: '',
        paymentOption: '',
        accountNumber: ''
      };
    },
    launchSimulator: function launchSimulator() {
      // Prefill the mobile number with the user's number
      this.simulatedPayment.MSISDN = this.userInfo.MSISDN;
      this.$modal.show('simulate-payment');
    },
    simulatePayment: function simulatePayment() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        logInfo && console.log('Did the simulate payment request pass validation?', result);
        // TODO: Implement a simulation of payments
        if (result) {
          __WEBPACK_IMPORTED_MODULE_4__api_services_payments__["a" /* default */].simulatePayment({
            payment: {
              'countryCode': __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.upperCase(_this.simulatedPayment.paymentOption.countryCode),
              'accountNumber': _this.simulatedPayment.accountNumber,
              'customerName': _this.userInfo.firstName + ' ' + _this.userInfo.lastName,
              'MSISDN': _this.simulatedPayment.MSISDN,
              'chargeAmount': _this.simulatedPayment.chargeAmount,
              'currencyCode': __WEBPACK_IMPORTED_MODULE_3__api_config__["a" /* default */].CURRENCIES[_this.simulatedPayment.paymentOption.countryCode].code,
              'serviceCode': _this.currentService.serviceCode,
              'narration': 'Simulated payment by ' + _this.userInfo.firstName + ' ' + _this.userInfo.lastName,
              'payerClientCode': _this.simulatedPayment.paymentOption.key
            }
          }).then(function (response) {
            logInfo && console.log('Successfully simulated a payment', response);
            _this.cancelSimulator();
            _this.$snackbar.open({
              message: 'Payment successfully made',
              type: 'is-success',
              position: 'is-bottom',
              queue: false
            });
          }).catch(function (reason) {
            logInfo && console.log('Failed to invite a user', reason);
            _this.cancelSimulator();
            if (reason.STATCODE === 7) {
              _this.$snackbar.open({
                message: 'Simulating the payment failed',
                type: 'is-error',
                position: 'is-bottom',
                queue: false,
                actionText: 'RETRY',
                onAction: function onAction() {
                  _this.simulatePayment();
                }
              });
            } else {
              _this.$snackbar.open({
                message: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.capitalize(reason.REASON),
                type: 'is-warning',
                position: 'is-bottom',
                queue: false,
                actionText: 'OK'
              });
            }
          });
        }
      });
    }
  }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_config__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Tip__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Group__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Shell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_services_service__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_services_paymentOption__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_PaymentOptionManager__ = __webpack_require__(275);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var logInfo = !!("development" !== 'production');

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'app-shell': __WEBPACK_IMPORTED_MODULE_6__components_Shell__["a" /* default */],
    'ml-group': __WEBPACK_IMPORTED_MODULE_5__components_Group__["a" /* default */],
    'ml-tip': __WEBPACK_IMPORTED_MODULE_4__components_Tip__["a" /* default */],
    'payment-option-manager': __WEBPACK_IMPORTED_MODULE_9__components_PaymentOptionManager__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('services', ['currentService', 'allServices']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('user', ['clientInfo']), {
    logoUrls: function logoUrls() {
      return __WEBPACK_IMPORTED_MODULE_3__api_config__["a" /* default */].LOGO_URLS;
    }
  }),
  data: function data() {
    return {
      options: []
    };
  },

  methods: {
    addPaymentOption: function addPaymentOption(option) {
      var _this = this;

      logInfo && console.log('Add the payment option =>', __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(option, ['countryPayerClientID', 'clientDisplayName', 'selectedPaymentModeID', 'countryName']));

      __WEBPACK_IMPORTED_MODULE_7__api_services_service__["a" /* default */].update({
        payload: {
          'serviceCode': this.currentService.serviceCode,
          'serviceName': this.currentService.serviceName,
          'clientCode': this.clientInfo.client_code,
          'options': [__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.merge(option, { optionEnabled: true, serviceSettingActive: 2 })]
        }
      }).then(function (response) {
        logInfo && console.log('Creation of the service setting was a success. Response =>', response);
        // Search for the option in the array of options and update the various fields
        // [optionEnabled, active]
        option.optionEnabled = true;
        _this.$snackbar.open({
          message: option.clientDisplayName + ' is added',
          type: 'is-success',
          position: 'is-bottom',
          queue: false,
          actionText: 'UNDO',
          onAction: function onAction() {
            _this.removePaymentOption(option);
          }
        });
      }).catch(function (reason) {
        logInfo && console.log('Creation of the service setting failed. Reason =>', reason);
        _this.$snackbar.open({
          message: 'Adding ' + option.clientDisplayName + ' to failed',
          type: 'is-error',
          position: 'is-bottom',
          queue: false,
          actionText: 'RETRY',
          onAction: function onAction() {
            _this.addPaymentOption(option);
          }
        });
      });
    },
    removePaymentOption: function removePaymentOption(option) {
      var _this2 = this;

      logInfo && console.log('Remove the payment option =>', __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(option, ['countryPayerClientID', 'clientDisplayName', 'selectedPaymentModeID', 'countryName']));

      __WEBPACK_IMPORTED_MODULE_7__api_services_service__["a" /* default */].update({
        payload: {
          'serviceCode': this.currentService.serviceCode,
          'serviceName': this.currentService.serviceName,
          'clientCode': this.clientInfo.client_code,
          'options': [__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.merge(option, { optionEnabled: false })]
        }
      }).then(function (response) {
        logInfo && console.log('Removal of the service setting was a success. Response =>', response);
        // Search for the option in the array of options and update the various fields
        // [optionEnabled, active]
        option.optionEnabled = false;
        _this2.$snackbar.open({
          message: option.clientDisplayName + ' is removed',
          type: 'is-success',
          position: 'is-bottom',
          queue: false,
          actionText: 'UNDO',
          onAction: function onAction() {
            _this2.addPaymentOption(option);
          }
        });
      }).catch(function (reason) {
        logInfo && console.log('Removal of the service setting failed. Reason =>', reason);
        _this2.$snackbar.open({
          message: 'Removing ' + option.clientDisplayName + ' from ' + _this2.currentService.serviceName + ' failed',
          type: 'is-error',
          position: 'is-bottom',
          queue: false,
          actionText: 'RETRY',
          onAction: function onAction() {
            _this2.removePaymentOption(option);
          }
        });
      });
    },
    updatePaymentOption: function updatePaymentOption(option) {
      var _this3 = this;

      logInfo && console.log('Update the payment option =>', __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(option, ['countryPayerClientID', 'clientDisplayName', 'selectedPaymentModeID', 'countryName']));

      __WEBPACK_IMPORTED_MODULE_7__api_services_service__["a" /* default */].update({
        payload: {
          'serviceCode': this.currentService.serviceCode,
          'serviceName': this.currentService.serviceName,
          'clientCode': this.clientInfo.client_code,
          'options': [option]
        }
      }).then(function (response) {
        logInfo && console.log('Update of the service setting was a success. Response =>', response);
        _this3.$snackbar.open({
          message: option.clientDisplayName + ' successfully updated',
          type: 'is-success',
          position: 'is-bottom',
          queue: false
        });
      }).catch(function (reason) {
        logInfo && console.log('Updating of the service setting failed. Reason =>', reason);
        _this3.$snackbar.open({
          message: option.clientDisplayName + ' failed to update',
          type: 'is-error',
          position: 'is-bottom',
          queue: false
        });
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_8__api_services_paymentOption__["a" /* default */].forService({ serviceCode: this.currentService.serviceCode }).then(function (paymentOptions) {
      logInfo && console.log('Successfully fetched the payment options: ', paymentOptions);
      _this4.options = paymentOptions;
    }).catch(function (reason) {
      logInfo && console.log('Failed to fetch the payment options: => ', reason);
    });
  },

  name: 'PaymentOptions'
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      open: true
    };
  },


  methods: {
    close: function close() {
      this.open = false;
    }
  },

  mounted: function mounted() {
    this.open = this.show;
  },


  name: 'Tip',

  props: {
    show: {
      type: Boolean,
      default: true
    }
  }
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_config__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Group__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_awesome_phonenumber__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_awesome_phonenumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_awesome_phonenumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Shell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_services_service__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_services_user__ = __webpack_require__(105);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var logInfo = !!("development" !== 'production');

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'app-shell': __WEBPACK_IMPORTED_MODULE_8__components_Shell__["a" /* default */],
    'ml-group': __WEBPACK_IMPORTED_MODULE_6__components_Group__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('services', ['currentService']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('user', ['clientInfo', 'userInfo']), {
    base_currency: function base_currency() {
      return __WEBPACK_IMPORTED_MODULE_5__api_config__["a" /* default */].CURRENCIES[this.country_of_operation];
    },
    countries: function countries() {
      return __WEBPACK_IMPORTED_MODULE_5__api_config__["a" /* default */].COUNTRIES;
    }
  }),

  data: function data() {
    return {
      business_name: '',
      country_of_operation: '',
      full_name: '',
      user_full_name: '',
      phone_number: '',
      user_phone_number: '',
      service_name: ''
    };
  },


  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('user', ['updateUser']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('user', ['updateClient']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('services', ['updateService']), {
    attachCustomValidators: function attachCustomValidators() {
      __WEBPACK_IMPORTED_MODULE_4_vee_validate__["a" /* Validator */].extend('phone_number', {
        getMessage: function getMessage(field) {
          return 'The phone number provided is not a valid phone number.';
        },
        validate: function validate(value) {
          return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
            var isPhoneNumberValid = __WEBPACK_IMPORTED_MODULE_7_awesome_phonenumber___default()('+' + value).isValid();
            resolve({
              valid: isPhoneNumberValid
            });
          });
        }
      });
    },
    populateProfile: function populateProfile() {
      this.business_name = this.clientInfo.client_name;
      this.service_name = this.currentService.serviceName;
      this.full_name = this.clientInfo.contactPerson;
      this.phone_number = this.clientInfo.contactMsisdn;
      this.user_full_name = this.userInfo.firstName + ' ' + this.userInfo.lastName;
      this.user_phone_number = this.userInfo.MSISDN;
      this.country_of_operation = this.clientInfo.businessCountryCode;
    },
    updateProfile: function updateProfile() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        logInfo && console.log('Did the update fields pass validation?', result);

        if (result) {
          // Update service
          __WEBPACK_IMPORTED_MODULE_9__api_services_service__["a" /* default */].updateService({
            service: {
              clientCode: _this.clientInfo.client_code,
              serviceCode: _this.currentService.serviceCode,
              serviceName: _this.service_name
            }
          }).then(function (response) {
            logInfo && console.log('The service was updated properly', response);
            _this.updateService(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.pick(_this.currentService, ['serviceCode', 'serviceID']), {
              serviceName: _this.service_name
            }));
            __WEBPACK_IMPORTED_MODULE_10__api_services_user__["a" /* default */].updateClient({
              client: {
                businessCountryCode: _this.country_of_operation,
                clientCode: _this.clientInfo.client_code,
                clientName: _this.business_name,
                defaultCurrencyCode: _this.base_currency !== undefined && _this.base_currency !== null ? _this.base_currency.code : undefined,
                fullName: _this.full_name,
                mobileNumber: _this.phone_number
              }
            }).then(function (response) {
              logInfo && console.log('The client was updated properly', response);
              _this.updateClient({
                businessCountryCode: _this.country_of_operation,
                clientCode: _this.clientInfo.client_code,
                clientName: _this.business_name,
                defaultCurrencyCode: _this.base_currency !== undefined && _this.base_currency !== null ? _this.base_currency.code : undefined,
                contactPerson: _this.full_name,
                contactMsisdn: _this.phone_number
              });
              __WEBPACK_IMPORTED_MODULE_10__api_services_user__["a" /* default */].updateUserProfile({
                user: {
                  clientCode: _this.clientInfo.client_code,
                  emailAddress: _this.userInfo.emailAddress,
                  fullName: _this.user_full_name,
                  mobileNumber: _this.user_phone_number
                }
              }).then(function (response) {
                logInfo && console.log('The user was updated properly', response);
                _this.updateUser({
                  firstName: _this.user_full_name,
                  lastName: '',
                  MSISDN: _this.user_phone_number,
                  emailAddress: _this.userInfo.emailAddress
                });
                _this.$snackbar.open({
                  message: 'Updating your profile was successful',
                  type: 'is-success',
                  position: 'is-bottom',
                  queue: false,
                  actionText: 'OK'
                });
              });
            });
          }).catch(function (reason) {
            logInfo && console.log('Profile update failed: =>', reason);
            _this.$snackbar.open({
              message: 'Updating your profile failed',
              type: 'is-error',
              position: 'is-bottom',
              queue: false,
              actionText: 'RETRY',
              onAction: function onAction() {
                _this.updateProfile();
              }
            });
          });
        }
      }).catch(function (reason) {
        logInfo && console.log('The update fields could not be validated', reason);
      });
    }
  }),

  mounted: function mounted() {
    this.attachCustomValidators();
    this.populateProfile();
  },


  name: 'Profile'
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_services_auth_js__ = __webpack_require__(32);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var logInfo = !!("development" !== 'production');

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showError: false,
      password: ''
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('auth', ['login']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('services', ['saveServices']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('user', ['saveUserInformation', 'saveUserKeys']), {
    setupPassword: function setupPassword() {
      var _this = this;

      // Reset the page as we try authenticate the user.
      this.showError = false;
      // Check that all the user is expected to
      // fill in is provided
      this.$validator.validateAll().then(function (result) {
        logInfo && console.log('Did the set password request pass validation?', result);

        if (result) {
          _this.$btn.disable('.mula-btn');
          // Attempt to login the user.
          __WEBPACK_IMPORTED_MODULE_3__api_services_auth_js__["a" /* default */].attemptToSetPassword({ password: _this.password, token: _this.$route.params.token }).then(function (response) {
            logInfo && console.log('The user\'s password was properly set', response);
            _this.$btn.enable('.mula-btn');
            // Persist the user's token
            _this.login(response.DATA.authorizationToken);

            // Persist the user's information, services and keys
            _this.saveServices(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(response.DATA, ['serviceDetails']));
            _this.saveUserKeys(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(response.DATA, ['clientAccessKeys', 'oauthKeyDetails']));
            _this.saveUserInformation(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.omit(response.DATA, ['authorizationToken', 'clientAccessKeys', 'oauthKeyDetails', 'serviceDetails']));

            // Redirect to the homepage
            _this.$router.push('/home');
          }).catch(function (response) {
            logInfo && console.log('Setting the user\'s password failed', response);
            _this.$btn.enable('.mula-btn');
            _this.showError = true;
          });
        }
      }).catch(function (reason) {
        logInfo && console.log('Validating the set password request failed', reason);
      });
    }
  }),
  name: 'Login'
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_services_auth_js__ = __webpack_require__(32);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var logInfo = !!("development" !== 'production');

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      showError: false
    };
  },


  methods: {
    recoverPassword: function recoverPassword() {
      var _this = this;

      // Reset the error alert
      this.showError = false;
      // Check that all the user is expected to
      // fill in is provided
      this.$validator.validateAll().then(function (result) {
        logInfo && console.log('Did the request to reset password pass validation?', result);

        if (result) {
          _this.$btn.disable('.mula-btn');
          // Attempt to request for a password reset
          __WEBPACK_IMPORTED_MODULE_0__api_services_auth_js__["a" /* default */].requestPasswordReset({ email: _this.email }).then(function (response) {
            logInfo && console.log('The request to reset the password was successful', response);
            _this.$snackbar.open({
              message: 'A reset password email has been successfully sent',
              type: 'is-success',
              position: 'is-bottom',
              queue: false
            });
            _this.$btn.enable('.mula-btn');
          }).catch(function (response) {
            logInfo && console.log('The reset password request failed', response);
            _this.showError = true;
            _this.$btn.enable('.mula-btn');
          });
        }
      }).catch(function (reason) {
        logInfo && console.log('Request password reset validation encountered an error', reason);
      });
    }
  },
  name: 'RecoverPassword'
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_services_auth_js__ = __webpack_require__(32);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var logInfo = !!("development" !== 'production');

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    token: function token() {
      return this.$route.params.token;
    }
  },
  data: function data() {
    return {
      password: '',
      showError: false,
      confirm_password: ''
    };
  },


  methods: {
    resetPassword: function resetPassword() {
      var _this = this;

      this.showError = false;
      // Check that all the user is expected to
      // fill in is provided
      this.$validator.validateAll().then(function (result) {
        logInfo && console.log('Did the reset password form pass validation?', result);

        if (result) {
          _this.$btn.disable('.mula-btn');
          // Attempt to reset the user's password.
          __WEBPACK_IMPORTED_MODULE_0__api_services_auth_js__["a" /* default */].resetPassword({ password: _this.password, token: _this.token }).then(function (response) {
            logInfo && console.log('Resetting the password was successful', response);
            _this.$snackbar.open({
              message: 'You have successfully reset the password',
              type: 'is-success',
              position: 'is-bottom',
              queue: true
            });
            _this.$btn.enable('.mula-btn');
            _this.$router.push('/login');
          }).catch(function (response) {
            logInfo && console.log('Resetting the password failed', response);
            _this.$btn.enable('.mula-btn');
            _this.showError = true;
          });
        }
      }).catch(function (reason) {
        logInfo && console.log('Reset password form validation encountered an error', reason);
      });
    }
  },
  name: 'ResetPassword'
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_recaptcha__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var logInfo = "development";

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { VueRecaptcha: __WEBPACK_IMPORTED_MODULE_1_vue_recaptcha__["a" /* default */] },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('registration', ['userInformation'])),

  data: function data() {
    return {
      email: '',
      full_name: '',
      password: '',
      recaptcha_token: '',
      rcapt_id: 0
    };
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('registration', ['persist']), {
    captchaExpired: function captchaExpired() {
      logInfo && console.log('The captcha just expired');
      this.$refs.recaptcha.reset();
    },
    verifyCaptcha: function verifyCaptcha(token) {
      var _this = this;

      logInfo && console.log('The user is no bot');
      logInfo && console.log('Token received is: ', token);
      this.$btn.disable('button[type="submit"]');
      this.$validator.validateAll().then(function (result) {
        logInfo && console.log('Did the user information pass validation?', result);
        if (result) {
          _this.persist({ emailAddress: _this.email, fullName: _this.full_name, password: _this.password });
          _this.$router.push('/register/business');
        } else {
          _this.$btn.enable('button[type="submit"]');
          _this.$refs.recaptcha.reset();
        }
      }).catch(function (reason) {
        logInfo && console.log('Failed to validate the user information during registration', reason);
        _this.$btn.enable('button[type="submit"]');
        _this.$refs.recaptcha.reset();
      });
    },
    submit: function submit() {
      this.$btn.disable('button[type="submit"]');
      this.$refs.recaptcha.execute();
    }
  }),
  mounted: function mounted() {
    var userInfo = this.userInformation;

    logInfo && console.log('Saved user information: ', userInfo);

    // Populate the data fields
    if (userInfo != null) {
      this.email = userInfo.emailAddress;
      this.full_name = userInfo.fullName;
      this.password = '';
    }
  },

  name: 'RegisterUser'
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_config__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_services_user__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_awesome_phonenumber__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_awesome_phonenumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_awesome_phonenumber__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var logInfo = !!("development" !== 'production');

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('registration', ['businessInformation', 'information']), {
    base_currency: function base_currency() {
      return __WEBPACK_IMPORTED_MODULE_2__api_config__["a" /* default */].CURRENCIES[this.country_of_operation];
    },
    countries: function countries() {
      return __WEBPACK_IMPORTED_MODULE_2__api_config__["a" /* default */].COUNTRIES;
    }
  }),

  data: function data() {
    return {
      business_name: '',
      country_of_operation: '',
      errorStatCode: 7,
      phone_number: '',
      showError: false
    };
  },


  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('registration', ['completeRegistration', 'persist']), {
    attachCustomValidators: function attachCustomValidators() {
      __WEBPACK_IMPORTED_MODULE_4_vee_validate__["a" /* Validator */].extend('phone_number', {
        getMessage: function getMessage(field) {
          return 'The phone number provided is not a valid phone number.';
        },
        validate: function validate(value) {
          return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
            var isPhoneNumberValid = __WEBPACK_IMPORTED_MODULE_6_awesome_phonenumber___default()('+' + value).isValid();
            resolve({
              valid: isPhoneNumberValid
            });
          });
        }
      });
    },
    back: function back() {
      this.persist({
        clientName: this.business_name,
        defaultCurrencyCode: this.base_currency !== undefined && this.base_currency !== null ? this.base_currency.code : undefined,
        businessCountryCode: this.country_of_operation,
        mobileNumber: this.phone_number
      });

      this.$router.push('/register/user');
    },
    createAccount: function createAccount() {
      var _this = this;

      this.hideErrorMsg();
      this.$btn.disable('button[type="submit"]');

      this.$validator.validateAll().then(function (result) {
        logInfo && console.log('Did the user information pass validation?', result);

        if (result) {
          _this.persist({
            clientName: _this.business_name,
            defaultCurrencyCode: _this.base_currency !== undefined && _this.base_currency !== null ? _this.base_currency.code : undefined,
            businessCountryCode: _this.country_of_operation,
            mobileNumber: _this.phone_number
          });
          __WEBPACK_IMPORTED_MODULE_3__api_services_user__["a" /* default */].create(_this.information).then(function (response) {
            logInfo && console.log('Was the account created successfully?', response.SUCCESS);
            _this.completeRegistration();
            _this.$router.push('/register/complete');
          }).catch(function (reason) {
            logInfo && console.log('Creating an account failed: ', reason);
            _this.showErrorMsg(reason);
            _this.$btn.enable('button[type="submit"]');
          });
        } else {
          _this.$btn.enable('button[type="submit"]');
        }
      }).catch(function (reason) {
        logInfo && console.log('Failed to validate the user information during registration', reason);
      });
    }
  }),
  mounted: function mounted() {
    var businessInfo = this.businessInformation;

    logInfo && console.log('Business information collected so far', businessInfo);

    // Populate the data fields
    if (businessInfo != null) {
      this.business_name = businessInfo.clientName;
      this.country_of_operation = businessInfo.businessCountryCode;
      this.phone_number = businessInfo.mobileNumber;
    }

    this.attachCustomValidators();
  },

  name: 'RegisterUser'
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var logInfo = !!("development" !== 'production');

/* harmony default export */ __webpack_exports__["a"] = ({
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      logInfo && console.log('Was the registration complete?', vm.$store.state.registration.complete);
      if (!vm.$store.state.registration.complete) {
        return next({
          path: '/register/user',
          query: {
            redirect: to.fullPath
          }
        });
      }
    });
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('registration', ['userInformation'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('registration', ['clearMemory'])),

  name: 'RegisterComplete'
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_config__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Shell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_randomstring__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_randomstring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_randomstring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_services_visits__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_utilities_Express__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_DataTable__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_DataTable__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_ComparisonData__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ComparisonBoard__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_PaymentSimulator__ = __webpack_require__(348);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















var logInfo = !!("development" !== 'production');

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'modal': __WEBPACK_IMPORTED_MODULE_4__components_Modal__["a" /* default */],
    'app-shell': __WEBPACK_IMPORTED_MODULE_5__components_Shell__["a" /* default */],
    'data-table': __WEBPACK_IMPORTED_MODULE_9__components_DataTable__["a" /* default */],
    'comparison-board': __WEBPACK_IMPORTED_MODULE_12__components_ComparisonBoard__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('services', ['currentService']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('user', ['expressKeys', 'userInfo']), {
    countries: function countries() {
      return __WEBPACK_IMPORTED_MODULE_3__api_config__["a" /* default */].COUNTRIES;
    },
    currencies: function currencies() {
      return __WEBPACK_IMPORTED_MODULE_3__api_config__["a" /* default */].CURRENCIES;
    },
    filters: function filters() {
      return [{
        label: 'Account number',
        type: 'string',
        key: 'accountNumber'
      }, {
        label: 'Amount',
        type: 'number',
        key: 'requestAmount'
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        label: 'Visit ID',
        type: 'string',
        key: 'checkoutRequestID'
      }, this._passedFilters('checkoutRequestID')), {
        label: 'Country',
        type: 'list',
        key: 'countryCode',
        list: this._prepareCountries(this.meta.countries)
      }, {
        label: 'Currency',
        type: 'list',
        key: 'originalCurrencyCode',
        list: this._prepareCurrencies(this.meta.currencies)
      }, {
        label: 'Date',
        type: 'date',
        key: 'date'
      }, {
        label: 'Mobile number',
        type: 'string',
        key: 'MSISDN'
      }, {
        label: 'Status',
        type: 'list',
        key: 'overallStatus',
        list: this._prepareStatuses(this.meta.statusCodes)
      }];
    }
  }),
  data: function data() {
    return {
      actions: [{
        name: 'View',
        event: 'view'
      }, {
        name: 'Pay',
        event: 'simulate-payment'
      }, {
        name: 'Payments',
        event: 'show-payments'
      }],
      buttons: [{
        name: 'Simulate',
        icon: 'open_in_new',
        event: 'new-visit'
      }],
      columns: {
        visitID: {
          label: 'Visit ID'
        },
        amount: {
          float: 'left',
          filter: 'money',
          label: 'Amount',
          highlight: true
        },
        currency: {
          float: 'right',
          highlight: true,
          label: ''
        },
        mobile_number: {
          filter: 'phoneNumber',
          label: 'Mobile Number'
        },
        status: {
          filter: 'capitalize'
        },
        date: {
          float: 'right',
          label: 'Date',
          type: 'date'
        },
        account_number: {
          label: 'Account Number',
          collapsed: true
        },
        conversion_rate: {
          label: 'Conversion rate',
          collapsed: true
        },
        converted_amount: {
          collapsed: true
        },
        amount_paid: {
          label: 'Amount Paid',
          collapsed: true
        },
        customer_email: {
          label: 'Customer Email',
          collapsed: true
        },
        merchant_transaction_id: {
          collapsed: true
        },
        original_amount: {
          collapsed: true
        }
      },
      newVisit: {
        accountNumber: '',
        merchantTransactionID: '',
        MSISDN: '',
        countryCode: '',
        currencyCode: '',
        amount: 100
      }
    };
  },

  methods: {
    _formatVisits: function _formatVisits(visits) {
      var structuredVisits = [];
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forIn(visits, function (visit) {
        structuredVisits.push({
          visitID: visit.checkoutRequestID,
          currency: visit.originalCurrencyCode,
          amount: visit.requestAmount,
          mobile_number: visit.MSISDN,
          status: visit.statusCodeDesc,
          date: visit.dateCreated,
          account_number: visit.accountNumber,
          customer_email: visit.customerEmail,
          merchant_transaction_id: visit.merchantTransactionID,
          conversion_rate: visit.conversionRate,
          converted_amount: visit.convertedCurrencyCode + ' ' + visit.convertedAmount,
          amount_paid: visit.convertedCurrencyCode + ' ' + (visit.amountPaid === null ? 0 : visit.amountPaid)
        });
      });
      return structuredVisits;
    },
    _passedFilters: function _passedFilters() {
      logInfo && console.log('What was the filter passed ?', this.$route.query.filter);
      if (this.$route.query.filter !== undefined) {
        return {
          mode: 'like',
          selected: true,
          value: this.$route.query.filter
        };
      }
      return {};
    },
    cancelVisitSimulator: function cancelVisitSimulator() {
      this.$modal.hide('launch-new-visit');
      // Reset the user form
      this.newVisit = {
        accountNumber: '',
        merchantTransactionID: '',
        MSISDN: '',
        countryCode: '',
        currencyCode: '',
        amount: 100
      };
    },
    launchNewVisit: function launchNewVisit() {
      // Prefill the mobile number with the user's number
      this.newVisit.MSISDN = this.userInfo.MSISDN;
      this.newVisit.countryCode = this.userInfo.businessCountryCode;
      this.newVisit.currencyCode = __WEBPACK_IMPORTED_MODULE_3__api_config__["a" /* default */].CURRENCIES[this.userInfo.businessCountryCode].code;
      // Generate the hidden fields
      this.newVisit.accountNumber = __WEBPACK_IMPORTED_MODULE_6_randomstring___default.a.generate({ length: 4, charset: 'alphabetic' }) + new Date().getTime() / 1000;
      this.$modal.show('launch-new-visit');
    },
    showPayments: function showPayments(visit) {
      logInfo && console.log('Select payments for the visit: ', visit);
      this.$router.push('/payments?filter=' + visit.visitID);
    },
    rebuildTable: function rebuildTable(filters) {
      var _this = this;

      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var rebuildFilters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var formattedFilters = this._extractFormattedFilters(filters);
      logInfo && console.log('Filters from the data table', formattedFilters);
      __WEBPACK_IMPORTED_MODULE_7__api_services_visits__["a" /* default */].whereService({ serviceCode: this.currentService.serviceCode }).fetchAll({ page: page === null ? this.page : page, filters: formattedFilters }).then(function (response) {
        logInfo && console.log('Visits fetched from the engine => ', response);
        _this.rows = _this._formatVisits(response.DATA.checkoutRequests);
        _this.page = response.DATA.page;
        _this.pageLimit = response.DATA.pageLimit;
        if (rebuildFilters) {
          _this.meta = response.DATA.metaData;
          console.log(_this.meta, "testing response");
        }
      }).catch(function (reason) {
        logInfo && console.log('Fetching visits from the engine failed => ', reason);
      });
    },
    rebuildComparisonChart: function rebuildComparisonChart(filters) {
      var _this2 = this;

      logInfo && console.log('Rebuilding the comparison chart....', filters);
      __WEBPACK_IMPORTED_MODULE_7__api_services_visits__["a" /* default */].whereService({ serviceCode: this.currentService.serviceCode }).fetchComparisonData({ filters: filters }).then(function (response) {
        logInfo && console.log('Comparison chart data received => ', response);
        _this2.comparisonData = response;
      }).catch(function (reason) {
        logInfo && console.log('Failed to rebuild the comparison chart => ', reason);
      });
    },
    redirectToCheckout: function redirectToCheckout() {
      this.$snackbar.open({
        indefinite: true,
        message: 'Redirecting to checkout in a few...',
        type: 'is-success',
        position: 'is-bottom',
        queue: false
      });
      __WEBPACK_IMPORTED_MODULE_8__api_utilities_Express__["a" /* default */].initialize({
        requestAmount: this.newVisit.amount,
        countryCode: this.newVisit.countryCode,
        currencyCode: this.newVisit.currencyCode,
        customerEmail: this.userInfo.emailAddress,
        merchantTransactionID: __WEBPACK_IMPORTED_MODULE_6_randomstring___default.a.generate({ length: 18, charset: 'alphabetic' }),
        MSISDN: this.newVisit.MSISDN,
        accountNumber: this.newVisit.accountNumber,
        serviceCode: this.currentService.serviceCode
      }).redirect({
        accessKey: this.expressKeys.access_key,
        ivKey: this.expressKeys.iv_key,
        secretKey: this.expressKeys.secret_key
      });
    },
    simulateVisitPayment: function simulateVisitPayment(event) {
      this.simulatedPayment.accountNumber = event.account_number;
      this.launchSimulator();
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_ComparisonData__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_DataTable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_PaymentSimulator__["a" /* default */]],
  mounted: function mounted() {
    this.rebuildTable(this.filters, 0, true);
    this.attachCustomValidators();
  },

  name: 'Visits'
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DataTable__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Modal__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Shell__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_services_user__ = __webpack_require__(105);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var logInfo = !!("development" !== 'production');

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'app-shell': __WEBPACK_IMPORTED_MODULE_6__components_Shell__["a" /* default */],
    'data-table': __WEBPACK_IMPORTED_MODULE_4__components_DataTable__["a" /* default */],
    'modal': __WEBPACK_IMPORTED_MODULE_5__components_Modal__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('services', ['currentService']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('user', ['clientInfo', 'userInfo'])),
  data: function data() {
    return {
      actions: [{
        name: 'Deactivate',
        event: 'deactivate-user',
        condition: {
          field: 'status',
          condition: 'isNot',
          value: 'Deactivated'
        }
      }, {
        name: 'Activate',
        event: 'activate-user',
        condition: {
          field: 'status',
          condition: 'is',
          value: 'Deactivated'
        }
      }],
      buttons: [{
        name: 'New',
        icon: 'add',
        event: 'create-user'
      }],
      columns: {
        'emailAddress': {
          highlight: true
        },
        'fullName': {
          hide: true
        },
        'roleCode': {
          hide: true
        },
        'userActive': {
          hide: true
        },
        'userID': {
          hide: true
        }
      },
      currentUser: {},
      filters: [{
        label: 'Name',
        type: 'string',
        key: 'fullName'
      }, {
        label: 'Amount',
        type: 'number',
        key: 'amount'
      }, {
        label: 'Date',
        type: 'date',
        key: 'date'
      }],
      newUser: {
        emailAddress: '',
        fullName: '',
        roleCode: ''
      },
      roles: [],
      users: []
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('auth', ['logout']), {
    _logoutIfUserSelfDeactivated: function _logoutIfUserSelfDeactivated(user) {
      if (user.userID === this.userInfo.userID) {
        this.logout();
        this.$router.push('/login');
        return true;
      }
      return false;
    },
    activateUser: function activateUser(user) {
      var _this = this;

      logInfo && console.log('Activating the user =>', user);
      // Set the default parameters for the user. TODO: Find a better way to do this
      user.clientCode = this.clientInfo.client_code;
      __WEBPACK_IMPORTED_MODULE_7__api_services_user__["a" /* default */].activateUser({ user: user }).then(function (response) {
        logInfo && console.log('Successfully deactivated user =>', { user: user, response: response });
        _this.fetchClientUsers({ clientCode: _this.clientInfo.client_code }).then(function () {
          _this.$snackbar.open({
            message: user.fullName + ' has been activated',
            type: 'is-success',
            position: 'is-bottom',
            queue: false
          });
        }).catch(function () {
          _this.$snackbar.open({
            message: 'Failed to refresh the list',
            type: 'is-warning',
            position: 'is-bottom',
            queue: false,
            actionText: 'RETRY',
            onAction: function onAction() {
              _this.fetchClientUsers({ clientCode: _this.clientInfo.client_code });
            }
          });
        });
      }).catch(function (reason) {
        logInfo && console.log('Failed to deactivate the user', { reason: reason, user: user });
        _this.$snackbar.open({
          message: user.fullName + '\'s deactivation failed',
          type: 'is-error',
          position: 'is-bottom',
          queue: false,
          actionText: 'RETRY',
          onAction: function onAction() {
            _this.activateUser(user);
          }
        });
      });
    },
    cancelUserCreation: function cancelUserCreation() {
      this.$modal.hide('create-user');
      // Reset the user form
      this.newUser = {
        emailAddress: '',
        name: '',
        role: ''
      };
    },
    cancelUserDeactivation: function cancelUserDeactivation() {
      this.$modal.hide('deactivate-user');
      // Reset the current user
      this.currentUser = {};
    },
    createUser: function createUser() {
      var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { emailAddress: '', fullName: '', roleCode: '' };

      this.newUser = user;
      this.$modal.show('create-user');
    },
    deactivateUser: function deactivateUser(user) {
      var _this2 = this;

      this.$modal.hide('deactivate-user');
      logInfo && console.log('Deactivating the user =>', user);
      // Set the default parameters for the user. TODO: Find a better way to do this
      user.clientCode = this.clientInfo.client_code;
      user.userActive = 0;
      __WEBPACK_IMPORTED_MODULE_7__api_services_user__["a" /* default */].deactivateUser({ user: user }).then(function (response) {
        logInfo && console.log('Successfully deactivated user =>', { user: user, response: response });
        if (!_this2._logoutIfUserSelfDeactivated(user)) {
          _this2.currentUser = {};
          _this2.fetchClientUsers({ clientCode: _this2.clientInfo.client_code }).then(function () {
            _this2.$snackbar.open({
              message: user.fullName + ' has been deactivated',
              type: 'is-success',
              position: 'is-bottom',
              queue: false
            });
          }).catch(function () {
            _this2.$snackbar.open({
              message: 'Failed to refresh the list',
              type: 'is-warning',
              position: 'is-bottom',
              queue: false,
              actionText: 'RETRY',
              onAction: function onAction() {
                _this2.fetchClientUsers({ clientCode: _this2.clientInfo.client_code });
              }
            });
          });
        }
      }).catch(function (reason) {
        logInfo && console.log('Failed to deactivate the user', { reason: reason, user: user });
        _this2.$snackbar.open({
          message: user.fullName + '\'s deactivation failed',
          type: 'is-error',
          position: 'is-bottom',
          queue: false,
          actionText: 'RETRY',
          onAction: function onAction() {
            _this2.deactivateUser(user);
          }
        });
        _this2.currentUser = {};
      });
    },
    fetchClientUsers: function fetchClientUsers(_ref) {
      var _this3 = this;

      var clientCode = _ref.clientCode;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__api_services_user__["a" /* default */].fetchClientUsers({ clientCode: clientCode }).then(function (response) {
          logInfo && console.log('Successfully fetched this client\'s users', response);
          _this3.roles = response.roles;
          _this3.users = response.users;
          resolve({ roles: _this3.roles, users: _this3.users });
        }).catch(function (reason) {
          logInfo && console.log('Failed to fetch this client\'s users', reason);
          reject(reason);
        });
      });
    },
    promptToDeactivateUser: function promptToDeactivateUser(user) {
      this.currentUser = user;
      this.$modal.show('deactivate-user');
    },
    saveUser: function saveUser(user) {
      var _this4 = this;

      this.$validator.validateAll().then(function (result) {
        logInfo && console.log('Did the user information pass validation?', result);
        // TODO: Find a better way to attach the default user information
        user.mobileNumber = _this4.userInfo.MSISDN;
        user.clientCode = _this4.clientInfo.client_code;
        if (result) {
          _this4.cancelUserCreation();
          __WEBPACK_IMPORTED_MODULE_7__api_services_user__["a" /* default */].inviteUser({ user: user }).then(function (response) {
            console.log(user.roleCode);
            logInfo && console.log('Successfully invited a user', response);
            _this4.$snackbar.open({
              message: user.fullName + ' has been invited',
              type: 'is-success',
              position: 'is-bottom',
              queue: false
            });
            _this4.users.push({
              name: user.fullName,
              emailAddress: user.emailAddress,
              role: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.capitalize(__WEBPACK_IMPORTED_MODULE_7__api_services_user__["a" /* default */]._retrieveRoleUsingCode(user.roleCode, _this4.roles).roleName),
              status: 'Invited',
              date: '----/--/-- --:--:--'
            });
          }).catch(function (reason) {
            logInfo && console.log('Failed to invite a user', reason);
            if (reason.STATCODE === 7) {
              _this4.$snackbar.open({
                message: user.fullName + '\'s invite failed',
                type: 'is-error',
                position: 'is-bottom',
                queue: false,
                actionText: 'RETRY',
                onAction: function onAction() {
                  _this4.createUser(user);
                }
              });
            } else {
              _this4.$snackbar.open({
                message: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.capitalize(reason.REASON),
                type: 'is-warning',
                position: 'is-bottom',
                queue: false,
                actionText: 'OK'
              });
            }
          });
        }
      }).catch(function (reason) {
        logInfo && console.log('Failed to validate the user information during invitation', reason);
      });
    }
  }),
  mounted: function mounted() {
    this.fetchClientUsers({ clientCode: this.clientInfo.client_code });
  },

  name: 'users'
});

/***/ }),
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_buefy__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_buefy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_buefy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chart_js__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_buefy_dist_buefy_css__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_buefy_dist_buefy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_buefy_dist_buefy_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_js_modal__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vee_validate__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_chartkick__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_Global__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lang_validation_en__ = __webpack_require__(656);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.














// Import the buefy styles
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_buefy___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vee_validate__["b" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_chartkick__["a" /* default */], { adapter: __WEBPACK_IMPORTED_MODULE_5_chart_js___default.a });
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_js_modal___default.a, { componentName: 'base-modal' });

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_11__mixins_Global__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_9_vee_validate__["b" /* default */].Validator.localize('en', __WEBPACK_IMPORTED_MODULE_12__lang_validation_en__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(108);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31e4f1ee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(376);
function injectStyle (ssrContext) {
  __webpack_require__(374)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31e4f1ee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 375 */,
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_utilities_Session__ = __webpack_require__(69);


var _mutations;



var LOGIN = 'LOGIN';
var LOGOUT = 'LOGOUT';
var PERSIST_TOKEN = 'PERSIST_TOKEN';
var CLEAR_TOKEN = 'CLEAR_TOKEN';

// Initial state
var state = {
  isLoggedIn: !!__WEBPACK_IMPORTED_MODULE_1__api_utilities_Session__["a" /* default */].get('token'),
  token: localStorage.getItem('token')

  // Getters
};var getters = {};

// Mutations
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, LOGIN, function (state) {
  state.isLoggedIn = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, LOGOUT, function (state) {
  state.isLoggedIn = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, PERSIST_TOKEN, function (state, token) {
  state.token = token;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, CLEAR_TOKEN, function (state) {
  state.token = null;
}), _mutations);

// Actions
var actions = {
  login: function login(_ref, token) {
    var commit = _ref.commit;

    __WEBPACK_IMPORTED_MODULE_1__api_utilities_Session__["a" /* default */].set('token', token);
    commit(LOGIN);
    commit(PERSIST_TOKEN, token);
  },

  logout: function logout(_ref2, token) {
    var commit = _ref2.commit;

    __WEBPACK_IMPORTED_MODULE_1__api_utilities_Session__["a" /* default */].remove('token');
    commit(LOGOUT);
    commit(CLEAR_TOKEN);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);




var _mutations;



var PERSIST_USER = 'PERSIST_USER';
var PERSIST_KEYS = 'PERSIST_KEYS';

// Initial state
var state = {
  keys: JSON.parse(localStorage.getItem('keys')) === null ? {} : JSON.parse(localStorage.getItem('keys')),
  user: JSON.parse(localStorage.getItem('user')) === null ? {} : JSON.parse(localStorage.getItem('user'))

  // Getters
};var getters = {
  expressKeys: function expressKeys(state) {
    if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.keys.clientAccessKeys).length > 0) {
      return {
        access_key: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keys(state.keys.clientAccessKeys)[0],
        iv_key: state.keys.clientAccessKeys[__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keys(state.keys.clientAccessKeys)[0]].ivKey,
        secret_key: state.keys.clientAccessKeys[__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keys(state.keys.clientAccessKeys)[0]].secretKey
      };
    }
    return {};
  },

  customApiKeys: function customApiKeys(state) {
    if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.keys.oauthKeyDetails).length > 0) {
      return {
        client_id: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keys(state.keys.oauthKeyDetails)[0],
        client_secret: state.keys.oauthKeyDetails[__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keys(state.keys.oauthKeyDetails)[0]].clientSecret
      };
    }
    return {};
  },

  clientInfo: function clientInfo(state) {
    return {
      client_name: state.user.clientName,
      client_code: state.user.clientCode,
      client_id: state.user.clientID,
      contactEmail: state.user.contactEmail,
      contactMsisdn: state.user.contactMsisdn,
      contactPerson: state.user.contactPerson,
      businessCountryCode: state.user.businessCountryCode
    };
  },

  userInfo: function userInfo(state) {
    return state.user;
  }

  // Mutations
};var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, PERSIST_USER, function (state, user) {
  state.user = user;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, PERSIST_KEYS, function (state, keys) {
  state.keys = keys;
}), _mutations);

// Actions
var actions = {
  saveUserInformation: function saveUserInformation(_ref, user) {
    var commit = _ref.commit;

    localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(user));
    commit(PERSIST_USER, user);
  },

  saveUserKeys: function saveUserKeys(_ref2, keys) {
    var commit = _ref2.commit;

    localStorage.setItem('keys', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(keys));
    commit(PERSIST_KEYS, keys);
  },

  updateClient: function updateClient(_ref3, client) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch,
        getters = _ref3.getters;

    var clientInformation = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge({}, getters.userInfo);
    clientInformation = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(clientInformation, client);
    dispatch('saveUserInformation', clientInformation);
  },

  updateUser: function updateUser(_ref4, user) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch,
        getters = _ref4.getters;

    var userInformation = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge({}, getters.userInfo);
    userInformation = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(userInformation, user);
    dispatch('saveUserInformation', userInformation);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);




var _mutations;

var CLEAR_PAYLOAD = 'CLEAR_PAYLOAD';
var COMPLETE_REGISTRATION = 'COMPLETE_REGISTRATION';
var PERSIST_DATA = 'PERSIST_DATA';
var RESET_REGISTRATION = 'RESET_REGISTRATION';

// Initial state
var state = {
  payload: JSON.parse(localStorage.getItem('registration_payload')) === null ? {} : JSON.parse(localStorage.getItem('registration_payload')),
  complete: false

  // Getters
};var getters = {
  completeBusiness: function completeBusiness(getters) {
    var userInfo = getters.businessInformation;
    var complete = true;
    for (var key in userInfo) {
      if (userInfo.hasOwnProperty(key) && complete) {
        complete = !(userInfo[key] === undefined || userInfo[key] === null || userInfo[key].trim() === '' || userInfo[key] === false);
      }
    }

    return complete;
  },
  completeUser: function completeUser(getters) {
    var userInfo = getters.userInformation;
    var complete = true;
    for (var key in userInfo) {
      if (userInfo.hasOwnProperty(key) && complete) {
        complete = !(userInfo[key] === undefined || userInfo[key] === null || userInfo[key].trim() === '' || userInfo[key] === false);
      }
    }

    return complete;
  },
  information: function information(state) {
    return state.payload;
  },
  userInformation: function userInformation(state) {
    if (state.payload === {}) {
      return {};
    }
    return {
      fullName: state.payload.fullName,
      emailAddress: state.payload.emailAddress
    };
  },

  businessInformation: function businessInformation(state) {
    return {
      clientName: state.payload.clientName,
      businessCountryCode: state.payload.businessCountryCode,
      mobileNumber: state.payload.mobileNumber
    };
  }

  // Mutations
};var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, CLEAR_PAYLOAD, function (state) {
  state.payload = {};
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, COMPLETE_REGISTRATION, function (state) {
  state.complete = true;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, PERSIST_DATA, function (state, payload) {
  state.payload = payload;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, RESET_REGISTRATION, function (state) {
  state.complete = false;
}), _mutations);

// Actions
var actions = {
  clearMemory: function clearMemory(_ref) {
    var commit = _ref.commit;

    commit(CLEAR_PAYLOAD);
    commit(RESET_REGISTRATION);
  },

  completeRegistration: function completeRegistration(_ref2) {
    var commit = _ref2.commit;

    commit(COMPLETE_REGISTRATION);
  },

  persist: function persist(_ref3, data) {
    var commit = _ref3.commit,
        state = _ref3.state;

    // Merge the payload with the provided data and
    // persist to local storage
    var payload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, state.payload);
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(payload, data);
    localStorage.setItem('registration_payload', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload));

    commit(PERSIST_DATA, payload);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 399 */,
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 120,
	"./af.js": 120,
	"./ar": 121,
	"./ar-dz": 122,
	"./ar-dz.js": 122,
	"./ar-kw": 123,
	"./ar-kw.js": 123,
	"./ar-ly": 124,
	"./ar-ly.js": 124,
	"./ar-ma": 125,
	"./ar-ma.js": 125,
	"./ar-sa": 126,
	"./ar-sa.js": 126,
	"./ar-tn": 127,
	"./ar-tn.js": 127,
	"./ar.js": 121,
	"./az": 128,
	"./az.js": 128,
	"./be": 129,
	"./be.js": 129,
	"./bg": 130,
	"./bg.js": 130,
	"./bm": 131,
	"./bm.js": 131,
	"./bn": 132,
	"./bn-bd": 133,
	"./bn-bd.js": 133,
	"./bn.js": 132,
	"./bo": 134,
	"./bo.js": 134,
	"./br": 135,
	"./br.js": 135,
	"./bs": 136,
	"./bs.js": 136,
	"./ca": 137,
	"./ca.js": 137,
	"./cs": 138,
	"./cs.js": 138,
	"./cv": 139,
	"./cv.js": 139,
	"./cy": 140,
	"./cy.js": 140,
	"./da": 141,
	"./da.js": 141,
	"./de": 142,
	"./de-at": 143,
	"./de-at.js": 143,
	"./de-ch": 144,
	"./de-ch.js": 144,
	"./de.js": 142,
	"./dv": 145,
	"./dv.js": 145,
	"./el": 146,
	"./el.js": 146,
	"./en-au": 147,
	"./en-au.js": 147,
	"./en-ca": 148,
	"./en-ca.js": 148,
	"./en-gb": 149,
	"./en-gb.js": 149,
	"./en-ie": 150,
	"./en-ie.js": 150,
	"./en-il": 151,
	"./en-il.js": 151,
	"./en-in": 152,
	"./en-in.js": 152,
	"./en-nz": 153,
	"./en-nz.js": 153,
	"./en-sg": 154,
	"./en-sg.js": 154,
	"./eo": 155,
	"./eo.js": 155,
	"./es": 156,
	"./es-do": 157,
	"./es-do.js": 157,
	"./es-mx": 158,
	"./es-mx.js": 158,
	"./es-us": 159,
	"./es-us.js": 159,
	"./es.js": 156,
	"./et": 160,
	"./et.js": 160,
	"./eu": 161,
	"./eu.js": 161,
	"./fa": 162,
	"./fa.js": 162,
	"./fi": 163,
	"./fi.js": 163,
	"./fil": 164,
	"./fil.js": 164,
	"./fo": 165,
	"./fo.js": 165,
	"./fr": 166,
	"./fr-ca": 167,
	"./fr-ca.js": 167,
	"./fr-ch": 168,
	"./fr-ch.js": 168,
	"./fr.js": 166,
	"./fy": 169,
	"./fy.js": 169,
	"./ga": 170,
	"./ga.js": 170,
	"./gd": 171,
	"./gd.js": 171,
	"./gl": 172,
	"./gl.js": 172,
	"./gom-deva": 173,
	"./gom-deva.js": 173,
	"./gom-latn": 174,
	"./gom-latn.js": 174,
	"./gu": 175,
	"./gu.js": 175,
	"./he": 176,
	"./he.js": 176,
	"./hi": 177,
	"./hi.js": 177,
	"./hr": 178,
	"./hr.js": 178,
	"./hu": 179,
	"./hu.js": 179,
	"./hy-am": 180,
	"./hy-am.js": 180,
	"./id": 181,
	"./id.js": 181,
	"./is": 182,
	"./is.js": 182,
	"./it": 183,
	"./it-ch": 184,
	"./it-ch.js": 184,
	"./it.js": 183,
	"./ja": 185,
	"./ja.js": 185,
	"./jv": 186,
	"./jv.js": 186,
	"./ka": 187,
	"./ka.js": 187,
	"./kk": 188,
	"./kk.js": 188,
	"./km": 189,
	"./km.js": 189,
	"./kn": 190,
	"./kn.js": 190,
	"./ko": 191,
	"./ko.js": 191,
	"./ku": 192,
	"./ku.js": 192,
	"./ky": 193,
	"./ky.js": 193,
	"./lb": 194,
	"./lb.js": 194,
	"./lo": 195,
	"./lo.js": 195,
	"./lt": 196,
	"./lt.js": 196,
	"./lv": 197,
	"./lv.js": 197,
	"./me": 198,
	"./me.js": 198,
	"./mi": 199,
	"./mi.js": 199,
	"./mk": 200,
	"./mk.js": 200,
	"./ml": 201,
	"./ml.js": 201,
	"./mn": 202,
	"./mn.js": 202,
	"./mr": 203,
	"./mr.js": 203,
	"./ms": 204,
	"./ms-my": 205,
	"./ms-my.js": 205,
	"./ms.js": 204,
	"./mt": 206,
	"./mt.js": 206,
	"./my": 207,
	"./my.js": 207,
	"./nb": 208,
	"./nb.js": 208,
	"./ne": 209,
	"./ne.js": 209,
	"./nl": 210,
	"./nl-be": 211,
	"./nl-be.js": 211,
	"./nl.js": 210,
	"./nn": 212,
	"./nn.js": 212,
	"./oc-lnc": 213,
	"./oc-lnc.js": 213,
	"./pa-in": 214,
	"./pa-in.js": 214,
	"./pl": 215,
	"./pl.js": 215,
	"./pt": 216,
	"./pt-br": 217,
	"./pt-br.js": 217,
	"./pt.js": 216,
	"./ro": 218,
	"./ro.js": 218,
	"./ru": 219,
	"./ru.js": 219,
	"./sd": 220,
	"./sd.js": 220,
	"./se": 221,
	"./se.js": 221,
	"./si": 222,
	"./si.js": 222,
	"./sk": 223,
	"./sk.js": 223,
	"./sl": 224,
	"./sl.js": 224,
	"./sq": 225,
	"./sq.js": 225,
	"./sr": 226,
	"./sr-cyrl": 227,
	"./sr-cyrl.js": 227,
	"./sr.js": 226,
	"./ss": 228,
	"./ss.js": 228,
	"./sv": 229,
	"./sv.js": 229,
	"./sw": 230,
	"./sw.js": 230,
	"./ta": 231,
	"./ta.js": 231,
	"./te": 232,
	"./te.js": 232,
	"./tet": 233,
	"./tet.js": 233,
	"./tg": 234,
	"./tg.js": 234,
	"./th": 235,
	"./th.js": 235,
	"./tk": 236,
	"./tk.js": 236,
	"./tl-ph": 237,
	"./tl-ph.js": 237,
	"./tlh": 238,
	"./tlh.js": 238,
	"./tr": 239,
	"./tr.js": 239,
	"./tzl": 240,
	"./tzl.js": 240,
	"./tzm": 241,
	"./tzm-latn": 242,
	"./tzm-latn.js": 242,
	"./tzm.js": 241,
	"./ug-cn": 243,
	"./ug-cn.js": 243,
	"./uk": 244,
	"./uk.js": 244,
	"./ur": 245,
	"./ur.js": 245,
	"./uz": 246,
	"./uz-latn": 247,
	"./uz-latn.js": 247,
	"./uz.js": 246,
	"./vi": 248,
	"./vi.js": 248,
	"./x-pseudo": 249,
	"./x-pseudo.js": 249,
	"./yo": 250,
	"./yo.js": 250,
	"./zh-cn": 251,
	"./zh-cn.js": 251,
	"./zh-hk": 252,
	"./zh-hk.js": 252,
	"./zh-mo": 253,
	"./zh-mo.js": 253,
	"./zh-tw": 254,
	"./zh-tw.js": 254
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 400;

/***/ }),
/* 401 */,
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Activate_vue__ = __webpack_require__(256);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5977f896_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Activate_vue__ = __webpack_require__(449);
function injectStyle (ssrContext) {
  __webpack_require__(403)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Activate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5977f896_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Activate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activate"},[_c('div',{staticClass:"activate__container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"activate__card"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"align-items-center col-12 d-flex justify-content-center"},[(_vm.status === 'pending')?_c('i',{staticClass:"material-icons",attrs:{"id":"activation-pending-icon"}},[_vm._v("sync")]):_vm._e(),_vm._v(" "),(_vm.status === 'success')?_c('i',{staticClass:"material-icons",attrs:{"id":"activation-succeded-icon"}},[_vm._v("thumb_up_alt")]):_vm._e(),_vm._v(" "),(_vm.status === 'failed')?_c('i',{staticClass:"material-icons",attrs:{"id":"activation-failed-icon"}},[_vm._v("thumb_down_alt")]):_vm._e(),_vm._v(" "),_c('br')])]),_vm._v(" "),(_vm.status === 'pending')?_c('h4',{staticClass:"activate__card-title text-uppercase"},[_vm._v("Activating your account")]):_vm._e(),_vm._v(" "),(_vm.status === 'success')?_c('h4',{staticClass:"activate__card-title text-uppercase"},[_vm._v("Account activated")]):_vm._e(),_vm._v(" "),(_vm.status === 'failed')?_c('h4',{staticClass:"activate__card-title text-uppercase"},[_vm._v("Account activation failed")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[(_vm.status === 'pending')?_c('p',{staticClass:"text-center text-muted"},[_vm._v("\n            Your account is currently being verified, this will take a few seconds.\n          ")]):_vm._e(),_vm._v(" "),(_vm.status === 'failed')?_c('p',{staticClass:"text-center text-muted"},[_vm._v("\n            Your account could not be verified. Check whether the link was copied correctly.\n          ")]):_vm._e(),_vm._v(" "),(_vm.status === 'success')?_c('p',{staticClass:"text-center text-muted"},[_vm._v("\n            Your account has been successfully activated. Login to start integrating your application to Mula.\n          ")]):_vm._e()])]),_vm._v(" "),(_vm.status === 'success')?_c('form',{attrs:{"id":"activation-page-login-button","novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.$router.push('/home')}}},[_c('button',{staticClass:"mula-btn mula-btn--primary",attrs:{"type":"submit"}},[_vm._v("\n          Login\n        ")])]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activate__brand"},[_c('img',{staticClass:"tingg-brand-logo",attrs:{"src":"https://developer.tingg.africa/checkout/v2/assets/images/tingg/tingg_white.png","height":"64","alt":"Tingg"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateService_vue__ = __webpack_require__(269);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0437114e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateService_vue__ = __webpack_require__(467);
function injectStyle (ssrContext) {
  __webpack_require__(451)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0437114e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateService_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0437114e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateService_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 451 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__ = __webpack_require__(270);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be7b55ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__ = __webpack_require__(454);
function injectStyle (ssrContext) {
  __webpack_require__(453)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be7b55ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 453 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonClass,attrs:{"type":_vm.type}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}]},[_vm._t("default")],2),_vm._v(" "),_c('i',{staticClass:"fas fa-spinner fa-spin"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ml-group"},[_c('div',{staticClass:"d-flex align-items-center justify-content-between mt-2"},[_c('div',{staticClass:"ml-group__header"},[_c('div',{staticClass:"ml-group__title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('div',{staticClass:"ml-group__subtitle",domProps:{"innerHTML":_vm._s(_vm.subtitle)}})]),_vm._v(" "),_c('div',{staticClass:"ml-group__legend"},[_vm._t("legend")],2)]),_vm._v(" "),_vm._t("content")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 458 */,
/* 459 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-modal',{attrs:{"height":_vm.height,"name":_vm.name,"width":_vm.width},on:{"closed":function($event){return _vm.$emit('cancel')}}},[_c('div',{staticClass:"ml-modal__container"},[_c('div',{staticClass:"ml-modal__title text-center",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"ml-modal__footer"},[_c('button',{staticClass:"ml-btn ml-btn--white",on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v(_vm._s(_vm.cancelText))]),_vm._v(" "),_c('button',{staticClass:"ml-btn tingg-primary-button",on:{"click":function($event){return _vm.$emit('save')}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.noIcon),expression:"noIcon"}],class:("fas fa-chevron-" + _vm.actionIcon)}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.action))])])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shell",class:{ 'shell--minimized': _vm.loading }},[_c('div',{staticClass:"sidebar"},[_c('nav',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"services-nav",class:{ active: _vm.servicesNavState },on:{"click":function($event){return _vm.toggleServicesNav()}}},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col d-flex align-items-center justify-content-between services-nav__services-dropdown",class:{ 'ml-text-hidden': _vm.loading }},[_c('span',{attrs:{"id":"service-name-display"}},[_vm._v(_vm._s(_vm.currentService.serviceName))]),_vm._v(" "),_c('i',{staticClass:"material-icons"},[_vm._v("expand_more")])])]),_vm._v(" "),_c('div',{staticClass:"row no-gutters"},[_c('div',{class:[
            'col',
            'mt-1',
            'services-nav__service-code',
            { 'ml-text-hidden': _vm.loading } ]},[_c('span',[_vm._v("CODE: "+_vm._s(_vm.currentService.serviceCode))])])]),_vm._v(" "),_c('div',{staticClass:"active-show"},[_c('ul',{staticClass:"services-nav__nav-list"},[_c('li',{staticClass:"list-title"},[_vm._v("Your services")]),_vm._v(" "),_vm._l((_vm.allServices),function(service){return _c('li',{key:("#" + (service.serviceName)),on:{"click":function($event){return _vm.pickService(service)}}},[_vm._v("\n            "+_vm._s(service.serviceName)+"\n          ")])})],2),_vm._v(" "),_c('ul',{staticClass:"services-nav__nav-list"},[_c('li',{on:{"click":_vm.createService}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")]),_vm._v(" "),_c('span',[_vm._v("New Service")])])]),_vm._v(" "),_c('ul',{staticClass:"services-nav__nav-list"},[_c('li',{on:{"click":_vm.triggerModal}},[_c('i',{staticClass:"material-icons"},[_vm._v("security")]),_vm._v(" "),_c('span',[_vm._v("Reset Password")])])]),_vm._v(" "),_c('ul',{staticClass:"services-nav__nav-list"},[_c('li',{on:{"click":_vm.logoutUser}},[_c('i',{staticClass:"material-icons"},[_vm._v("exit_to_app")]),_vm._v(" "),_c('span',[_vm._v("Logout")])])])])]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"sidenav-list-item"},[_c('li',{staticClass:"sidenav-list-item__item",on:{"click":function($event){return _vm.goTo('/home')}}},[_c('div',{class:{ 'ml-text-blurred': _vm.loading }},[_c('i',{staticClass:"material-icons-round"},[_vm._v("home")]),_vm._v(" "),_c('span',[_vm._v("Home")])])]),_vm._v(" "),_c('li',{staticClass:"sidenav-list-item__item",on:{"click":function($event){return _vm.openTinggDocumentation()}}},[_c('div',{class:{ 'ml-text-blurred': _vm.loading }},[_c('i',{staticClass:"material-icons-outlined"},[_vm._v("map")]),_vm._v(" "),_c('span',[_vm._v("Documentation")])])]),_vm._v(" "),_c('li',{staticClass:"sidenav-list-item__title"},[_vm._v("Analytics")]),_vm._v(" "),_c('li',{staticClass:"sidenav-list-item__item",on:{"click":function($event){return _vm.goTo('/visits')}}},[_c('div',{class:{ 'ml-text-blurred': _vm.loading }},[_c('i',{staticClass:"material-icons"},[_vm._v("timeline")]),_vm._v(" "),_c('span',[_vm._v("Customer visits")])])]),_vm._v(" "),_c('li',{staticClass:"sidenav-list-item__item",on:{"click":function($event){return _vm.goTo('/payments')}}},[_c('div',{class:{ 'ml-text-blurred': _vm.loading }},[_c('i',{staticClass:"material-icons"},[_vm._v("receipt")]),_vm._v(" "),_c('span',[_vm._v("Customer payments")])])]),_vm._v(" "),_c('li',{staticClass:"sidenav-list-item__title"},[_vm._v("Configurations")]),_vm._v(" "),_c('li',{staticClass:"sidenav-list-item__item",on:{"click":function($event){return _vm.goTo('/payment/options')}}},[_c('div',{class:{ 'ml-text-blurred': _vm.loading }},[_c('i',{staticClass:"material-icons-outlined"},[_vm._v("account_balance_wallet")]),_vm._v(" "),_c('span',[_vm._v("Payment options")])])]),_vm._v(" "),_c('li',{staticClass:"sidenav-list-item__item",on:{"click":function($event){return _vm.goTo('/users')}}},[_c('div',{class:{ 'ml-text-blurred': _vm.loading }},[_c('i',{staticClass:"material-icons-outlined"},[_vm._v("people")]),_vm._v(" "),_c('span',[_vm._v("Users")])])]),_vm._v(" "),_c('li',{staticClass:"sidenav-list-item__item",on:{"click":function($event){return _vm.goTo('/profile')}}},[_c('div',{class:{ 'ml-text-blurred': _vm.loading }},[_c('i',{staticClass:"material-icons-outlined"},[_vm._v("account_circle")]),_vm._v(" "),_c('span',[_vm._v("Profile")])])])])]),_vm._v(" "),_c('div',{staticClass:"shell-content"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('modal',{attrs:{"action":"Proceed","no-icon":false,"name":"reset-password","title":"<strong>Reset Password?</strong>"},on:{"cancel":_vm.cancelPasswordReset,"save":_vm.requestPasswordReset}},[_c('div',{staticClass:"form-group",staticStyle:{"text-align":"center"}},[_c('label',{staticClass:"control-label",attrs:{"for":"user_email"}},[_vm._v("Click proceed to reset your password and check your email address\n        below.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.emailAddress),expression:"userInfo.emailAddress"}],staticClass:"form-control",staticStyle:{"text-align":"center"},attrs:{"type":"email","name":"user_email","id":"user_email","readonly":""},domProps:{"value":(_vm.userInfo.emailAddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo, "emailAddress", $event.target.value)}}})])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row no-gutters ml-offline__banner"},[_c('div',{staticClass:"align-items-center col d-flex justify-content-center"},[_c('div',{staticClass:"ml-offline__banner-text"},[_vm._v("\n          You are offline. Please check your internet connection.\n        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"ml-breadcrumb"},[_c('span',{staticStyle:{"display":"flex","align-items":"center"},attrs:{"id":"breadcrumbs"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Step_vue__ = __webpack_require__(274);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_988d2004_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Step_vue__ = __webpack_require__(464);
function injectStyle (ssrContext) {
  __webpack_require__(463)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Step_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_988d2004_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Step_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step",class:_vm.customClass},[_c('div',{staticClass:"align-items-center d-flex justify-content-start step__header"},[_c('div',{staticClass:"step__number mb-1"},[_c('span',{staticClass:"step__number__count",domProps:{"innerHTML":_vm._s(_vm.step)}})]),_vm._v(" "),_c('div',{staticClass:"step__details"},[_c('h4',{staticClass:"mb-1 step__title text-dark",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('p',{staticClass:"mb-0 step__sub-title subtle-text",domProps:{"innerHTML":_vm._s(_vm.subTitle)}})])]),_vm._v(" "),_c('div',{staticClass:"ml-5"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 465 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'ml-pom__container': true,
    'ml-pom--editable': _vm.editable,
    'ml-pom--selected': _vm.active,
    'ml-pom--syncing': _vm.syncing
  }},[_c('div',{staticClass:"ml-pom__side-panel"},[_c('div',{staticClass:"ml-pom__check-icon mb-1 mr-2",on:{"click":_vm.raiseEvent}},[_c('div',{staticClass:"ml-pom__check-icon__center"})]),_vm._v(" "),_c('div',{staticClass:"ml-pom__toggles"},[_c('button',{staticClass:"ml-pom__toggle ml-btn ml-btn--white",on:{"click":_vm.toggleEditability}},[_c('i',{staticClass:"fas fa-pencil-alt"})])])]),_vm._v(" "),_c('div',{staticClass:"ml-pom__main-panel",on:{"click":_vm.raiseEvent}},[_c('div',{staticClass:"ml-pom__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('img',{staticClass:"ml-pom__img",attrs:{"alt":_vm.title,"src":_vm.imageSource}}),_vm._v(" "),_c('div',{staticClass:"ml-pom__mode text-muted"},[_vm._v(_vm._s(_vm.paymentMode.paymentModeName))])]),_vm._v(" "),_c('modal',{attrs:{"action":"Save","name":("payment-option#" + (_vm.paymentOption.countryPayerClientID)),"no-icon":false,"title":("Configure <b>" + _vm.title + "</b>")},on:{"cancel":_vm.cancelEdit,"save":_vm.saveEdit}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"role"}},[_vm._v("Payment Mode")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPayerMode),expression:"selectedPayerMode"}],staticClass:"form-control",attrs:{"id":"role","name":"role"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedPayerMode=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.paymentOption.paymentModes),function(mode,index){return _c('option',{key:(index + "@" + (mode.payerModeID)),domProps:{"value":parseInt(mode.payerModeID)}},[_vm._v("\n          "+_vm._s(mode.paymentModeName)+"\n        ")])}),0)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-shell',{attrs:{"loading":true}},[_c('div',{staticClass:"create-service px-5"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.createService($event)}}},[_c('div',{staticClass:"align-items-start create-service__toolbar d-flex fixed-top justify-content-between row no-gutters mb-5"},[_c('div',{staticClass:"col-md-5"},[_c('h3',{staticClass:"mb-2 create-service__title text-left"},[_vm._v("Let's get you all setup")]),_vm._v(" "),_c('p',{staticClass:"create-service__sub-title mt-1 text-muted text-left"},[_vm._v("\n            You require to setup a service and assign it payment options in order to\n            start collecting payments on mula checkout\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('div',{staticClass:"align-items-start d-flex justify-content-end ml-btn-group pt-1"},[_c('button',{staticClass:"ml-btn ml-btn--md tingg-primary-button",attrs:{"type":"submit"}},[_vm._v("Create")]),_vm._v(" "),_c('button',{staticClass:"ml-btn ml-btn--md ml-btn--white",attrs:{"type":"button"},on:{"click":_vm.quitCreatingService}},[_vm._v("\n              Cancel\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"no-gutters row space-from-fixed-top"},[_c('ml-step',{attrs:{"custom-class":"col-12","step":"1","sub-title":"Provide information of the service your users will be paying","title":"Create service"}},[_c('div',{staticClass:"row no-gutters mt-3 mb-4"},[_c('div',{staticClass:"col-6"},[_c('div',{class:{'form-group': true, 'has-error': _vm.errors.has('service_name') }},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:3'),expression:"'required|min:3'"},{name:"model",rawName:"v-model",value:(_vm.service_name),expression:"service_name"}],staticClass:"mula-form-group__input form-control",attrs:{"id":"service_name","name":"service_name","placeholder":"Service name","type":"text","autocomplete":"service_name"},domProps:{"value":(_vm.service_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.service_name=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('service_name')),expression:"errors.has('service_name')"}],staticClass:"help is-danger"},[_vm._v("\n            "+_vm._s(_vm.errors.first('service_name'))+"\n          ")])])])])])],1)]),_vm._v(" "),_c('div',{staticClass:"mt-4 no-gutters row"},[_c('ml-step',{attrs:{"custom-class":"col-12","step":"2","sub-title":"Pick the payment options and type of payment method you want your users to use","title":"Select Payment options"}},[_c('div',{staticClass:"ml-pol"},_vm._l((_vm.options),function(country){return _c('div',{staticClass:"ml-pol__item"},[_c('div',{staticClass:"ml-pol__item__title"},[_vm._v("\n              "+_vm._s(country.title)+"\n            ")]),_vm._v(" "),_c('ul',{staticClass:"ml-pol__item-list"},_vm._l((country.options),function(option){return _c('li',{staticClass:"ml-pol__item-list__item"},[_c('payment-option-manager',{attrs:{"image-source":((_vm.logoUrls['KE']) + "/" + (option.clientLogo)),"selected":option.optionEnabled,"title":option.clientDisplayName,"payment-option":option},on:{"option-activated":_vm.addPaymentOption,"option-deactivated":_vm.removePaymentOption,"option-updated":_vm.updatePaymentOption}})],1)}),0)])}),0)])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Documentation_vue__ = __webpack_require__(278);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6f59fe6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Documentation_vue__ = __webpack_require__(470);
function injectStyle (ssrContext) {
  __webpack_require__(469)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Documentation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6f59fe6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Documentation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-shell',{attrs:{"breadcrumbs":"Documentation"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('iframe',{staticStyle:{"width":"100%","height":"99vh","align-content":"center","text-align":"center"},attrs:{"src":"https://tingg.gitbook.io/checkout/"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(279);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1e77bbc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(480);
function injectStyle (ssrContext) {
  __webpack_require__(472)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e1e77bbc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1e77bbc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeveloperKey_vue__ = __webpack_require__(280);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5288b59d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeveloperKey_vue__ = __webpack_require__(476);
function injectStyle (ssrContext) {
  __webpack_require__(474)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeveloperKey_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5288b59d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeveloperKey_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 475 */,
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"developer-key",style:(("width: " + _vm.width + "%"))},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":_vm.id},domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('div',{staticClass:"developer-key__description text-muted",domProps:{"innerHTML":_vm._s(_vm.description)}}),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"mula-form-group__input form-control",attrs:{"readonly":"","type":"text","id":_vm.id},domProps:{"value":_vm.value}}),_vm._v(" "),_c('div',{class:_vm.copyButtonClass(),attrs:{"id":"copy-button","data-clipboard-text":_vm.value}},[_c('span',{staticClass:"input-group-text"},[_vm._v("COPY")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollapsibleCard_vue__ = __webpack_require__(281);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92d2552e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollapsibleCard_vue__ = __webpack_require__(479);
function injectStyle (ssrContext) {
  __webpack_require__(478)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-92d2552e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollapsibleCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92d2552e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollapsibleCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 478 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ml-card ml-card--collapsible"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.collapsed),expression:"!collapsed"}]},[_vm._t("default")],2),_vm._v(" "),_c('h3',{directives:[{name:"show",rawName:"v-show",value:(_vm.collapsed),expression:"collapsed"}],staticClass:"ml-card__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.collapsed),expression:"!collapsed"}],staticClass:"ml-card__toggle",attrs:{"id":"collapsible-hide-trigger"},on:{"click":function($event){return _vm.toggleCollapsible()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("expand_less")]),_vm._v(" "),_c('span',[_vm._v("Hide")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.collapsed),expression:"collapsed"}],staticClass:"ml-card__toggle",attrs:{"id":"collapsible-show-trigger"},on:{"click":function($event){return _vm.toggleCollapsible()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("expand_more")]),_vm._v(" "),_c('span',[_vm._v("Show")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-shell',{attrs:{"breadcrumbs":"Home"}},[_c('div',{staticClass:"row no-gutters mt-4"},[_c('div',{staticClass:"col-12"},[_c('collapsible-card',{attrs:{"title":"Welcome to Tingg Developer Portal","collapsible":"true"}},[_c('div',{staticClass:"ml-jumbotron"},[_c('div',{staticClass:"ml-jumbotron__title"},[_vm._v("\n            Welcome to Tingg Developer Portal\n          ")]),_vm._v(" "),_c('div',{staticClass:"ml-jumbotron__body"},[_c('div',{staticClass:"ml-jumbotron__icon-list"},[_c('div',{staticClass:"icon-list-item router-link-item",on:{"click":function($event){return _vm.goTo('/documentation/express')}}},[_c('div',{staticClass:"icon-list-item__icon"},[_c('i',{staticClass:"material-icons-outlined"},[_vm._v("map")])]),_vm._v(" "),_c('div',{staticClass:"icon-list-item__title"},[_vm._v("\n                  Learn your way around\n                ")]),_vm._v(" "),_c('div',{staticClass:"icon-list-item__content"},[_vm._v("\n                  Read our docs and be guided on how you will integrate our checkout to your web or mobile application\n                ")])]),_vm._v(" "),_c('div',{staticClass:"icon-list-item router-link-item",on:{"click":function($event){return _vm.goTo('/visits')}}},[_c('div',{staticClass:"icon-list-item__icon"},[_c('i',{staticClass:"material-icons"},[_vm._v("timeline")])]),_vm._v(" "),_c('div',{staticClass:"icon-list-item__title"},[_vm._v("\n                  Track customer visits\n                ")]),_vm._v(" "),_c('div',{staticClass:"icon-list-item__content"},[_vm._v("\n                  Track the behaviour of your customers on checkout and get a view of their\n                  preferences and track the effects of your changes\n                ")])]),_vm._v(" "),_c('div',{staticClass:"icon-list-item router-link-item",on:{"click":function($event){return _vm.goTo('/users')}}},[_c('div',{staticClass:"icon-list-item__icon"},[_c('i',{staticClass:"material-icons-outlined"},[_vm._v("people")])]),_vm._v(" "),_c('div',{staticClass:"icon-list-item__title"},[_vm._v("\n                  Manage your team\n                ")]),_vm._v(" "),_c('div',{staticClass:"icon-list-item__content"},[_vm._v("\n                  Manage your team by adding or removing users that can access this portal\n                  or changing their roles.\n                ")])]),_vm._v(" "),_c('div',{staticClass:"icon-list-item router-link-item",on:{"click":function($event){return _vm.goTo('/payment/options')}}},[_c('div',{staticClass:"icon-list-item__icon"},[_c('i',{staticClass:"material-icons-outlined"},[_vm._v("account_balance_wallet")])]),_vm._v(" "),_c('div',{staticClass:"icon-list-item__title"},[_vm._v("\n                  Manage your payment options\n                ")]),_vm._v(" "),_c('div',{staticClass:"icon-list-item__content"},[_vm._v("\n                  Manage the payment options for your service and determine how your\n                  customer will pay for your service\n                ")])])])])])]),_vm._v(" "),_c('hr',{staticClass:"divider mt-5 mb-4"})],1)]),_vm._v(" "),_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-12"},[_c('ml-group',{attrs:{"title":"General keys"}},[_c('template',{slot:"content"},[_c('div',{staticClass:"key-list"},[_c('developer-key',{attrs:{"title":"Service Code","description":("<b>" + (_vm.currentService.serviceName) + "</b>'s service code"),"value":_vm.currentService.serviceCode}}),_vm._v(" "),_c('developer-key',{attrs:{"title":"Client Code","description":"Your business client code","id":"express_checkout_id","value":_vm.clientInfo.client_code}})],1)])],2)],1)]),_vm._v(" "),_c('div',{staticClass:"row no-gutters my-4"},[_c('div',{staticClass:"col-12"},[_c('ml-group',{attrs:{"title":"Express checkout keys"}},[_c('template',{slot:"content"},[_c('div',{staticClass:"key-list"},[_c('developer-key',{attrs:{"title":"IV Key","description":"This is one of the pair of keys you need to encrypt your data","value":_vm.expressKeys.iv_key}}),_vm._v(" "),_c('developer-key',{attrs:{"title":"Secret Key","description":"This is one of the pair of keys you need to encrypt your data","value":_vm.expressKeys.secret_key}}),_vm._v(" "),_c('developer-key',{attrs:{"title":"Access Key","description":"Pass this key when you are sending the parameters to checkout","value":_vm.expressKeys.access_key,"width":100}})],1)])],2)],1)]),_vm._v(" "),_c('div',{staticClass:"row no-gutters my-4"},[_c('div',{staticClass:"col-12"},[_c('ml-group',{attrs:{"title":"Custom API keys"}},[_c('template',{slot:"content"},[_c('div',{staticClass:"key-list"},[_c('developer-key',{attrs:{"title":"Client ID","description":"You use this as one of the pair of keys you need to generate an access token","value":_vm.customApiKeys.client_id}}),_vm._v(" "),_c('developer-key',{attrs:{"title":"Client Secret","description":"This is one of the pair of keys you need to encrypt your data","value":_vm.customApiKeys.client_secret}})],1)])],2)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(282);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12da874e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(483);
function injectStyle (ssrContext) {
  __webpack_require__(482)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12da874e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 482 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"login__container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"login__card"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showError),expression:"showError"}],staticClass:"help-text tingg-error-help",staticStyle:{"display":"none"}},[_c('span',[_vm._v("Your credentials don't match our records")])]),_vm._v(" "),_c('h3',{staticClass:"login__card-title"},[_vm._v("Sign In")]),_vm._v(" "),_c('form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.signIn($event)}}},[_c('div',{class:{'form-group': true, 'has-error': _vm.errors.has('email') }},[_c('label',{staticClass:"mula-form-group__label control-label",attrs:{"for":"email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, email: true}),expression:"{required: true, email: true}"},{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"mula-form-group__input form-control",attrs:{"id":"email","name":"email","type":"email","autocomplete":"email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"help tingg-validation-error"},[_vm._v("Your email is required")])]),_vm._v(" "),_c('div',{class:{'form-group': true, 'has-error': _vm.errors.has('password') }},[_c('label',{staticClass:"mula-form-group__label control-label",attrs:{"for":"password"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, min:5}),expression:"{required: true, min:5}"},{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"mula-form-group__input form-control",attrs:{"id":"password","name":"password","type":"password","autocomplete":"password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password')),expression:"errors.has('password')"}],staticClass:"help tingg-validation-error"},[_vm._v(_vm._s(_vm.errors.first('password')))])]),_vm._v(" "),_c('div',{staticClass:"login__forgot-password"},[_c('a',{staticClass:"tingg-anchors",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.goTo('recover/password')}}},[_vm._v("Forgot password?")])]),_vm._v(" "),_c('button',{staticClass:"mula-btn tingg-primary-button ladda-button",attrs:{"data-style":"zoom-in","type":"submit"}},[_vm._v("Login")])]),_vm._v(" "),_c('div',{staticClass:"login__optional-cta"},[_c('span',[_vm._v("Don't have an account?")]),_vm._v(" "),_c('a',{staticClass:"tingg-anchors",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.goTo('/register/user')}}},[_vm._v("Register")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login__brand"},[_c('img',{staticClass:"tingg-brand-logo",attrs:{"src":"https://developer.tingg.africa/checkout/v2/web-assets/images/tingg-logo-white.svg","height":"64","alt":"Tingg"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundComponent_vue__ = __webpack_require__(283);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b861683c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundComponent_vue__ = __webpack_require__(486);
function injectStyle (ssrContext) {
  __webpack_require__(485)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b861683c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b861683c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 485 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',[_vm._m(0),_vm._v(" "),_c('p',[_c('a',{staticClass:"text-white",on:{"click":function () { _vm.goTo('home') }}},[_vm._v("Take me home "),_c('i',{staticClass:"material-icons"},[_vm._v("home")])]),_vm._v(" "),_c('span',[_vm._v("  |  ")]),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_c('span',[_vm._v("Page Not Found")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"text-white",attrs:{"href":"mailto:support@cellulant.io"}},[_vm._v("Report issue "),_c('i',{staticClass:"material-icons"},[_vm._v("error_outline")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payments_vue__ = __webpack_require__(284);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63c638d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payments_vue__ = __webpack_require__(604);
function injectStyle (ssrContext) {
  __webpack_require__(488)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63c638d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 489 */,
/* 490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */,
/* 492 */,
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popover_vue__ = __webpack_require__(286);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2fefef0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popover_vue__ = __webpack_require__(495);
function injectStyle (ssrContext) {
  __webpack_require__(494)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popover_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2fefef0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popover_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"popover-container",style:(_vm.position)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ml-data-table ml-card--depth"},[_c('div',{staticClass:"ml-data-table__toolbar"},[_c('div',{attrs:{"id":"datatable-toolbar-left"}},[_c('button',{staticClass:"ml-data-table__toolbar__action",on:{"click":_vm.toggleFilter}},[_c('i',{staticClass:"material-icons"},[_vm._v("filter_list")]),_vm._v(" "),_c('span',[_vm._v("Filter")]),_vm._v(" "),(_vm.numberOfFilters > 0)?_c('span',{staticClass:"ml-data-table__filter__filters-number"},[_vm._v(_vm._s(_vm.numberOfFilters))]):_vm._e()]),_vm._v(" "),_c('pop-over',{attrs:{"event":_vm.filterEvent,"show":_vm.showFilter}},[_c('div',{staticClass:"ml-data-table__filter"},[_c('div',{staticClass:"d-flex align-items-center justify-content-between ml-data-table__filter__head"},[_c('button',{staticClass:"ml-btn ml-btn--white ml-btn--sm",on:{"click":_vm.clearFilters}},[_vm._v("Clear")]),_vm._v(" "),_c('div',{staticClass:"ml-data-table__filter__title"},[_vm._v("Filter")]),_vm._v(" "),_c('button',{staticClass:"ml-btn ml-btn--primary ml-btn--sm",on:{"click":_vm.performFilter}},[_vm._v("Done")])]),_vm._v(" "),_c('div',{staticClass:"ml-data-table__filter__body"},[_c('ul',{staticClass:"filter-list"},_vm._l((_vm.tableFilters),function(filter,index){return _c('li',{key:index,staticClass:"filter-list__item"},[_c('div',{staticClass:"filter-list__item-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(filter.selected),expression:"filter.selected"}],attrs:{"type":"checkbox","id":filter.key},domProps:{"checked":Array.isArray(filter.selected)?_vm._i(filter.selected,null)>-1:(filter.selected)},on:{"change":function($event){var $$a=filter.selected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(filter, "selected", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(filter, "selected", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(filter, "selected", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"mb-0",attrs:{"for":filter.key}},[_vm._v("\n                    "+_vm._s(filter.label)+"\n                  ")])]),_vm._v(" "),(filter.selected && filter.type === 'date')?_c('div',{staticClass:"filter-list__item-form d-flex flex-column justify-content-between"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(filter.mode),expression:"filter.mode"}],attrs:{"name":("filter-" + (filter.label)),"id":("id-" + (filter.label))},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(filter, "mode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"dateBetween"}},[_vm._v("is between")]),_vm._v(" "),_c('option',{attrs:{"value":"dateLessThan"}},[_vm._v("is before")]),_vm._v(" "),_c('option',{attrs:{"value":"dateGreaterThan"}},[_vm._v("is after")])]),_vm._v(" "),_c('div',{staticClass:"w-100 d-flex align-items-start pt-3 filter-list_item-form-input-container"},[(filter.mode === "dateLessThan" || filter.mode === "dateGreaterThan")?_c('b-datepicker',{staticClass:"px-1 w-50",attrs:{"placeholder":"","icon":"calendar-today"},model:{value:(filter.value),callback:function ($$v) {_vm.$set(filter, "value", $$v)},expression:"filter.value"}}):_vm._e(),_vm._v(" "),(filter.mode === "dateBetween")?_c('b-datepicker',{staticClass:"px-1 w-50",attrs:{"placeholder":"","icon":"calendar-today"},model:{value:(filter.min),callback:function ($$v) {_vm.$set(filter, "min", $$v)},expression:"filter.min"}}):_vm._e(),_vm._v(" "),(filter.mode === "dateBetween")?_c('span',{staticClass:"mx-3"},[_vm._v("to")]):_vm._e(),_vm._v(" "),(filter.mode === "dateBetween")?_c('b-datepicker',{staticClass:"px-1 w-50",attrs:{"placeholder":"","icon":"calendar-today"},model:{value:(filter.max),callback:function ($$v) {_vm.$set(filter, "max", $$v)},expression:"filter.max"}}):_vm._e()],1)]):_vm._e(),_vm._v(" "),(filter.selected && filter.type === 'number')?_c('div',{staticClass:"filter-list__item-form d-flex flex-column justify-content-between"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(filter.mode),expression:"filter.mode"}],attrs:{"name":("filter-" + (filter.label)),"id":("id-" + (filter.label))},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(filter, "mode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"between"}},[_vm._v("is between")]),_vm._v(" "),_c('option',{attrs:{"value":"lessThan"}},[_vm._v("is less than")]),_vm._v(" "),_c('option',{attrs:{"value":"greaterThan"}},[_vm._v("is greater than")])]),_vm._v(" "),_c('div',{staticClass:"w-100 d-flex align-items-start pt-3 filter-list_item-form-input-container"},[(filter.mode === "lessThan" || filter.mode === "greaterThan")?_c('input',{directives:[{name:"model",rawName:"v-model",value:(filter.value),expression:"filter.value"}],staticClass:"px-1 w-50",attrs:{"type":"number"},domProps:{"value":(filter.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(filter, "value", $event.target.value)}}}):_vm._e(),_vm._v(" "),(filter.mode === "between")?_c('input',{directives:[{name:"model",rawName:"v-model",value:(filter.min),expression:"filter.min"}],staticClass:"px-1 w-50",attrs:{"type":"number"},domProps:{"value":(filter.min)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(filter, "min", $event.target.value)}}}):_vm._e(),_vm._v(" "),(filter.mode === "between")?_c('span',{staticClass:"mx-3"},[_vm._v("to")]):_vm._e(),_vm._v(" "),(filter.mode === "between")?_c('input',{directives:[{name:"model",rawName:"v-model",value:(filter.max),expression:"filter.max"}],staticClass:"px-1 w-50",attrs:{"type":"number"},domProps:{"value":(filter.max)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(filter, "max", $event.target.value)}}}):_vm._e()])]):_vm._e(),_vm._v(" "),(filter.selected && filter.type === 'string')?_c('div',{staticClass:"filter-list__item-form d-flex flex-column justify-content-between"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(filter.mode),expression:"filter.mode"}],attrs:{"name":("filter-" + (filter.label)),"id":("id-" + (filter.label))},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(filter, "mode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"like"}},[_vm._v("is like")]),_vm._v(" "),_c('option',{attrs:{"value":"exact"}},[_vm._v("is exactly")])]),_vm._v(" "),_c('div',{staticClass:"w-100 d-flex align-items-start pt-3 filter-list_item-form-input-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(filter.value),expression:"filter.value"}],staticClass:"px-1 w-50",attrs:{"type":"text"},domProps:{"value":(filter.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(filter, "value", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),(filter.selected && filter.type === 'list')?_c('div',{staticClass:"filter-list__item-form d-flex flex-column justify-content-between"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(filter.value),expression:"filter.value"}],attrs:{"name":("filter-" + (filter.label)),"id":("id-" + (filter.label))},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(filter, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((filter.list),function(item,index){return _c('option',{key:("filter-list-item#" + index),domProps:{"value":item.key}},[_vm._v(_vm._s(item.label))])}),0)]):_vm._e()])}),0)])])])],1),_vm._v(" "),_c('div',{attrs:{"id":"datatable-toolbar-right"}},[_vm._l((_vm.buttons),function(button,index){return _c('button',{key:("action-button#" + index),staticClass:"ml-data-table__toolbar__action",on:{"click":function($event){return _vm.$emit(button.event)}}},[_c('span',[_vm._v(_vm._s(button.name))]),_vm._v(" "),_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(button.icon))])])}),_vm._v(" "),_c('button',{staticClass:"ml-data-table__toolbar__action",on:{"click":function($event){return _vm.$emit('export-data', _vm.tableFilters)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cloud_download")])])],2)]),_vm._v(" "),_c('table',{directives:[{name:"show",rawName:"v-show",value:(_vm.rows.length > 0),expression:"rows.length > 0"}],staticClass:"table"},[_c('thead',{staticClass:"ml-data-table__head"},[_c('tr',[_vm._l((_vm.columns),function(column,index){return (!(column.hide || column.collapsed))?_c('td',{key:("datatable-column#" + index),class:{
            'text-left' : ((index + 1) !== _vm.columns.length) || (column.float === 'left'),
            'text-right' : ((index + 1) === _vm.columns.length) || (column.float === 'right')
          }},[_vm._v("\n          "+_vm._s(column.label)+"\n        ")]):_vm._e()}),_vm._v(" "),(_vm.hasActions)?_c('td',{staticClass:"text-center"},[_vm._v("Actions")]):_vm._e()],2)]),_vm._v(" "),_c('tbody',{staticClass:"ml-data-table__body"},[_vm._l((_vm.rows),function(row,index){return [_c('tr',{key:("datatable-row-primary#" + index),class:['ml-data-table__row', {'ml-data-table__row--clickable': _vm.hasCollapsable}]},[_vm._l((_vm.columns),function(column,index){return (!(column.hide || column.collapsed))?_c('td',{key:("datatable-cell#" + index),class:{
               'text-right' : ((index + 1) === _vm.columns.length) || (column.float === 'right'),
               'text-left' : (column.float === 'left'),
               'ml-data-table__row--text-highlight': column.highlight
             },on:{"click":function($event){return _vm.toggleRow(row)}}},[_vm._v("\n            "+_vm._s(_vm.dynamicallyFilter(row[column.key ], column.filter))+"\n          ")]):_vm._e()}),_vm._v(" "),(_vm.hasActions)?_c('td',{staticClass:"action-icon text-center"},[_c('div',{staticClass:"action-icon__container align-items-center d-flex justify-content-center mx-auto",on:{"click":function($event){_vm.$refs[("ctxMenu-" + index)][0].open($event)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("more_horiz")])])]):_vm._e(),_vm._v(" "),_c('context-menu',{ref:("ctxMenu-" + index),refInFor:true,attrs:{"id":("context-menu-" + index)}},_vm._l((_vm.actions),function(action,index){return (_vm.determineMenuItemVisibility(row, action.condition))?_c('li',{key:("context-menu-list-item#" + index),on:{"click":function($event){return _vm.$emit(action.event, row)}}},[_vm._v("\n                "+_vm._s(action.name)+"\n            ")]):_vm._e()}),0)],2),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:((_vm.selectedRow === row) && _vm.hasCollapsable),expression:"(selectedRow === row) && hasCollapsable"}],key:("datatable-row-secondary#" + index),staticClass:"ml-data-table__row__extra-information"},[_c('td',{attrs:{"colspan":"8"}},[_c('div',{staticClass:"ml-data-table__row__extra-information__container"},_vm._l((_vm.columns),function(column,index){return (column.collapsed)?_c('div',{key:("extra-info#" + index),class:[
                  'ml-data-table__row__extra-information__element',
                  {
                    'ml-data-table__row__extra-information__element--align-right' : (column.float === 'right'),
                    'ml-data-table__row__extra-information__element--align-left' : (column.float === 'left'),
                    'ml-data-table__row__extra-information__element--highlight': column.highlight
                  }]},[_c('div',{staticClass:"extra-information__title"},[_vm._v("\n                  "+_vm._s(column.label)+"\n                ")]),_vm._v(" "),_c('p',{staticClass:"extra-information__content"},[_vm._v("\n                  "+_vm._s((_vm.dynamicallyFilter(row[column.key ], column.filter) === null && column.type === 'date') ?
                    '--/--/-- --:--:--' :
                    _vm.dynamicallyFilter(row[column.key ], column.filter))+"\n                ")])]):_vm._e()}),0)])])]})],2)]),_vm._v(" "),(_vm.rows.length <= 0)?_c('div',[_vm._t("default")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ml-data-table__footer"},[_c('div',{staticClass:"ml-data-table__footer-summary"},[(_vm.rows.length > 0)?_c('span',[_vm._v("\n        "+_vm._s(_vm.previousRecords)+" - "+_vm._s((_vm.previousRecords > 1) ? _vm.previousRecords + _vm.rows.length : _vm.rows.length)+"\n        "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.numberOfPossiblePages <= 0),expression:"numberOfPossiblePages <= 0"}]},[_vm._v("records")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.numberOfPossiblePages > 0),expression:"numberOfPossiblePages > 0"}]},[_c('span',{staticClass:"mx-1"},[_vm._v("of")]),_vm._v(" many")])]):_vm._e(),_vm._v(" "),(_vm.rows.length <= 0)?_c('span',[_vm._v("\n        0 results\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"ml-data-table__pagination"},[_c('button',{staticClass:"ml-btn ml-btn--white ml-data-table__pagination-button ml-btn--prev",on:{"click":_vm.prevPage}},[_vm._v("Prev")]),_vm._v(" "),_c('button',{staticClass:"ml-btn ml-btn--white ml-data-table__pagination-button ml-btn--next",on:{"click":_vm.nextPage}},[_vm._v("Next")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart_vue__ = __webpack_require__(293);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7c370fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chart_vue__ = __webpack_require__(602);
function injectStyle (ssrContext) {
  __webpack_require__(499)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7c370fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 507 */,
/* 508 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 519 */,
/* 520 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 546 */,
/* 547 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 548 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 554 */,
/* 555 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports = {"_from":"elliptic@^6.5.3","_id":"elliptic@6.5.4","_inBundle":false,"_integrity":"sha512-iLhC6ULemrljPZb+QutR5TQGB+pdW6KGD5RSegS+8sorOZT+rdQFbsQFJgvN3eRqNALqJer4oQ16YvJHlU8hzQ==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"elliptic@^6.5.3","name":"elliptic","escapedName":"elliptic","rawSpec":"^6.5.3","saveSpec":null,"fetchSpec":"^6.5.3"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.5.4.tgz","_shasum":"da37cebd31e79a1367e941b592ed1fbebd58abbb","_spec":"elliptic@^6.5.3","_where":"/apps/checkout/v2/sandbox/web-apps/tingg-developer-portal/client/node_modules/browserify-sign","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"bundleDependencies":false,"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"},"deprecated":false,"description":"EC cryptography","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.5.4"}

/***/ }),
/* 563 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 595 */,
/* 596 */,
/* 597 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ml-chart__container"},[_c('line-chart',{attrs:{"colors":['#6CD1EF', '#5D538B'],"data":_vm.data,"download":true,"id":_vm.id,"height":_vm.height,"legend":"bottom","thousands":","}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ml-comparison-board__container ml-card--depth mb-4"},[_c('div',{staticClass:"ml-comparison-board__tabs"},_vm._l((_vm.categories),function(category,index){return _c('div',{key:((category.title) + "#" + index),class:{'ml-comparison-board__tab': true, 'ml-comparison-board__tab--active': (index === _vm.selectedTab)},attrs:{"id":("comparison-board-tab-" + (category.title.toLowerCase().replace(' ', '-')))},on:{"click":function($event){return _vm.selectTab(index)}}},[_c('div',{staticClass:"ml-comparison-board__category-title"},[_vm._v("\n        "+_vm._s(category.title)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"ml-comparison-board__category-total"},[_vm._v("\n        "+_vm._s(category.total)+" "+_vm._s(category.unit)+"\n      ")]),_vm._v(" "),_c('div',{class:{
          'ml-comparison-board__category-performance': true,
          'ml-comparison-board__category-performance--max': !category.invert ? (category.performance > 0) : (category.performance < 0),
          'ml-comparison-board__category-performance--min': !category.invert ? (category.performance < 0) : (category.performance > 0)}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(category.performance < 0),expression:"category.performance < 0"}],staticClass:"material-icons"},[_vm._v("arrow_downward")]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(category.performance > 0),expression:"category.performance > 0"}],staticClass:"material-icons"},[_vm._v("arrow_upward")]),_vm._v("\n        "+_vm._s(category.performance)+"%\n      ")]),_vm._v(" "),_c('div',{staticClass:"ml-comparison-board__category-prompt"},[_vm._v("\n        vs "+_vm._s(category.data[1].name)+"\n      ")])])}),0),_vm._v(" "),(!_vm.hide)?_c('div',{staticClass:"ml-comparison-board__chart-container"},[_c('chart',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedCategory),expression:"selectedCategory"}],attrs:{"data":_vm.selectedCategory.data,"height":"200px"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ml-comparison-board__filter-container row no-gutters"},[_c('div',{staticClass:"align-items-center col-4 d-flex justify-content-start"},[_c('b-datepicker',{staticClass:"mx-1",attrs:{"icon":"calendar-today","readonly":true,"placeholder":"Date from","max-date":_vm.range.to},on:{"input":_vm.rebuildChart},model:{value:(_vm.range.from),callback:function ($$v) {_vm.$set(_vm.range, "from", $$v)},expression:"range.from"}}),_vm._v(" "),_c('span',{staticClass:"mx-3"},[_vm._v("to")]),_vm._v(" "),_c('b-datepicker',{staticClass:"px-1",attrs:{"icon":"calendar-today","readonly":true,"placeholder":"Date to","min-date":_vm.range.from},on:{"input":_vm.rebuildChart},model:{value:(_vm.range.to),callback:function ($$v) {_vm.$set(_vm.range, "to", $$v)},expression:"range.to"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-shell',{attrs:{"breadcrumbs":"Home , Payments"}},[_c('div',{staticClass:"payments__container"},[_c('div',{staticClass:"row no-gutters mt-4"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"payments__chart-container"},[_c('comparison-board',{attrs:{"data":_vm.comparisonData},on:{"filter-chart":_vm.rebuildComparisonChart}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row no-gutters mt-4"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"payments__data-table-container"},[_c('data-table',{attrs:{"actions":_vm.actions,"buttons":_vm.buttons,"column-configuration":_vm.columns,"filters":_vm.filters,"selected-row":_vm.selectedRow,"page":_vm.page,"page-limit":_vm.pageLimit,"rows":_vm.rows},on:{"filter":_vm.rebuildTable,"next-page":_vm.nextPage,"prev-page":_vm.prevPage,"show-visit":_vm.showVisit,"simulate-payment":_vm.launchSimulator,"view":_vm.selectRow}},[_c('div',{staticClass:"ml-data-table__placeholder"},[_c('i',{staticClass:"fas fa-credit-card fa-3x"}),_vm._v(" "),_c('h5',{staticClass:"my-3"},[_vm._v("You do not have any payments")])])])],1)])]),_vm._v(" "),_c('modal',{attrs:{"action":"Pay","name":"simulate-payment","no-icon":false,"title":"<b>Simulate</b> a payment"},on:{"cancel":_vm.cancelSimulator,"save":_vm.simulatePayment}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"phone_number"}},[_vm._v("Mobile number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.simulatedPayment.MSISDN),expression:"simulatedPayment.MSISDN"},{name:"validate",rawName:"v-validate",value:('required|phone_number'),expression:"'required|phone_number'"}],staticClass:"form-control",attrs:{"type":"text","name":"phone_number","id":"phone_number"},domProps:{"value":(_vm.simulatedPayment.MSISDN)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.simulatedPayment, "MSISDN", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('phone_number')),expression:"errors.has('phone_number')"}],staticClass:"help is-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.first('phone_number'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"amount"}},[_vm._v("Amount")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.simulatedPayment.chargeAmount),expression:"simulatedPayment.chargeAmount"},{name:"validate",rawName:"v-validate",value:('required|min_value:1'),expression:"'required|min_value:1'"}],staticClass:"form-control",attrs:{"type":"number","name":"amount","id":"amount"},domProps:{"value":(_vm.simulatedPayment.chargeAmount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.simulatedPayment, "chargeAmount", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('amount')),expression:"errors.has('amount')"}],staticClass:"help is-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.first('amount'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"account_number"}},[_vm._v("Account number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.simulatedPayment.accountNumber),expression:"simulatedPayment.accountNumber"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"account_number","id":"account_number"},domProps:{"value":(_vm.simulatedPayment.accountNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.simulatedPayment, "accountNumber", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('account_number')),expression:"errors.has('account_number')"}],staticClass:"help is-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.first('account_number'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"payment_option"}},[_vm._v("Payment option")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.simulatedPayment.paymentOption),expression:"simulatedPayment.paymentOption"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"id":"payment_option","name":"payment_option"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.simulatedPayment, "paymentOption", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm._preparePayerClients(_vm.meta.payerClients)),function(client){return _c('option',{key:client.label,domProps:{"value":client}},[_vm._v(" "+_vm._s(client.label)+" ")])}),0),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('payment_option')),expression:"errors.has('payment_option')"}],staticClass:"help is-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.first('payment_option'))+"\n        ")])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentOptions_vue__ = __webpack_require__(349);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64dd5b30_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentOptions_vue__ = __webpack_require__(610);
function injectStyle (ssrContext) {
  __webpack_require__(606)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentOptions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64dd5b30_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentOptions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 606 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tip_vue__ = __webpack_require__(350);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_143f60f4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tip_vue__ = __webpack_require__(609);
function injectStyle (ssrContext) {
  __webpack_require__(608)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_143f60f4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 608 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.open),expression:"open"}],staticClass:"ml-tip"},[_c('div',{staticClass:"ml-tip__header"},[_vm._t("title"),_vm._v(" "),_c('img',{staticClass:"ml-tip__close",attrs:{"id":"ml-tip__close","src":"/static/img/icons/close.png","alt":"Close"},on:{"click":_vm.close}})],2),_vm._v(" "),_c('div',{staticClass:"ml-tip__content"},[_vm._t("content")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-shell',{attrs:{"breadcrumbs":"Home,Payment Options"}},[_c('div',{staticClass:"payment-options-manager"},[_c('ml-tip',[_c('div',{staticClass:"ml-tip__title",attrs:{"slot":"title"},slot:"title"},[_c('img',{attrs:{"src":"/static/img/icons/idea.png","alt":"Idea"}}),_vm._v("\n\n        Helpful Tip\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("\n        A payment mode is the type of experience you choose to offer to your users on checkout.\n        There are 4 payment mode currently available on checkout:-\n        STK push, USSD push, instructional and card.\n        "),_c('b',[_vm._v("STK push")]),_vm._v(" is when the user's sim toolkit is launched and he/she is prompted to authorize the payment,\n        while "),_c('b',[_vm._v("USSD push")]),_vm._v(" is when a user is prompted to authorize the payment via USSD,\n        "),_c('b',[_vm._v("Instructional")]),_vm._v(" mode is when instructions are shown to the user on how to pay on checkout and finally\n        "),_c('b',[_vm._v("Card")]),_vm._v(" is for a user to to insert the card details to checkout.\n      ")])]),_vm._v(" "),_c('ml-group',{staticClass:"mt-4",attrs:{"title":"Payment options","subtitle":"Select the payment options for your new services"}},[_c('template',{slot:"legend"},[_c('div',{staticClass:"ml-pom__legend"},[_c('ul',{staticClass:"ml-pom__legend-list"},[_c('li',{staticClass:"ml-pom__legend-list__item"},[_c('div',{staticClass:"ml-pom__check-icon mr-2 blue"},[_c('div',{staticClass:"ml-pom__check-icon__center"})]),_vm._v(" "),_c('span',[_vm._v("Active")])]),_vm._v(" "),_c('li',{staticClass:"ml-pom__legend-list__item"},[_c('div',{staticClass:"ml-pom__check-icon mr-2 orange"},[_c('div',{staticClass:"ml-pom__check-icon__center"})]),_vm._v(" "),_c('span',[_vm._v("Syncing")])]),_vm._v(" "),_c('li',{staticClass:"ml-pom__legend-list__item"},[_c('div',{staticClass:"ml-pom__check-icon mr-2"},[_c('div',{staticClass:"ml-pom__check-icon__center"})]),_vm._v(" "),_c('span',[_vm._v("Inactive")])])])])]),_vm._v(" "),_c('template',{slot:"content"},[_c('div',{staticClass:"ml-pol"},_vm._l((_vm.options),function(country,index){return _c('div',{key:((country.title.replace(/\s/g,'')) + "#" + index),staticClass:"ml-pol__item"},[_c('div',{staticClass:"ml-pol__item__title"},[_vm._v("\n              "+_vm._s(country.title)+"\n            ")]),_vm._v(" "),_c('ul',{staticClass:"ml-pol__item-list"},_vm._l((country.options),function(option,index){return _c('li',{key:((option.clientDisplayName.replace(/\s/g,'')) + "#" + index),staticClass:"ml-pol__item-list__item"},[_c('payment-option-manager',{attrs:{"image-source":((_vm.logoUrls['KE']) + "/" + (option.clientLogo)),"selected":option.optionEnabled,"status":option.serviceSettingActive,"title":option.clientDisplayName,"payment-option":option},on:{"option-activated":_vm.addPaymentOption,"option-deactivated":_vm.removePaymentOption,"option-updated":_vm.updatePaymentOption}})],1)}),0)])}),0)])],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(351);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c73d7302_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(613);
function injectStyle (ssrContext) {
  __webpack_require__(612)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c73d7302_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 612 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-shell',{attrs:{"breadcrumbs":"Home , Profile"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.updateProfile($event)}}},[_c('div',{staticClass:"row no-gutters mt-4"},[_c('div',{staticClass:"align-items-center col-12 d-flex justify-content-between"},[_c('h5',{staticClass:"ml-create-service__title"},[_vm._v("Manage your profile")]),_vm._v(" "),_c('div',{staticClass:"ml-btn-group"},[_c('button',{staticClass:"ml-btn ml-btn--md tingg-primary-button",attrs:{"type":"submit"}},[_vm._v("Save")])])])]),_vm._v(" "),_c('ml-group',{staticClass:"my-4 mr-2",attrs:{"title":"Service information"}},[_c('template',{slot:"content"},[_c('div',{staticClass:"row my-4 d-flex align-items-end justify-content-between"},[_c('div',{staticClass:"col-6"},[_c('div',{class:{'form-group': true, 'has-error': _vm.errors.has('service_name') }},[_c('label',{staticClass:"mula-form-group__label control-label",attrs:{"for":"service_name"}},[_vm._v("Service name")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:3'),expression:"'required|min:3'"},{name:"model",rawName:"v-model",value:(_vm.service_name),expression:"service_name"}],staticClass:"mula-form-group__input form-control",attrs:{"id":"service_name","name":"service_name","type":"text","autocomplete":"service_name"},domProps:{"value":(_vm.service_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.service_name=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('service_name')),expression:"errors.has('service_name')"}],staticClass:"help is-danger"},[_vm._v("\n            "+_vm._s(_vm.errors.first('service_name'))+"\n          ")])])])])])],2),_vm._v(" "),_c('ml-group',{staticClass:"my-4 mr-2",attrs:{"title":"Profile information"}},[_c('template',{slot:"content"},[_c('div',{staticClass:"row my-4"},[_c('div',{staticClass:"col-6"},[_c('div',{class:{'form-group': true, 'has-error': _vm.errors.has('full_name') }},[_c('label',{staticClass:"mula-form-group__label control-label",attrs:{"for":"user_full_name"}},[_vm._v("Full name")]),_vm._v(" "),_c('span',{staticClass:"help muted subtle-text mt-0 mb-2"},[_vm._v("Please provide your full name separated by spaces")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:5'),expression:"'required|min:5'"},{name:"model",rawName:"v-model",value:(_vm.user_full_name),expression:"user_full_name"}],staticClass:"mula-form-group__input form-control",attrs:{"id":"user_full_name","name":"user_full_name","type":"text","autocomplete":"user_full_name"},domProps:{"value":(_vm.user_full_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.user_full_name=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('user_full_name')),expression:"errors.has('user_full_name')"}],staticClass:"help is-danger"},[_vm._v("\n              "+_vm._s(_vm.errors.first('user_full_name'))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{class:{'form-group': true, 'has-error': _vm.errors.has('phone_number') }},[_c('label',{staticClass:"mula-form-group__label control-label",attrs:{"for":"user_phone_number"}},[_vm._v("Phone number")]),_vm._v(" "),_c('span',{staticClass:"help muted subtle-text mt-0 mb-2"},[_vm._v("Please provide a mobile number with the country code")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("+")])]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|phone_number'),expression:"'required|phone_number'"},{name:"model",rawName:"v-model",value:(_vm.user_phone_number),expression:"user_phone_number"}],staticClass:"mula-form-group__input form-control",attrs:{"id":"user_phone_number","name":"user_phone_number","type":"text","autocomplete":"user_phone_number"},domProps:{"value":(_vm.user_phone_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.user_phone_number=$event.target.value}}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('user_phone_number')),expression:"errors.has('user_phone_number')"}],staticClass:"help is-danger"},[_vm._v("\n              "+_vm._s(_vm.errors.first('user_phone_number'))+"\n            ")])])])])])],2),_vm._v(" "),_c('ml-group',{staticClass:"my-4 mr-2",attrs:{"title":"Business information"}},[_c('template',{slot:"content"},[_c('div',{staticClass:"row my-4"},[_c('div',{staticClass:"col-6"},[_c('div',{class:{'form-group': true, 'has-error': _vm.errors.has('full_name') }},[_c('label',{staticClass:"mula-form-group__label control-label",attrs:{"for":"full_name"}},[_vm._v("Contact name")]),_vm._v(" "),_c('span',{staticClass:"help muted subtle-text mt-0 mb-2"},[_vm._v("Please provide your full name separated by spaces")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:5'),expression:"'required|min:5'"},{name:"model",rawName:"v-model",value:(_vm.full_name),expression:"full_name"}],staticClass:"mula-form-group__input form-control",attrs:{"id":"full_name","name":"full_name","type":"text","autocomplete":"full_name"},domProps:{"value":(_vm.full_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.full_name=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('full_name')),expression:"errors.has('full_name')"}],staticClass:"help is-danger"},[_vm._v("\n                "+_vm._s(_vm.errors.first('full_name'))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{class:{'form-group': true, 'has-error': _vm.errors.has('phone_number') }},[_c('label',{staticClass:"mula-form-group__label control-label",attrs:{"for":"phone_number"}},[_vm._v("Contact phone number")]),_vm._v(" "),_c('span',{staticClass:"help muted subtle-text mt-0 mb-2"},[_vm._v("Please provide a mobile number with the country code")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("+")])]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|phone_number'),expression:"'required|phone_number'"},{name:"model",rawName:"v-model",value:(_vm.phone_number),expression:"phone_number"}],staticClass:"mula-form-group__input form-control",attrs:{"id":"phone_number","name":"phone_number","type":"text","autocomplete":"phone_number"},domProps:{"value":(_vm.phone_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone_number=$event.target.value}}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('phone_number')),expression:"errors.has('phone_number')"}],staticClass:"help is-danger"},[_vm._v("\n                "+_vm._s(_vm.errors.first('phone_number'))+"\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"row my-4"},[_c('div',{staticClass:"col-6"},[_c('div',{class:{'form-group': true, 'has-error': _vm.errors.has('business_name') }},[_c('label',{staticClass:"mula-form-group__label control-label",attrs:{"for":"business_name"}},[_vm._v("Business name")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:3'),expression:"'required|min:3'"},{name:"model",rawName:"v-model",value:(_vm.business_name),expression:"business_name"}],staticClass:"mula-form-group__input form-control",attrs:{"id":"business_name","name":"business_name","type":"text","autocomplete":"business_name"},domProps:{"value":(_vm.business_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.business_name=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('business_name')),expression:"errors.has('business_name')"}],staticClass:"help is-danger"},[_vm._v("\n                "+_vm._s(_vm.errors.first('business_name'))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{class:{'form-group': true, 'has-error': _vm.errors.has('country_of_operation') }},[_c('label',{staticClass:"mula-form-group__label control-label",attrs:{"for":"country_of_operation"}},[_vm._v("\n                Country of operation\n              ")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.country_of_operation),expression:"country_of_operation"}],staticClass:"mula-form-group__input form-control",attrs:{"name":"country_of_operation","id":"country_of_operation"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.country_of_operation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.countries),function(country){return _c('option',{domProps:{"value":country.code,"textContent":_vm._s(country.name)}})}),0),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('country_of_operation')),expression:"errors.has('country_of_operation')"}],staticClass:"help is-danger"},[_vm._v("\n                "+_vm._s(_vm.errors.first('country_of_operation'))+"\n              ")])])])])])],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetPassword_vue__ = __webpack_require__(352);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55f5e18e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetPassword_vue__ = __webpack_require__(616);
function injectStyle (ssrContext) {
  __webpack_require__(615)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55f5e18e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55f5e18e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 615 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"set-password"},[_c('div',{staticClass:"set-password__container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"set-password__card"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showError),expression:"showError"}],staticClass:"help-text help-text--error mb-4",staticStyle:{"display":"none"},attrs:{"id":"set-password-error"}},[_vm._v("\n        Whoops! Something went wrong "),_c('br'),_vm._v("\n        Please try again later\n      ")]),_vm._v(" "),_c('h3',{staticClass:"set-password__card-title"},[_vm._v("Secure your account")]),_vm._v(" "),_c('form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.setupPassword($event)}}},[_c('div',{class:{'form-group': true, 'has-error': _vm.errors.has('password') }},[_c('label',{staticClass:"mula-form-group__label control-label",attrs:{"for":"password"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:5'),expression:"'required|min:5'"},{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],ref:"password",staticClass:"mula-form-group__input form-control",attrs:{"id":"password","name":"password","type":"password","autocomplete":"password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password')),expression:"errors.has('password')"}],staticClass:"help is-danger"},[_vm._v("\n            "+_vm._s(_vm.errors.first('password'))+"\n          ")])]),_vm._v(" "),_c('div',{class:{ 'form-group': true, 'has-error': _vm.errors.has('confirm_password') }},[_c('label',{staticClass:"mula-form-group__label control-label",attrs:{"for":"confirm_password"}},[_vm._v("Confirm Password")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|confirmed:password'),expression:"'required|confirmed:password'"}],staticClass:"mula-form-group__input form-control",attrs:{"id":"confirm_password","name":"confirm_password","type":"password","autocomplete":"confirm_password","data-vv-as":"password"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('confirm_password')),expression:"errors.has('confirm_password')"}],staticClass:"help is-danger"},[_vm._v("\n            "+_vm._s(_vm.errors.first('confirm_password'))+"\n          ")])]),_vm._v(" "),_c('button',{staticClass:"mula-btn tingg-primary-button",attrs:{"type":"submit"}},[_vm._v("Save")])]),_vm._v(" "),_c('div',{staticClass:"set-password__optional-cta"},[_c('span',[_vm._v("Already have a password?")]),_vm._v(" "),_c('a',{staticClass:"tingg-anchors",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.goTo('/login')}}},[_vm._v("Login")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"set-password__brand"},[_c('img',{staticClass:"tingg-brand-logo",attrs:{"src":"https://developer.tingg.africa/checkout/v2/assets/images/tingg/tingg_white.png","height":"64","alt":"Tingg"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecoverPassword_vue__ = __webpack_require__(353);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae1e1050_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecoverPassword_vue__ = __webpack_require__(619);
function injectStyle (ssrContext) {
  __webpack_require__(618)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecoverPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae1e1050_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecoverPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 618 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recover-password"},[_c('div',{staticClass:"recover-password__container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"recover-password__card"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showError),expression:"showError"}],staticClass:"help-text help-text--error mb-4",staticStyle:{"display":"none"},attrs:{"id":"recover-password-error"}},[_vm._v("\n        We were unable to recover your password. "),_c('br'),_vm._v(" Please try again later\n      ")]),_vm._v(" "),_c('h3',{staticClass:"recover-password__card-title"},[_vm._v("\n        Recover Password\n      ")]),_vm._v(" "),_c('form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.recoverPassword($event)}}},[_c('div',{class:{'form-group': true, 'has-error': _vm.errors.has('email') }},[_c('label',{staticClass:"mula-form-group__label control-label",attrs:{"for":"email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"},{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"mula-form-group__input form-control",attrs:{"id":"email","name":"email","type":"email","autocomplete":"email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"help is-danger"},[_vm._v("\n            Your email is required\n          ")])]),_vm._v(" "),_c('button',{staticClass:"mula-btn tingg-primary-button",attrs:{"type":"submit"}},[_vm._v("Recover")])]),_vm._v(" "),_c('div',{staticClass:"recover-password__optional-cta"},[_c('span',[_vm._v("Remember your password?")]),_vm._v(" "),_c('a',{staticClass:"tingg-anchors",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.goTo('/login')}}},[_vm._v("Login")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recover-password__brand"},[_c('img',{staticClass:"tingg-brand-logo",attrs:{"src":"https://developer.tingg.africa/checkout/v2/assets/images/tingg/tingg_white.png","height":"64","alt":"Tingg"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__ = __webpack_require__(354);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41e58f6d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__ = __webpack_require__(622);
function injectStyle (ssrContext) {
  __webpack_require__(621)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41e58f6d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 621 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reset-password"},[_c('div',{staticClass:"reset-password__container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"reset-password__card"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showError),expression:"showError"}],staticClass:"help-text help-text--error mb-4",staticStyle:{"display":"none"},attrs:{"id":"reset-password-error"}},[_vm._v("\n        We were unable to reset your password. "),_c('br'),_vm._v(" Please try again later\n      ")]),_vm._v(" "),_c('h3',{staticClass:"reset-password__card-title"},[_vm._v("\n        Reset Passsword\n      ")]),_vm._v(" "),_c('form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.resetPassword($event)}}},[_c('div',{class:{'form-group': true, 'has-error': _vm.errors.has('password') }},[_c('label',{staticClass:"mula-form-group__label control-label",attrs:{"for":"password"}},[_vm._v("New Password")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:5'),expression:"'required|min:5'"},{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],ref:"password",staticClass:"mula-form-group__input form-control",attrs:{"id":"password","name":"password","type":"password","autocomplete":"password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password')),expression:"errors.has('password')"}],staticClass:"help is-danger"},[_vm._v("\n            "+_vm._s(_vm.errors.first('password'))+"\n          ")])]),_vm._v(" "),_c('div',{class:{'form-group': true, 'has-error': _vm.errors.has('confirm_password') }},[_c('label',{staticClass:"mula-form-group__label control-label",attrs:{"for":"confirm_password"}},[_vm._v("Confirm Password")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, is: _vm.password}),expression:"{required: true, is: password}"},{name:"model",rawName:"v-model",value:(_vm.confirm_password),expression:"confirm_password"}],staticClass:"mula-form-group__input form-control",attrs:{"id":"confirm_password","name":"confirm_password","type":"password","autocomplete":"confirm_password","data-vv-as":"password"},domProps:{"value":(_vm.confirm_password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.confirm_password=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('confirm_password')),expression:"errors.has('confirm_password')"}],staticClass:"help is-danger"},[_vm._v("\n            "+_vm._s(_vm.errors.first('confirm_password'))+"\n          ")])]),_vm._v(" "),_c('button',{staticClass:"mula-btn tingg-primary-button",attrs:{"type":"submit"}},[_vm._v("Reset Password")])]),_vm._v(" "),_c('div',{staticClass:"reset-password__optional-cta"},[_c('span',[_vm._v("Remember your password?")]),_vm._v(" "),_c('a',{staticClass:"tingg-anchors",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.goTo('/login')}}},[_vm._v("Login")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reset-password__brand"},[_c('img',{staticClass:"tingg-brand-logo",attrs:{"src":"https://developer.tingg.africa/checkout/v2/assets/images/tingg/tingg_white.png","height":"64","alt":"Tingg"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterUser_vue__ = __webpack_require__(355);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49fe1b12_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterUser_vue__ = __webpack_require__(626);
function injectStyle (ssrContext) {
  __webpack_require__(624)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49fe1b12_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 624 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 625 */,
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register"},[_c('div',{staticClass:"register__container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"register__card row no-gutters"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-6 register__form-section"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{class:{'form-group': true, 'has-error': _vm.errors.has('full_name') }},[_c('label',{staticClass:"mula-form-group__label control-label",attrs:{"for":"full_name"}},[_vm._v("Full name")]),_vm._v(" "),_c('span',{staticClass:"help muted subtle-text mt-0 mb-2"},[_vm._v("Please provide your full name separated by spaces")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:5'),expression:"'required|min:5'"},{name:"model",rawName:"v-model",value:(_vm.full_name),expression:"full_name"}],staticClass:"mula-form-group__input form-control",attrs:{"id":"full_name","name":"full_name","type":"text","autocomplete":"full_name"},domProps:{"value":(_vm.full_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.full_name=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('full_name')),expression:"errors.has('full_name')"}],staticClass:"help is-danger"},[_vm._v("\n              "+_vm._s(_vm.errors.first('full_name'))+"\n            ")])]),_vm._v(" "),_c('div',{class:{'form-group': true, 'has-error': _vm.errors.has('work_email') }},[_c('label',{staticClass:"mula-form-group__label control-label",attrs:{"for":"work_email"}},[_vm._v("Work Email")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"},{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"mula-form-group__input form-control",attrs:{"id":"work_email","name":"work_email","type":"email","autocomplete":"work_email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('work_email')),expression:"errors.has('work_email')"}],staticClass:"help is-danger"},[_vm._v("\n              "+_vm._s(_vm.errors.first('work_email'))+"\n            ")])]),_vm._v(" "),_c('div',{class:{'form-group': true, 'has-error': _vm.errors.has('password') }},[_c('label',{staticClass:"mula-form-group__label control-label",attrs:{"for":"password"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:5'),expression:"'required|min:5'"},{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"mula-form-group__input form-control",attrs:{"id":"password","name":"password","type":"password","autocomplete":"new_password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password')),expression:"errors.has('password')"}],staticClass:"help is-danger"},[_vm._v("\n              "+_vm._s(_vm.errors.first('password'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"register__navigation"},[_c('vue-recaptcha',{ref:"recaptcha",attrs:{"size":"invisible","sitekey":"6Lc23akUAAAAANu7aDnhQLXp48SvyZE_y4qJl9cA"},on:{"verify":_vm.verifyCaptcha,"expired":_vm.captchaExpired}},[_c('button',{staticClass:"ml-btn ml-btn--md tingg-primary-button",attrs:{"type":"submit"}},[_c('span',[_vm._v("Next")]),_vm._v(" "),_c('i',{staticClass:"fas fa-chevron-right"})])])],1)]),_vm._v(" "),_c('div',{staticClass:"register__secondary-cta"},[_c('span',[_vm._v("Already have an account?")]),_vm._v(" "),_c('a',{staticClass:"tingg-anchors",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.goTo('/login')}}},[_vm._v("Login")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register__brand"},[_c('img',{staticClass:"tingg-brand-logo",attrs:{"src":"https://developer.tingg.africa/checkout/v2/assets/images/tingg/tingg_white.png","alt":"Tingg"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('ul',{staticClass:"wizard-vertical"},[_c('li',{staticClass:"wizard-vertical__step active"},[_c('span',{staticClass:"wizard-vertical__step__count"},[_vm._v("1")]),_vm._v(" Profile Information\n          ")]),_vm._v(" "),_c('li',{staticClass:"wizard-vertical__divider"}),_vm._v(" "),_c('li',{staticClass:"wizard-vertical__step"},[_c('span',{staticClass:"wizard-vertical__step__count"},[_vm._v("2")]),_vm._v(" Business Information\n          ")]),_vm._v(" "),_c('li',{staticClass:"wizard-vertical__divider"}),_vm._v(" "),_c('li',{staticClass:"wizard-vertical__step"},[_c('span',{staticClass:"wizard-vertical__step__count"},[_vm._v("3")]),_vm._v(" Complete\n          ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterBusiness_vue__ = __webpack_require__(356);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f75bf27_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterBusiness_vue__ = __webpack_require__(629);
function injectStyle (ssrContext) {
  __webpack_require__(628)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterBusiness_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f75bf27_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterBusiness_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 628 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register"},[_c('div',{staticClass:"register__container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"register__card row no-gutters"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-6 register__form-section"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showError),expression:"showError"}],staticClass:"help-text help-text--error mb-4",staticStyle:{"display":"none"},attrs:{"id":"login-error"},domProps:{"innerHTML":_vm._s(_vm.error)}}),_vm._v(" "),_c('form',{staticClass:"mb-5",on:{"submit":function($event){$event.preventDefault();return _vm.createAccount($event)}}},[_c('div',{class:{'form-group': true, 'has-error': _vm.errors.has('business_name') }},[_c('label',{staticClass:"mula-form-group__label control-label",attrs:{"for":"business_name"}},[_vm._v("Business name")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:3'),expression:"'required|min:3'"},{name:"model",rawName:"v-model",value:(_vm.business_name),expression:"business_name"}],staticClass:"mula-form-group__input form-control",attrs:{"id":"business_name","name":"business_name","type":"text","autocomplete":"business_name"},domProps:{"value":(_vm.business_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.business_name=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('business_name')),expression:"errors.has('business_name')"}],staticClass:"help is-danger"},[_vm._v("\n                      "+_vm._s(_vm.errors.first('business_name'))+"\n                    ")])]),_vm._v(" "),_c('div',{class:{'form-group': true, 'has-error': _vm.errors.has('country_of_operation') }},[_c('label',{staticClass:"mula-form-group__label control-label",attrs:{"for":"country_of_operation"}},[_vm._v("\n              Country of operation\n            ")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.country_of_operation),expression:"country_of_operation"}],staticClass:"mula-form-group__input form-control",attrs:{"name":"country_of_operation","id":"country_of_operation"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.country_of_operation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.countries),function(country,index){return _c('option',{key:("#" + index + (country.code)),domProps:{"value":country.code,"textContent":_vm._s(country.name)}})}),0),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('country_of_operation')),expression:"errors.has('country_of_operation')"}],staticClass:"help is-danger"},[_vm._v("\n              "+_vm._s(_vm.errors.first('country_of_operation'))+"\n            ")])]),_vm._v(" "),_c('div',{class:{'form-group': true, 'has-error': _vm.errors.has('phone_number') }},[_c('label',{staticClass:"mula-form-group__label control-label",attrs:{"for":"phone_number"}},[_vm._v("Phone number")]),_vm._v(" "),_c('span',{staticClass:"help muted subtle-text mt-0 mb-2"},[_vm._v("Please provide a mobile number with the country code")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|phone_number'),expression:"'required|phone_number'"},{name:"model",rawName:"v-model",value:(_vm.phone_number),expression:"phone_number"}],staticClass:"mula-form-group__input form-control",attrs:{"id":"phone_number","name":"phone_number","type":"text","autocomplete":"phone_number"},domProps:{"value":(_vm.phone_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone_number=$event.target.value}}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('phone_number')),expression:"errors.has('phone_number')"}],staticClass:"help is-danger"},[_vm._v("\n              "+_vm._s(_vm.errors.first('phone_number'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"register__navigation"},[_c('button',{staticClass:"ml-btn ml-btn--md tingg-primary-button",attrs:{"type":"submit"}},[_vm._v("Finish")]),_vm._v(" "),_c('button',{staticClass:"ml-btn ml-btn--md ml-btn-white",on:{"click":function($event){$event.preventDefault();return _vm.back()}}},[_c('i',{staticClass:"fas fa-chevron-left"}),_vm._v(" "),_c('span',[_vm._v("Back")])])])]),_vm._v(" "),_c('div',{staticClass:"register__secondary-cta"},[_c('span',[_vm._v("Already have an account?")]),_vm._v(" "),_c('a',{staticClass:"tingg-anchors",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.goTo('/login')}}},[_vm._v("Login")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register__brand"},[_c('img',{staticClass:"tingg-brand-logo",attrs:{"src":"https://developer.tingg.africa/checkout/v2/assets/images/tingg/tingg_white.png","height":"64","alt":"Tingg"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('ul',{staticClass:"wizard-vertical"},[_c('li',{staticClass:"wizard-vertical__step active"},[_c('span',{staticClass:"wizard-vertical__step__count"},[_vm._v("1")]),_vm._v(" Profile Information\n          ")]),_vm._v(" "),_c('li',{staticClass:"wizard-vertical__divider"}),_vm._v(" "),_c('li',{staticClass:"wizard-vertical__step active"},[_c('span',{staticClass:"wizard-vertical__step__count"},[_vm._v("2")]),_vm._v(" Business Information\n          ")]),_vm._v(" "),_c('li',{staticClass:"wizard-vertical__divider"}),_vm._v(" "),_c('li',{staticClass:"wizard-vertical__step"},[_c('span',{staticClass:"wizard-vertical__step__count"},[_vm._v("3")]),_vm._v(" Complete\n          ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("+")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterComplete_vue__ = __webpack_require__(357);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4506032_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterComplete_vue__ = __webpack_require__(632);
function injectStyle (ssrContext) {
  __webpack_require__(631)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterComplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4506032_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterComplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register"},[_c('div',{staticClass:"register__container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"register__card row no-gutters"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"register__prompt text-center"},[_c('i',{staticClass:"material-icons",attrs:{"id":"tingg-email-complete"}},[_vm._v("mail_outline")]),_vm._v(" "),_c('div',{staticClass:"register__prompt-text"},[_vm._v("\n            A confirmation message has been sent to\n            "),_c('span',{attrs:{"id":"registration-email"}},[_vm._v(_vm._s(_vm.userInformation.emailAddress))]),_vm._v(".\n            Check your email and follow the instructions to activate your account.\n          ")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register__brand"},[_c('img',{staticClass:"tingg-brand-logo",attrs:{"src":"https://developer.tingg.africa/checkout/v2/assets/images/tingg/tingg_white.png","alt":"Tingg"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('ul',{staticClass:"wizard-vertical"},[_c('li',{staticClass:"wizard-vertical__step active"},[_c('span',{staticClass:"wizard-vertical__step__count"},[_vm._v("1")]),_vm._v(" Profile Information\n          ")]),_vm._v(" "),_c('li',{staticClass:"wizard-vertical__divider"}),_vm._v(" "),_c('li',{staticClass:"wizard-vertical__step active"},[_c('span',{staticClass:"wizard-vertical__step__count"},[_vm._v("2")]),_vm._v(" Business Information\n          ")]),_vm._v(" "),_c('li',{staticClass:"wizard-vertical__divider"}),_vm._v(" "),_c('li',{staticClass:"wizard-vertical__step active"},[_c('span',{staticClass:"wizard-vertical__step__count"},[_vm._v("3")]),_vm._v(" Complete\n          ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Visits_vue__ = __webpack_require__(358);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9413d81c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Visits_vue__ = __webpack_require__(636);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Visits_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9413d81c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Visits_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_API__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__transformers_ComparisonDataTransformer__ = __webpack_require__(288);






var logApi = !!("development" !== 'production');

var Visits = function () {
  function Visits() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Visits);

    this.serviceCode = '';
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Visits, [{
    key: 'fetchAll',
    value: function fetchAll(_ref) {
      var from = _ref.from,
          page = _ref.page,
          filters = _ref.filters;

      return __WEBPACK_IMPORTED_MODULE_3__utilities_API__["a" /* default */].refresh().post({ url: 'fetchCheckoutRequests',
        data: {
          'dateFrom': from,
          'serviceCode': this.serviceCode,
          'page': page,
          filters: filters
        }
      });
    }
  }, {
    key: 'fetchComparisonData',
    value: function fetchComparisonData(_ref2) {
      var _this = this;

      var filters = _ref2.filters;

      logApi && console.log('Fetching comparison data of the service => ' + this.serviceCode);
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__utilities_API__["a" /* default */].refresh().post({ url: 'fetchCheckoutRequestTotals',
          data: {
            'serviceCode': _this.serviceCode,
            'date': {
              'type': 'dateBetween',
              'min': filters.from,
              'max': filters.to
            }
          }
        }).then(function (response) {
          console.log('Fetch visits comparison data => ', response);
          resolve(__WEBPACK_IMPORTED_MODULE_4__transformers_ComparisonDataTransformer__["a" /* default */].transform(response.DATA, 'Visits'));
        }).catch(function (reason) {
          console.log('Fetching visits comparison data failed => ', reason);
          reject(reason);
        });
      });
    }
  }, {
    key: 'whereService',
    value: function whereService(_ref3) {
      var serviceCode = _ref3.serviceCode;

      this.serviceCode = serviceCode;
      return this;
    }
  }]);

  return Visits;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Visits());

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_config__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);







var logApi = !!("development" !== 'production');

var Express = function () {
  function Express() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Express);

    this.requestBody = {
      merchantTransactionID: '',
      customerFirstName: 'John',
      customerLastName: 'Smith',
      MSISDN: '',
      customerEmail: '',
      requestAmount: '',
      currencyCode: '',
      accessKey: '',
      ivKey: '',
      secretKey: '',
      serviceCode: '',
      accountNumber: new Date().getTime(),
      dueDate: __WEBPACK_IMPORTED_MODULE_5_moment___default()(new Date(new Date().getTime() + 15 * 60 * 1000)).utc().format('YYYY-MM-DD HH:mm:ss'),
      requestDescription: 'This is a test visit for the customer last',
      countryCode: '',
      successRedirectUrl: __WEBPACK_IMPORTED_MODULE_4__api_config__["a" /* default */].EXPRESS_CALLBACK_URL,
      failedRedirectUrl: __WEBPACK_IMPORTED_MODULE_4__api_config__["a" /* default */].EXPRESS_CALLBACK_URL,
      paymentWebhookUrl: __WEBPACK_IMPORTED_MODULE_4__api_config__["a" /* default */].PAYMENT_WEBHOOK_URL
    };
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Express, [{
    key: 'encrypt',
    value: function encrypt() {
      return fetch(__WEBPACK_IMPORTED_MODULE_4__api_config__["a" /* default */].ENGINE_PROXY_URL + 'encrypt', {
        method: 'POST',
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.requestBody),
        mode: 'cors'
      }).then(function (response) {
        return response.json();
      });
    }
  }, {
    key: 'initialize',
    value: function initialize(request) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forIn(request, function (value, key) {
        _this.requestBody[key] = value;
      });
      return this;
    }
  }, {
    key: 'redirect',
    value: function redirect(_ref) {
      var accessKey = _ref.accessKey,
          ivKey = _ref.ivKey,
          secretKey = _ref.secretKey;

      this.requestBody = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.assign(this.requestBody, { accessKey: accessKey, ivKey: ivKey, secretKey: secretKey });
      logApi && console.log('Payload to send for encryption => ', this.requestBody);
      this.encrypt().then(function (merchantProperties) {
        logApi && console.log('Merchant properties => ', merchantProperties);
        window.Tingg.renderCheckout({ merchantProperties: merchantProperties, checkoutType: 'redirect' });
      });
    }
  }]);

  return Express;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Express());

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-shell',{attrs:{"breadcrumbs":"Home, Visits"}},[_c('div',{staticClass:"visits__container"},[_c('div',{staticClass:"row no-gutters mt-4"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"visits__chart-container"},[_c('comparison-board',{attrs:{"data":_vm.comparisonData},on:{"filter-chart":_vm.rebuildComparisonChart}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row no-gutters mt-4"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"visits__data-table-container"},[_c('data-table',{attrs:{"actions":_vm.actions,"buttons":_vm.buttons,"column-configuration":_vm.columns,"filters":_vm.filters,"selected-row":_vm.selectedRow,"page":_vm.page,"page-limit":_vm.pageLimit,"rows":_vm.rows},on:{"filter":_vm.rebuildTable,"next-page":_vm.nextPage,"new-visit":_vm.launchNewVisit,"prev-page":_vm.prevPage,"show-payments":_vm.showPayments,"simulate-payment":_vm.simulateVisitPayment,"view":_vm.selectRow}},[_c('div',{staticClass:"ml-data-table__placeholder"},[_c('i',{staticClass:"fas fa-chart-bar fa-3x"}),_vm._v(" "),_c('h5',{staticClass:"my-3"},[_vm._v("You do not have any visits yet")])])])],1)])]),_vm._v(" "),_c('modal',{attrs:{"action":"Pay","name":"simulate-payment","no-icon":false,"title":"<b>Simulate</b> a payment"},on:{"cancel":_vm.cancelSimulator,"save":_vm.simulatePayment}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"phone_number"}},[_vm._v("Mobile number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.simulatedPayment.MSISDN),expression:"simulatedPayment.MSISDN"},{name:"validate",rawName:"v-validate",value:('required|phone_number'),expression:"'required|phone_number'"}],staticClass:"form-control",attrs:{"type":"text","name":"phone_number","id":"phone_number"},domProps:{"value":(_vm.simulatedPayment.MSISDN)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.simulatedPayment, "MSISDN", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('phone_number')),expression:"errors.has('phone_number')"}],staticClass:"help is-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.first('phone_number'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"amount"}},[_vm._v("Amount")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.simulatedPayment.chargeAmount),expression:"simulatedPayment.chargeAmount"},{name:"validate",rawName:"v-validate",value:('required|min_value:1'),expression:"'required|min_value:1'"}],staticClass:"form-control",attrs:{"type":"number","name":"amount","id":"amount"},domProps:{"value":(_vm.simulatedPayment.chargeAmount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.simulatedPayment, "chargeAmount", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('amount')),expression:"errors.has('amount')"}],staticClass:"help is-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.first('amount'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"payment_option"}},[_vm._v("Payment option")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.simulatedPayment.paymentOption),expression:"simulatedPayment.paymentOption"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"id":"payment_option","name":"payment_option"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.simulatedPayment, "paymentOption", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm._preparePayerClients(_vm.meta.payerClients)),function(client,key){return _c('option',{key:key,domProps:{"value":client}},[_vm._v(" "+_vm._s(client.label)+" ")])}),0),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('payment_option')),expression:"errors.has('payment_option')"}],staticClass:"help is-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.first('payment_option'))+"\n        ")])])]),_vm._v(" "),_c('modal',{attrs:{"action":"Launch","name":"launch-new-visit","no-icon":false,"title":"<b>Launch</b> a new visit"},on:{"cancel":_vm.cancelVisitSimulator,"save":_vm.redirectToCheckout}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"visit_phone_number"}},[_vm._v("Mobile number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newVisit.MSISDN),expression:"newVisit.MSISDN"},{name:"validate",rawName:"v-validate",value:('required|phone_number'),expression:"'required|phone_number'"}],staticClass:"form-control",attrs:{"type":"text","name":"visit_phone_number","id":"visit_phone_number"},domProps:{"value":(_vm.newVisit.MSISDN)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newVisit, "MSISDN", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('visit_phone_number')),expression:"errors.has('visit_phone_number')"}],staticClass:"help is-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.first('visit_phone_number'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"visit_amount"}},[_vm._v("Amount")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newVisit.amount),expression:"newVisit.amount"},{name:"validate",rawName:"v-validate",value:('required|min_value:1'),expression:"'required|min_value:1'"}],staticClass:"form-control",attrs:{"type":"number","name":"visit_amount","id":"visit_amount"},domProps:{"value":(_vm.newVisit.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newVisit, "amount", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('visit_amount')),expression:"errors.has('visit_amount')"}],staticClass:"help is-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.first('visit_amount'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"visit_country_code"}},[_vm._v("Country")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newVisit.countryCode),expression:"newVisit.countryCode"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"id":"visit_country_code","name":"visit_country_code"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.newVisit, "countryCode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.countries),function(country,key){return _c('option',{key:key,domProps:{"value":country.code}},[_vm._v(" "+_vm._s(country.name)+" ")])}),0),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('visit_country_code')),expression:"errors.has('visit_country_code')"}],staticClass:"help is-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.first('visit_country_code'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"visit_currency_code"}},[_vm._v("Currency")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newVisit.currencyCode),expression:"newVisit.currencyCode"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"id":"visit_currency_code","name":"visit_currency_code"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.newVisit, "currencyCode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.currencies),function(currency,key){return _c('option',{key:key,domProps:{"value":currency.code}},[_vm._v(" "+_vm._s(currency.name)+" ")])}),0),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('visit_currency_code')),expression:"errors.has('visit_currency_code')"}],staticClass:"help is-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.first('visit_currency_code'))+"\n        ")])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__ = __webpack_require__(359);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e04d03c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__ = __webpack_require__(638);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e04d03c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-shell',{attrs:{"breadcrumbs":"Home , Users"}},[_c('div',{staticClass:"users__container"},[_c('div',{staticClass:"row no-gutters mt-4"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"users__data-table-container"},[_c('data-table',{attrs:{"actions":_vm.actions,"buttons":_vm.buttons,"column-configuration":_vm.columns,"filters":_vm.filters,"rows":_vm.users},on:{"activate-user":_vm.activateUser,"create-user":_vm.createUser,"deactivate-user":_vm.promptToDeactivateUser}})],1)])]),_vm._v(" "),_c('modal',{attrs:{"action":"Invite","name":"create-user","no-icon":false,"title":("Invite a user to <b>" + (_vm.currentService.serviceName) + "</b>")},on:{"cancel":_vm.cancelUserCreation,"save":function($event){return _vm.saveUser(_vm.newUser)}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"full_name"}},[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newUser.fullName),expression:"newUser.fullName"},{name:"validate",rawName:"v-validate",value:('required|min:5'),expression:"'required|min:5'"}],staticClass:"form-control",attrs:{"type":"text","name":"full_name","id":"full_name"},domProps:{"value":(_vm.newUser.fullName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newUser, "fullName", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('full_name')),expression:"errors.has('full_name')"}],staticClass:"help is-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.first('full_name'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"emailAddress"}},[_vm._v("Email address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newUser.emailAddress),expression:"newUser.emailAddress"},{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"form-control",attrs:{"type":"text","name":"emailAddress","id":"emailAddress"},domProps:{"value":(_vm.newUser.emailAddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newUser, "emailAddress", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('emailAddress')),expression:"errors.has('emailAddress')"}],staticClass:"help is-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.first('emailAddress'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"role"}},[_vm._v("Role")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newUser.roleCode),expression:"newUser.roleCode"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"id":"role","name":"role"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.newUser, "roleCode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.roles),function(role,index){return _c('option',{key:("#" + index + (role.name)),domProps:{"value":role.roleCode}},[_vm._v(_vm._s(role.roleName))])}),0),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('role')),expression:"errors.has('role')"}],staticClass:"help is-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.first('role'))+"\n        ")])])]),_vm._v(" "),_c('modal',{attrs:{"action":"Deactivate","name":"deactivate-user","no-icon":false,"title":"<b>Are you sure?</b>"},on:{"cancel":_vm.cancelUserDeactivation,"save":function($event){return _vm.deactivateUser(_vm.currentUser)}}},[_c('p',[_vm._v("\n        Deactivating "+_vm._s(_vm.currentUser.fullName)+" will disable their account and as a result they will be\n        unable to login to the checkout portal.\n      ")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 639 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_config__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    // Button utility methods
    '$btn': function $btn() {
      return {
        disable: function disable(identifier) {
          var button = document.querySelector(identifier);
          button.classList.add('ml-btn--disabled');
          button.disabled = true;
        },
        enable: function enable(identifier) {
          var button = document.querySelector(identifier);
          button.disabled = false;
          button.classList.remove('ml-btn--disabled');
        }
      };
    },
    error: function error() {
      var error = __WEBPACK_IMPORTED_MODULE_1__api_config__["a" /* default */].ERROR_MESSAGES[this.errorStatCode];
      if (error === undefined) {
        return this.errorFallbackMessage;
      }
      return error;
    }
  },
  data: function data() {
    return {
      showError: false,
      errorStatCode: 7,
      errorFallbackMessage: __WEBPACK_IMPORTED_MODULE_1__api_config__["a" /* default */].ERROR_MESSAGES[7]
    };
  },

  methods: {
    hideErrorMsg: function hideErrorMsg() {
      this.showError = false;
    },
    goTo: function goTo(path) {
      if (!this.loading) {
        this.$router.push(path);
      }
    },
    showErrorMsg: function showErrorMsg(reason) {
      this.errorStatCode = reason.STATCODE;
      this.errorFallbackMessage = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.capitalize(reason.REASON);
      this.showError = true;
    }
  }
});

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  custom: {
    confirm_password: {
      required: 'We require you to confirm your password',
      confirmed: 'You passwords do not match yet'
    },
    full_name: {
      required: 'We require your full name',
      min: 'Please provide your full name'
    },
    user_full_name: {
      required: 'We require your full name',
      min: 'Please provide your full name'
    },
    emailAddress: {
      required: 'We require an email address',
      email: 'The email provided is not a valid'
    },
    work_email: {
      required: 'We require your email address',
      email: 'The email provided is not a valid'
    },
    password: {
      required: 'Please provide a password',
      min: 'Your password should be at least 5 characters long'
    },
    business_name: {
      required: 'We require a name for your business',
      min: 'Your business name should be at least 3 characters long'
    },
    role: {
      required: 'We require you to select a role'
    },
    service_name: {
      required: 'We require you provide a name for your service',
      min: 'Your business name should be at least 3 characters long'
    },
    country_of_operation: {
      required: 'Please select you country of operation'
    },
    phone_number: {
      required: 'We require your mobile number'
    },
    visit_amount: {
      required: 'We require you to provide an amount'
    },
    user_phone_number: {
      required: 'We require your mobile number'
    }
  }
});

/***/ })
]),[369]);


// WEBPACK FOOTER //
// static/js/app.12be6e5b1d431b04609c.js